var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYearContainer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_279",
    "data-name": "Group 279",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 435.274,
    height: 662.684,
    viewBox: "0 0 435.274 662.684",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_262",
    "data-name": "Rectangle 262",
    width: 435.274,
    height: 662.684,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_246",
    "data-name": "Group 246",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_989",
    "data-name": "Path 989",
    d: "M429.01,276.61c0,117.836-95.523,213.36-213.36,213.36S2.294,394.446,2.294,276.61,97.817,63.25,215.65,63.25s213.36,95.523,213.36,213.36",
    transform: "translate(6.264 172.714)",
    fill: "#054e91"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_990",
    "data-name": "Path 990",
    d: "M426.716,213.36c0,117.836-95.523,213.36-213.36,213.36S0,331.2,0,213.36,95.523,0,213.356,0s213.36,95.523,213.36,213.36",
    fill: "#d2e8ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_991",
    "data-name": "Path 991",
    d: "M123.165,80c-.123-6.29-.019-12.58-.407-18.862-.2-3.2-.157-6.413-.224-9.621.466,0,.929,0,1.4,0,.742,1.127,2.056,1.362,3.156,1.839.828.362.9-.533.72-1.078-.466-1.44-.231-2.925-.392-4.38.052-.608.1-1.22.157-1.832.224-.007.448-.019.672-.026q.336,4.471.675,8.939c-1.451.172-2.466-1.026-3.805-1.212-.522-.075-1.183-.675-1.447.205-.19.638-.347,1.436.463,1.9.5.287,1.156.422,1.515.832.5.567,3.186.888.425,2.156-.1.045-.011.481-.011.735a1.216,1.216,0,0,1-.977.556c-.783.146-1.444.3-.418,1.145,1.22,1,2.391,2.067,3.585,3.1a2.154,2.154,0,0,1,0,.347.5.5,0,0,0-.007.347l-.742.216a2.621,2.621,0,0,0-2.735-.787c-.41.119-.459.642-.31,1a2.6,2.6,0,0,0,2.429,1.53,1.694,1.694,0,0,0,.377-.063c.586.321,1.171.645,1.757.966a.9.9,0,0,0,.049.284c0,.187-.011.369-.015.556-1.16-.354-2.324-.7-3.481-1.056-.41-.127-.88-.455-1.134.168-.183.455.257.63.53.9,1.19,1.142,2.97.772,4.242,1.683a2.324,2.324,0,0,0,.235-.272l-.034.049c.41-.131.9-.026,1.224-.422l-.041.034c1.447-.246,3.085.183,4.227-1.175a2.026,2.026,0,0,0,.086-2.526,19.517,19.517,0,0,1-.261-5.189c-.022-3.1.007-3.1,2.992-4v.776a2.558,2.558,0,0,0-1.944,3.223,25.054,25.054,0,0,1,.1,3.895c0,.448-.034.9-.075,1.347-.086.907.653,1.112,1.074.757.791-.668.142-1.567-.063-2.347-.869-3.3-.026-5.118,3.1-6.473.739-.321,1.309-.634.854-1.563l.936-.06c1.619,1.589,1.175,3.574,1.052,5.5-.463,0-.929,0-1.4-.007-.037-.519-.075-1.037-.116-1.552.347-.254.481-.586.2-.933-.19-.228-.429-.116-.589.112a3.179,3.179,0,0,0-2.19,4.055,4.589,4.589,0,0,1-.19,3.9c3.119-.246,5.641-1.776,8.428-2.246,1.724-.291,2.175-1.086,1.7-2.638.347-.422.679-.373.776.146.123.672.459,1.045,1.466,1.436-1.1-2.593-.541-4.977-.72-7.32a6.631,6.631,0,0,0,1.634-2.347c.582-.011,1.16-.026,1.738-.034a.86.86,0,0,1,.921.813c.1.608-.313.869-.813.806-1.94-.239-2.052,1.164-2.223,2.458a19.537,19.537,0,0,0,.25,3.671c.067,1.321.563,1.593,1.694,1.175,4.436-1.645,9.077-2.649,13.483-4.406a49.648,49.648,0,0,1,7.458-2.735,2.393,2.393,0,0,0,1.962-3.16,42.205,42.205,0,0,1-.332-7.771c1.365-.022.817,1.033.88,1.664.287,2.813-.172,5.734,1.25,8.375-1.324,1.634-3.417,1.526-5.137,2.265-.959.019-.783.727-.806,1.321a1.814,1.814,0,0,0-1.776-.287c-2.94,1.183-5.917,2.268-8.9,3.339-.974.351-.821.672-.239,1.324a6.434,6.434,0,0,0,7.3,2.056c.672.086,1.179-.078,1.28-.854l3.026.078c.131.007.261.011.388.015.06.306-.1.377-.373.492-3.649,1.556-7.633,1.88-11.36,3.134a3.616,3.616,0,0,1-2.25.243V67.95l3.615-1.511a37.193,37.193,0,0,1-3.022-2.529,2.142,2.142,0,0,0-2.574-.552c-3.738,1.276-7.506,2.455-11.259,3.671a43.18,43.18,0,0,0-6.924,1.817c.515,1.115,2.268,1.022,1.8,2.563-1.086.451-1.332-.679-1.936-1.082-1.839-1.224-3.708-1-4.689.694l-1.38.09a3.566,3.566,0,0,0-2.089-.1c-.586.25-1.343.5-1.466,1.123-.153.783.7.951,1.242,1.257,1.332.75,2.943.731,4.249,1.653a1.41,1.41,0,0,0,2.033-.5c.466-.153.936-.3,1.406-.455,2.85-.53,3.223-.91,2.649-2.667.44-.806.836-.149,1.194.071,2,1.22,5.092.049,5.51-2.1a5.549,5.549,0,0,0,4.6-.265c.108.873.742,1.157,1.485,1.324-4.943,1.959-10.226,2.865-15.135,4.943-2.6,1.093-2.6,1.011-2.13,3.7a20.21,20.21,0,0,1,.145,2.522q.353,7.191.7,14.374c-.295,0-.589,0-.884-.007-.951-5.29-.4-10.685-1.138-16-.231-1.656-.589-2.791-2.2-3.328-.216-.187-.433-.369-.653-.552a4.285,4.285,0,0,0-3.947-2.216c-.09-.3-.082-.724-.28-.873-.757-.556-1.85-.675-1.608-2.16.075-.451-1.283-.91-2-.783s-.451.992-.284,1.474c.209.6-.011,1.332.578,1.794l.459.022c.63,1.567,2.037,1.287,3.287,1.384l2.115,1.533c-1.089,1.287-2.171,2.38-3.917.821-.545-.481-1.1-.056-1.336.6s.1,1.418.627,1.406c2.347-.06,3.981,1.746,6.118,2.164a.424.424,0,0,1,.093.593c-1.858-.522-3.719-1.033-5.57-1.578-.623-.183-1.421-.582-1.638.28-.183.724.66.828,1.242,1.127.824.425,1.865-.56,2.335.28.921,1.649,2.544,1.556,4,1.947.754.545.354,1.272.306,1.947-.817-.041-2.362.448-2.168-.608.228-1.235-.556-1.033-.925-1.127a5.662,5.662,0,0,1-2.794-1.186.863.863,0,0,0-1.235.011,1.485,1.485,0,0,0-.205.9c-.007.578.388.761.9.787a12.51,12.51,0,0,1,1.354.112c.127.022.216.25.306.362-.332.6-1.007.134-1.4.578,1.306.619,2.585,1.227,3.872,1.824.3.138.664.25.679.6.022.492-.463.657-.8.69-.959.1-1.932.075-2.9.119-.489.022-1.16-.142-1.168.638-.007.638.589.545,1.018.627a10.953,10.953,0,0,1,5.242,2.925c-1.6-.436-3.238-.589-4.678-1.518a3.473,3.473,0,0,0-2.955-.444c-.616.22-.3,1.168-.332,1.8-.063,1.235.959,1.332,1.724,1.406,2.6.257,4.7,1.671,6.909,2.82l.067.384c-.451-.019-.9-.056-1.35-.052-.769,0-2.056-.474-1.149,1.171-1.3.8.41,1.988-.4,2.9-.97,1.093-.537,1.985.552,2.7.735.381.619,1.873,1.94,1.481,1.656.34,3.335.739,4.966-.03a33.755,33.755,0,0,1,10.606-3.193c5.689-.705,11.36-1.041,17.057-1.306,1.011-.049,1.332-.373,1.392-1.358a49.556,49.556,0,0,0-.172-6.226c-.194-2.973-1.261-5.835-.668-8.931.593-3.078.843-6.3,2.675-8.879a16.529,16.529,0,0,1,9.875-6.189,9.394,9.394,0,0,1,8.543,2.175,6.1,6.1,0,0,0,.142-3.022q-.839-10.2-1.668-20.4l.724-.022c1.186.9,1.992-.9,3.115-.444l.034.873a20.731,20.731,0,0,1-1.854,1.183c-1.082.548-1.272,1.239-.53,2.19l.485.519c-.664,1.787-.19,3.6-.067,5.395.463,6.73,1.022,13.453,1.466,20.187.037.582.839,1.761-.724,1.828a14.22,14.22,0,0,1-.4-3.458c-.246-2.25-2.015-4.522-3.884-4.988-.836-1.332-2.123-1.313-3.455-1.153-1.063.478-3-.948-3.179,1.462a2.179,2.179,0,0,0-2.466.977,2.691,2.691,0,0,0-2.6,1.186c-2.07.977-3.533,3.436-3.033,5.1,0,.306-.026.619.291.813-.078.451.049.754.563.776,1.683,1.511,2.212,1.421,2.686-.459.116-.119.228-.235.339-.354,1.268-.291,1.421-1.3,1.511-2.35.246-.381.492-.757.735-1.134.026-.25.048-.5.071-.746.634-.541,1.283-1.074,1.134-2.048l1.1-.813c1.153.16,1.88-.783,2.854-1.1q1.018.252,2.037.5c.657.824.157,1-.575.989a5.35,5.35,0,0,0-2.608.56c-2.272,1.145-2.958,3.317-3.992,5.38s-.552,4.1-.44,6.115c.153,2.8-.444,5.533-.392,8.3.026,1.212.347,2.417-1.011,3.257a11.025,11.025,0,0,1,4.913,0,28.076,28.076,0,0,0,8.9-.317c1.97-.317,2.2-1.2,1.985-2.865a136.046,136.046,0,0,1-1.1-13.774c1.224-.369.873.653.914,1.142.317,3.5.567,7,.847,10.494.347,4.313.571,4.5,4.805,3.91.231-.034.444-.2.679-.235,2.94-.492,5.812-.925,8.812.108a9.893,9.893,0,0,0,8.293-.548,9.078,9.078,0,0,1,7.353-.821,8.489,8.489,0,0,0,5,.2.645.645,0,0,0,.828-.119l2.309-.145c.772.366,1.582-.041,2.361.1.34.5.589.366.8-.1,2.19-.627,4.548-.485,6.667-1.44a13.2,13.2,0,0,0,3.839-.731c.914-.011,1.832-.019,2.746-.03a.941.941,0,0,1,0,1.1c-.287.138-.6.425-.866.388-3.94-.578-7.543,1.093-11.3,1.7-2.186.354-4.432,0-6.57.7a17.29,17.29,0,0,1-7.514-.567c-2.223-.69-4.186.317-5.939,1.28-2.861,1.571-5.719.929-8.506.384a16,16,0,0,0-5.872-.41c-4.35.716-8.748,1.138-13.072,2.026-2.679.552-5.32-.1-7.95-.41a4.322,4.322,0,0,0-4.522,1.951c-1.324,2.011-3.182,2.6-5.488,2.682-6.085.216-12.151.418-18.235,1.168a37.148,37.148,0,0,0-11.1,3.343c-1.712.783-3.671-.03-5.451.94a15.371,15.371,0,0,1-6.159,1.4,3.7,3.7,0,0,0-2.541,1.668,3.85,3.85,0,0,1-3.417,1.455c-2.858-.019-5.715.157-8.573.16-2.694,0-4.066,2.376-6.223,3.35-1.138.511-2.2,1.295-3.458,1.078-3.82-.672-7.017.563-9.916,2.921-2.235.466-4.738-.388-6.719,1.265a9.761,9.761,0,0,1-7.29,2.481c-2.492-.295-4.775.056-6.644,1.951-.8.813-1.929.567-2.936.765-4.969.97-10.076,1.253-14.751,3.66-2.556,1.313-5.514,1.847-8.286,2.746-.276.09-.552.131-.616-.179a.835.835,0,0,1,.235-.668,7.4,7.4,0,0,1,2.832-1.224c2.5-.645,5.13-.929,7.256-2.623a2.523,2.523,0,0,1,1.231-.56c4.2-.425,8.11-2.335,12.382-2.376a4.149,4.149,0,0,0,2.72-.929,8.168,8.168,0,0,1,6.555-1.843,8.178,8.178,0,0,0,6.8-2.153,5.291,5.291,0,0,1,4.167-1.343,6.989,6.989,0,0,0,5.066-1.571,7.946,7.946,0,0,1,6.241-1.671c3.078.515,5.462-.81,7.6-2.694a5.79,5.79,0,0,1,4.025-1.634c2.537,0,5.07-.09,7.607-.138,3.458-.071,4.734-1.317,4.689-4.671-.063-4.943-.81-9.853-.672-14.807.015-.533-.034-1.048-.6-1.324.011-.22.019-.44.03-.66a1.27,1.27,0,0,0,.634-1.313c-.1-2.85-.2-5.7-.295-8.554m49.275,14.781a1.113,1.113,0,0,0,.739-1.2c-.157-1.612-.157-3.242-.362-4.846-.44-3.414-.56-3.477-3.8-3.66-.567-.03-1.1.067-1.268.642-.175.619.381.754.824.821.526.078.851.28.821.854-.619.138-1.489-.4-1.772.649-.683,2.5,2.145,1.854,2.992,3.227-.731,0-1.3-.026-1.862.011-.354.026-.72.429-.418.612,1.5.914-.063,1.668-.194,2.779,1.571-.619,2.869.425,4.3.116m-45.954,3.925c.832-.963,1.418-1.839.44-2.805-.533-.526-1.608-.649-1.9-.041-.664,1.384.91,1.821,1.459,2.846m43.391-16.083c-.556.052-1.44-.022-1.194.6.392.985,1.533,1.257,2.529,1.5.593.146.828-.239.791-.772-.1-1.474-1.406-.974-2.126-1.332m-42.2,21.41c-.422-.8-1.175-1.384-1.724-.824a2.776,2.776,0,0,0-.448,3.16,3.666,3.666,0,0,1,2.171-2.335M124.9,89.5c.672-.746,1.074-1.638,2.123-1.932-.589-.8-1.317-1.283-1.918-.81-.854.668-.369,1.757-.205,2.742m5.559,16.333c0-.332-.246-.425-.492-.414a.726.726,0,0,0-.769.649c-.041.328.239.422.481.41a.745.745,0,0,0,.78-.645m-4.391,1.153c-.157.134-.269.231-.384.332.112.116.209.3.343.328.112.022.261-.131.4-.209-.1-.131-.209-.265-.354-.451M128.41,88.3c.1.045.235.153.313.123s.1-.2.145-.3c-.1-.048-.235-.153-.31-.123s-.1.194-.149.3",
    transform: "translate(121.943 124.149)",
    fill: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_992",
    "data-name": "Path 992",
    d: "M83.828,78.64c.951-.451,1.858-1.649,2.94-.94.884.578.153,1.8.19,2.727a34.831,34.831,0,0,1-.261,3.895c1.347-.284,2.511-1.112,3.921-.127-2.115.552-4.018,1.671-6.126,2.171a3.13,3.13,0,0,0-2.037,1.242c-1.7.041-3.074,1.037-4.589,1.608-1.25.112-.772,1.03-.8,1.709a5.369,5.369,0,0,0-.384,1.283c-.347,10.4-1.168,20.8-.765,31.226.037,1-.354,2.007.235,3.026.34.593-.418.679-.817.739-2.1.328-3.391,1.91-5.036,3-4.38,2.921-9.073,5.38-13.7,7.913a8.052,8.052,0,0,1-3.033.627c-1.959.179-3.634.709-4.805,2.485a4.746,4.746,0,0,1-2.947,1.791c-4.208,1.018-8.435,1.966-12.654,2.936-1.052-.257.034-1.343-.675-1.738-.645-6.081.265-12.069,1.3-18.019a7.191,7.191,0,0,1,4.633-5.189c2.283-.981,3.876.06,3.641,2.563-.541,5.779-.22,11.561-.485,17.336-.034.75-.563,1.981.839,1.858,1.03-.09,2.578.19,2.541-1.835-.09-4.809,1.541-9.457,1.44-14.281-.007-.451-.067-1.224.713-1.093.593.1.354.727.328,1.16q-.269,4.661-.537,9.319c-.515.6-.526,1.138.19,1.593-.041.642-.093,1.287-.112,1.929-.007.31-.09.69.28.854s.623-.1.783-.366c1.045-1.738,2.794-1.891,4.548-2.1.873-.1,1.839.011,2.522-.761.306-.011.616-.011.8-.321,1.914.16,2.783-.41,2.656-1.589-.451-4.152-.921-8.312-.175-12.487,1.018.272.556,1.112.668,1.731s-.362,1.447.6,1.787c-.026,2.365,1.138,4.723.041,7.107a.853.853,0,0,0,.231,1.052c.3.209.608-.037.869-.228,1.571-1.149,4.3-1.41,3.417-4.451a1.072,1.072,0,0,0,1.078-1.078,35.1,35.1,0,0,1,3.41-2.153c1.056-.519,1.145-1.067.492-1.918l-.8-.754c1.324-1.138.977-3.94-.724-5.07a3.049,3.049,0,0,1,.586-.436c.642-.265,1.015-.761.642-1.354-.485-.761-1-.03-1.47.187a4.579,4.579,0,0,0-.966.642c-.6.5-1.306,1.011.209,1.209.686.09.612.511.19.929s-1.235.492-1.254,1.38c.9.287,1.642-.783,2.533-.295-.045.157-.093.313-.142.474q-1.393.974-2.787,1.951c-.9-.138-.72-.795-.541-1.321a6.284,6.284,0,0,0,.228-2.846,2.973,2.973,0,0,1,1.205-2.958c2.917-1.007,2.929-1.007,2.694-3.831-.041-.474.28-1.153-.313-1.373a1.656,1.656,0,0,0-1.7.589c-.276.276-.545.556-.821.832-.713.22-1.194.653-.586,1.328.339.377.649-.015.675-.474.392.015.783.03,1.175.041l.063.795c-.478.455-1.168.7-1.414,1.388l-1.574-.381c-.19-.589.257-1.257-.235-1.806,0-.731.627-1.149.88-1.753a6.287,6.287,0,0,1,2.828-1.5c.63-.231,1.242-.414,1.171-1.283-.339-4.022.127-8.04.067-12.061-.063-3.958-.123-3.958-3.749-5.312a1.027,1.027,0,0,1,.638-.948c.556.153,1.123.287,1.675.463.8.254.944-.037.966-.839.168-6.279-.552-12.621,1.369-18.773.175-.556.093-.966-.739-.88-.873.086-1.563-.09-2.209.985-.761,1.257-2.746.7-3.88,1.7a.449.449,0,0,0-.526.313.207.207,0,0,1-.179.153l-.921-.269c.668-1.231,2.059-1.485,3.074-2.246.668-.5,1.776-.414,1.906-1.586a.546.546,0,0,1,.44-.272c2.518.929,4.566-1.571,7.174-.888,1.2.313,1.071-1.224.589-1.9-.8-1.112-.09-1.276.686-1.571,12.095-4.555,24.193-9.11,36.061-14.24.783-.339,1.582-1.13,2.6-.533-.466.642.063,1.235.1,1.85l0,0c-1.06-.66-2.112-1.056-3.141.052-1.324.705-1.589,2.246-.515,3.011.75.228.985-.858,1.4-.754,2.843.709,3.249-1.716,4.522-3.443-1.276.866-1.66-.183-2.272-.683,1.22-1.511,3.018-1.914,4.738-2.459-.019.332-.041.668-.06,1-1.231.157-1.227,1.045-1.22,1.981.022,2.742-.4,3.3-2.973,4.305-1.026.4-2,.918-3.018,1.351-1.9.813-2.738.25-2.742-1.738,0-.481.616-1.295-.351-1.421a1.941,1.941,0,0,0-1.638.914,1.466,1.466,0,0,0-.164.556c-.261,1.108.474,2.7-.6,3.283a37.394,37.394,0,0,1-6.5,2.57c-1.171.373-.795-.828-1-1.41-.153-.433.246-1.239-.515-1.231-.7.011-.608.754-.485,1.227.519,1.97-.877,2.716-2.223,3.35a52.482,52.482,0,0,1-4.891,1.91c-1.873.668-2.369.276-2.421-1.753-.007-.366.317-.746-.108-1.19-2,.444-1.656,2.283-2.108,3.637-.888-.134-.522-2.313-2.35-1.239-.892.526-1.835.72-2.134,1.847-.336-.007-.672-.011-1.011-.015-.686.007-1.406.205-1.261,1,.127.709.824.049,1.246.187.545-.015,1,.09,1.011.776-.388.216-.78.425-1.164.649-1.533.9-2.209.589-2.4-1.112-.078-.668.164-1.66-.921-1.533-.944.112-.466,1.045-.522,1.615-.1,1.022-.09,2.056-.123,3.089-1.276.328-2.171-.634-3.253-.955a1.076,1.076,0,0,0-1.239.224.759.759,0,0,0-.007.5,8.7,8.7,0,0,1,4.029,1.7c.011.011.377-.459.578-.705.709.537.4,1.321.4,1.981.048,4.227.071,8.457.037,12.684-.011,1.69.433,2.276,2.25,1.683,2.973-.97,3-.862,3.346-4.037.175-1.615.414-3.22.627-4.827.3-.011.6-.019.9-.03m-11.517,41c.078.455.463.425.783.5a2.527,2.527,0,0,0,1.906.407,6.466,6.466,0,0,1-.343-2.9c.037-1.045-.425-1.571-1.477-1.563a8.2,8.2,0,0,0-1.119-.772c-.533-.246-1.239-.9-1.619.063a1.311,1.311,0,0,0,.769,1.914c.489.168.989.306,1.485.455.19.44,1.142.22.944.724-.265.675-.851-.183-1.309-.026-.6-.03-1.134-.716-1.772-.209a.666.666,0,0,0-.086.873c.425.757,1.112.7,1.821.522Zm.862-23.074c-.422-.556-.81-1.19-1.627-1.138a.489.489,0,0,0-.4.716c.306.739.492,1.63,1.563,1.671.131,0,.257,0,.384,0a1.072,1.072,0,0,0,1.388.94.714.714,0,0,0,.507-.742c.019-.627-.436-.888-.921-1.1-.291-.127-.6-.228-.9-.34m-34.3,43.119c.149-.474.478-1.2-.119-1.324-.746-.153-.619.735-.791,1.227-1.425.134-2.026-.28-1.168-1.712a9.162,9.162,0,0,0,.463-1.052c.944-.336,2.421-.47,2.085-1.78-.321-1.242-1.556.242-2.332-.209.209-.384.422-.768.63-1.149.552-.146,1.1-.28,1.653-.44.9-.261.556-1.022.608-1.6.045-.519-.007-1.112-.578-1.291-.657-.205-.851.362-1.033.854-.127.336-.362.541-.724.384-.526-.228-.321-.772-.451-1.171,0-1.425,1.16-2.641.746-4.145.026-.261.056-.526.082-.791.377-.03,1.2-.742.948.306-.265,1.1.362,2.119-.347,3.4,1.384-.974,1.515-1.809,1.4-4.115-.067-1.313-1.123-1.2-1.813-1.641.433-.556,1.384-.492,1.731-1.433a2.948,2.948,0,0,0-2.638,1.436c.291,1.261-1.406,1.78-1.134,3.037a7.632,7.632,0,0,0-1.418,4.361c-.056,1.753-.175,3.5-.242,5.257-.112,2.791-1.052,5.521-.187,8.543a20.611,20.611,0,0,0,5.186-1.317c.123-.041.123-.444.179-.683.839-1.253-.571-1.944-.735-2.951M94.841,61.546c1.19-.5.791-1.593.552-2.261-.358-1.015-1.03-.959-1.373.164a12.021,12.021,0,0,0-2.988.769,2.519,2.519,0,0,0-1.787,2.843c.138.41.418.41.757.295,1.63-.556,3.477-.537,4.839-1.809m4.734-3.44c-.052.769.183,1.295,1.328.787,1.168-.515,2.38-.925,3.581-1.343a1.115,1.115,0,0,0,.862-1.134,1.172,1.172,0,0,0-1.265-.959,30.9,30.9,0,0,0-4.01,1.276c-.481.175-.533.683-.5,1.373M70.2,127.407a10.4,10.4,0,0,1-2.7,1.966,22.124,22.124,0,0,0-2.112.985.877.877,0,0,0-.448,1.156.844.844,0,0,0,.552.455c1.377.22,4.611-2.854,4.708-4.563m4.425-17.758a5.941,5.941,0,0,0-2.332-2.839c-.541-.384-1.2-.869-1.7-.22a1.3,1.3,0,0,0,.5,2,6,6,0,0,0,3.54,1.063m-.757-6.876c.257-1.768-1.078-1.921-2.149-2.246-.754-.228-1.138.284-1.011.966.261,1.4,1.548,1.854,2.608,2.283.742.3.418-.683.552-1M69.611,89.963c-.1,2.365,1.276,3.179,2.4,4.171.381.34.81.81,1.3.257.418-.47.2-.974-.276-1.321a13.456,13.456,0,0,1-3.417-3.108m1.929,19.828c-.519.06-1.138-.078-1.153.716-.011.653,1.873,2.067,2.66,2.007a.793.793,0,0,0,.813-.9c-.16-1.362-1.112-1.791-2.32-1.821m.918,11.371c-.5.1-1.436-.116-1.377.552.052.582.839,1.1,1.3,1.642.466-.492,1.212-.929,1.336-1.5.19-.884-.727-.582-1.261-.7m.951-7.1a3.408,3.408,0,0,0-2.268-1.489c-.4-.093-1.194-.06-1.015.474.332.985,1.459,1.153,2.328,1.515a.641.641,0,0,0,.955-.5M71.323,104.3c.444.9.88,1.8,1.959,1.914a.521.521,0,0,0,.478-.7,2.655,2.655,0,0,0-2.436-1.216m2.261-4.4c-.742-.612-1.138-1.742-2.354-1.649-.112.007-.321.332-.287.381A3.094,3.094,0,0,0,73.584,99.9M70.778,88.142c-.116.086-.254.138-.265.213s.075.19.119.291c.112-.09.224-.179.336-.265l-.19-.239",
    transform: "translate(88.11 130.583)",
    fill: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_993",
    "data-name": "Path 993",
    d: "M41.646,122.059a1.533,1.533,0,0,0,.772-1.231,174.892,174.892,0,0,0,1.436-20.817c.183-5.4.183-10.908,1.518-16.247.164-.645.776-1.735-.328-1.947-.907-.175-1.052.866-1.227,1.664-.325,1.5-.936,2.735-2.873,2.388-.873-.157-1.227.414-1.489,1.183a4.477,4.477,0,0,1-3.846,3.07c-1.149.209-1.295,1.69-1.765,2.679l.034-.037c-.761-.384-1.7,1.142-2.164-.321-2.358,2.817-3.484,6.443-7.129,7.842a1.985,1.985,0,0,0-1.291,2.32,30.849,30.849,0,0,1-.216,6.208,27.276,27.276,0,0,0-.407,7.45,22.415,22.415,0,0,1-1.16,4.7l-.892-.683a6,6,0,0,0,.9-3.533c-.037-4.947.925-9.834.746-14.781a2.745,2.745,0,0,1,1.944-2.787c2.306-1.059,4.119-2.63,4.507-5.406.209-1.5,1.492-2.283,2.656-2.936A48.285,48.285,0,0,0,41.06,83.7c.8-.754,1.489-1.623,2.3-2.358.694-.63,1.384-1.477,2.507-.6.485.388,1.033.049,1.429-.242,1.608-1.2,4.037-2.141,4.6-3.731,1.686-4.734,6.271-4.32,9.558-6.032,2.973-1.548,6.018-3,9-4.563.22-.119.563-.343.556-.5-.134-2.436,2.265-4.167,1.828-6.674-.2-1.179-.082-2.287,1.239-2.716,1.257-.4,2.35-.347,3.108,1.1.769,1.474,1.944.045,2.929.16.2.19.4.381.6.567a5.865,5.865,0,0,1-2.667,1.108,1.47,1.47,0,0,1-1.925-.832c-.257-.589-.563-1.291-1.41-.97-.746.28-.8,1.015-.69,1.656a3.862,3.862,0,0,1-1.015,3.742,2.535,2.535,0,0,0-.459,1.656,3.493,3.493,0,0,1-2.015,3.063,66.953,66.953,0,0,1-13.658,6.122c-2.723.97-3.637,3.007-4.425,5.107a5.354,5.354,0,0,1-4.182,3.41c-1.272.287-1.574.776-1.772,1.761a70.574,70.574,0,0,0-1.257,9.651c-.362,6.185.433,12.419-.761,18.575a.656.656,0,0,0,.481.824c.664-2.309,2.787-1.85,4.451-2.242a1.042,1.042,0,0,1,1.317,1.071,12.364,12.364,0,0,1,.254,2.5,77.438,77.438,0,0,0-.381,11.274c-.769.034-1.433-.269-1.071-1.082.541-1.209.011-2.067-.436-3.063-1.351.9-.3,2.466-1.212,3.384-.571-1.265-1.906-2.492-.209-3.88a4.735,4.735,0,0,1,.892-.672c.66-.284,1.414-.5,1.25-1.418-.22-1.239-1.157-.194-1.69-.463-.157-.078-.257-.272-.384-.414l.213-.571a9.764,9.764,0,0,0,1.227-.437,1.18,1.18,0,0,0,.586-1.6c-.269-.724-.81-.616-1.4-.4a3.363,3.363,0,0,1-.936.071,2.144,2.144,0,0,1,.936-1.421c.47-.272,1.033-.638.664-1.175-.444-.645-1.052-.138-1.533.149-2.533,1.526-3.082,4.051-3.335,6.719-.63,1.153.071,2.488-.511,3.667-.149.295.127.589.474.7q.168,2.082.336,4.16a.919.919,0,0,0,.72.873c-.463.418-.8,1.242-1.582.828-.668-.351-.705-1.164-.783-1.847-.187-1.627.34-3.361-.761-4.842l-.4-.806",
    transform: "translate(56.306 153.103)",
    fill: "#2d2d2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_994",
    "data-name": "Path 994",
    d: "M95.9,68.04c.619-.339.045-1.429.989-1.608a1.567,1.567,0,0,0-.049-.862c-.414-.821-1.1-.287-1.69-.276l-.1-.839c1.466-.41,1.753-1.339,1.53-2.794-.4-2.552-.66-5.13-.832-7.708-.388-5.891-2.071-11.543-3.037-17.325a.728.728,0,0,0-.746-.694c-.09-.339-.179-.679-.272-1.018,1.171-.91,1.78-.522,2.746.6a87.374,87.374,0,0,0,6.417,6.238,2.672,2.672,0,0,1,.877,2.2,118.154,118.154,0,0,0,2.708,27.961,47.9,47.9,0,0,0,1.675,4.857c-.06.31-.123.616-.183.925-.224-.06-.448-.116-.672-.172a.977.977,0,0,0-.795-.907c-.959-1.884-2.791-2.022-4.533-2.466-.164.787.511.821.664,1.212-.034.231-.063.459-.1.69-1.559.582.168.8.134,1.22l-.093.936c-.451.489-.381.865.224,1.16.321.157.918.149.563.795-1.157.31-.866.854-.224,1.436.552.5,1.433.545,1.821,1.287-.563.7-1.806-1.149-2.108.567a5.464,5.464,0,0,0,2.962,6.018l-.951.459c-1.283-.336-1.018.627-.959,1.246.142,1.462.537,2.914.537,4.372a2.808,2.808,0,0,0,1.668,2.9c-.265.265-.53.533-.795.8-1.059.914-.16,2.044-.336,3.055l-.146,1.235c-.377.007-.754.011-1.13.019a12.84,12.84,0,0,1-.31-1.7A325.54,325.54,0,0,0,97.84,69.238c-.2-1.362-.575-1.959-1.944-1.2m3.518-22.309c-.082-.146-.153-.336-.347-.1.086.063.172.131.257.194l.231.131-.142-.22M98.1,45.108c.123.131.25.3.41.063.015-.026-.142-.168-.216-.257a2.4,2.4,0,0,0-.455-.332c-.455-.19-.757-.742-1.332-.6-.1.026-.239.317-.209.448.2.806.951.4,1.429.608a1.7,1.7,0,0,0,.373.075m3.246,19.623a.81.81,0,0,0-.138-.839,3.808,3.808,0,0,0-.377-3.014l.034-.522a2.976,2.976,0,0,0-.179-1.623l-.179-.474a.726.726,0,0,0,.082-1.142q-.2-1.494-.4-3c.41-.5-.235-.69-.317-1.048a1.365,1.365,0,0,0,.138-.358c.127-1.067.507-2.22-.884-2.805-.754-.321-1.608-1.324-2.209-.862-.951.731.265,1.865.078,2.854.06.242.119.489.179.735a1.841,1.841,0,0,0,.228,1.772.882.882,0,0,1-.022.22c-.694.463-.213.91.015,1.362,0,.146,0,.287,0,.433-.642.47-.414.977-.06,1.489-.082.291-.16.578-.239.869.131.183.261.366.392.552l.045,1.41c-.1.642.6.627.817,1.007-.563.388-.724.791-.052,1.231a.574.574,0,0,0-.052.306c-.022.4-.041.8-.063,1.2a.889.889,0,0,0,.556,1.018,2.09,2.09,0,0,0-.071,1.459c.239.216.481.433.724.649-.011.19-.019.381-.03.571-.664-.045-.724.414-.705.892.134,3.2,1.179,4.365,4.592,5.066a2.671,2.671,0,0,0-.608-1.959c.2-.515.328-1.018-.194-1.433-.1-.291-.2-.582-.3-.873-.015-.481-.026-.966-.041-1.447a1.227,1.227,0,0,1-.049-.328,1.427,1.427,0,0,0-.123-1.235c-.1-.354-.205-.705-.31-1.06.071-.4.142-.8-.28-1.074M97.079,40.314a2.162,2.162,0,0,0-1.791-1.75.66.66,0,0,0-.2.459c.257.836.959,1.078,1.988,1.291m2.029,6.861a2.831,2.831,0,0,0-2.6-1.149,3.423,3.423,0,0,0,2.6,1.149",
    transform: "translate(250.368 93.96)",
    fill: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_995",
    "data-name": "Path 995",
    d: "M85.924,55.7c-.466,0-.929,0-1.4,0,.179-1.38.407-2.779-1.481-3.637,1.72-.067,1.85-1.018,1.757-2.19-.071-.9.082-1.813-.015-2.7-.071-.638.463-1.884-.847-1.675-.951.153-2.3.127-2.145,2.007.093,1.119,1.343,2.656-.5,3.578a11.292,11.292,0,0,1-.328-1.1c-.1-.56-.09-1.392-.66-1.448a1.693,1.693,0,0,0-1.451,1.089c-.228.5-.843.985-.485,1.548.295.463.951.157,1.447.209.254.03.511.03.765.041-1.291,1.612-3.283,1.921-5.04,2.619a26.316,26.316,0,0,0-3.268,1.142c-1.13.627-1.421.142-1.455-1.007-.03-.955.72-2.544-.948-2.641-1.806-.1-1.168,1.567-1.351,2.619-.134.772.246,1.9-1.115,2.026-.228-.593.675-1.291-.149-1.854-.731,1.194-.731,1.194.127,1.88-.254.992-1.171,1.108-1.918,1.373a20.183,20.183,0,0,0-3.872,1.7c-1.448.888-2.037.526-2.365-1.108-.213-1.048.235-2.223-.6-3.149-.015-.381-.034-.761-.049-1.142C64.5,51.579,70.412,49.274,76.34,47c1.932-.742,3.906-1.347,5.794-2.235,3.115-1.466,4.134-1.1,5.954,1.918a1.493,1.493,0,0,0,1.959.713c1.246-.358,2.485-.739,3.723-1.108a1.662,1.662,0,0,1-.381,1.369c-.713.157-1.309.686-2.126.556-.918-.146-.918.612-1.03,1.22l-.9-.3a2.057,2.057,0,0,0-1.47.291c-.716.53-1.783.612-1.951,1.821-.2,1.447.985,1.858,1.955,2.712-1.858-.478-2.723-.131-1.944,1.746M73.11,52.661c-.138-.392.145-1.149-.649-1.1-.709.041-.6.724-.616,1.209s-.1,1.19.638,1.145c.634-.041.66-.675.627-1.254m-8.241,3.913c.492-.813.94-1.421.388-2.19a.474.474,0,0,0-.806.03c-.612.787-.149,1.369.418,2.16",
    transform: "translate(159.948 119.967)",
    fill: "#2d2d2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_996",
    "data-name": "Path 996",
    d: "M43.967,80.063l.888.683q-.285,2.222-.575,4.439c-.06.474-.216.9-.765.989a3.551,3.551,0,0,0-2.761,2.011,16.548,16.548,0,0,1,.123-8.032c.739-2.7-.448-5.085-.69-7.614-.052-.56-.638-.56-1.108-.5a1.033,1.033,0,0,0-.921,1.086c-.071,1.1-.1,2.209-.116,3.313a10.806,10.806,0,0,1-.362,3.473,5.748,5.748,0,0,0,.213,5.033c.287.7-.183,1.324-.209,1.992a5.15,5.15,0,0,0-.511,3.5,12.654,12.654,0,0,1-.589,4.163c-.131.377-.742.653-.2,1.074.526.407.966.067,1.242-.41,1.13-1.959,3.111-2.716,5.018-3.574a2.093,2.093,0,0,1,.709-.056c.257.269.381.642-.007.783-1.929.705-3.279,2.2-4.865,3.387-2.8,2.1-5.76,3.984-8.651,5.962-1.41.052-1.145-.884-.989-1.716.112-.6.6-1.321-.228-1.683a1.361,1.361,0,0,0-1.787.742c-.325.705-.813.72-1.406.686-.231-.422.172-1.268-.53-1.28s-.507.783-.537,1.254q-.123,1.847-.134,3.7c-.007,1.015-.257,1.877-1.44,1.858-1.324-.019-.571-1.16-.78-1.768-.254-.746.224-1.72-1.414-1.563-1.574.153-1.641.832-1.552,1.985a12.969,12.969,0,0,1-.086,4.827c-.131.123-.265.246-.4.366-1.466-.384-.664-1.571-.836-2.406-.119-.586.321-1.582-.522-1.63-1.041-.056-.955.948-.94,1.746.034,1.675.019,3.35.026,5.025-.149.123-.3.242-.448.366-1.373-.138-2.238.877-3.294,1.455-.157-.291-.31-.578-.466-.866,2.6-1.4,3.3-3.533,2.615-6.335a1.683,1.683,0,0,1,1.544-2.343c.362.451.6.287.78-.157.545-1.918,1.425-3.425,3.757-3.447.66-.007.94-.7,1.026-1.272.261-1.683,1.522-2.089,2.843-2,2.835.205,5.484-.88,8.271-.977a2.2,2.2,0,0,0,2.071-1.511,27.878,27.878,0,0,0,1.668-10.636c-.149-3.85.444-7.625.492-11.446A1.878,1.878,0,0,1,38.6,70.9a1.826,1.826,0,0,1,2.082.672c1.526,1.772,1.649,4.037,2.134,6.163.2.892.242,1.8,1.149,2.324M33.152,97.608c-1.086.015-1.85-.175-2.067.791-.03.134.134.455.213.455.813.011,1.25-.466,1.854-1.246m-9.808,3.406a.424.424,0,0,0-.295-.634.489.489,0,0,0-.44.164.437.437,0,0,0,.306.589c.127.041.31-.086.429-.119m6.6-1.567c.254-.343.448-.713.067-.977-.045-.03-.265.086-.257.112.049.291.123.578.19.865",
    transform: "translate(32.959 193.327)",
    fill: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_997",
    "data-name": "Path 997",
    d: "M77.483,66.7c-.694.571-1.53-.052-2.253.265-1.656-1.153-2.917.261-4.305.709-.955.306.653.817-.06,1.321-1.891-1.328-3.514-.082-5.208.627a.918.918,0,0,0-.963.813c-1.149.228-2.362-.183-3.484.5-.769.466-.7.746-.049,1.164-.254.09-.507.175-.757.265-.4-.067-.787-.131-1.179-.2a1.969,1.969,0,0,0-1.559-.19c-1.5.511-3.272.44-4.32,1.955-.325.119-.384.384-.377.686-1.959,1.414-1.959,1.414.022,2.417.168.381.783.616.384,1.183-.265.093-.526.19-.791.284.276-1.168-.854-1.373-1.354-1.347-1.074.049-.448,1.089-.616,1.694a3.348,3.348,0,0,1-1.455.989c-.19-.205-.381-.407-.571-.608a4.506,4.506,0,0,0,.429-1.063c.086-.694.832-1.38-.03-2.119a2.174,2.174,0,0,0-2.317-.489c-.627.216-1.574.817-1.854-.056s.9-.862,1.481-1.145a46.1,46.1,0,0,1,11.453-3.6,40.411,40.411,0,0,0,6.312-1.891c7.223-2.656,14.471-5.242,21.709-7.857q7.493-1.992,14.982-3.981c2.809-.742,5.622-1.462,8.435-2.19,0,.239,0,.478,0,.716q-2.345.867-4.7,1.738a27.381,27.381,0,0,0-7.622,2.153c-.287.123-.571.25-.854.373-2.223-.172-4.167.72-6.1,1.627l-2.589.638a23.163,23.163,0,0,0-4.26,1.4c-1.85.6-3.708,1.2-5.559,1.809-1.317.436-.921.921-.019,1.4",
    transform: "translate(122.267 149.741)",
    fill: "#2d2d2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_998",
    "data-name": "Path 998",
    d: "M27.507,97.684c3.067-3.936,6.678-7.237,11.684-8.42a64.081,64.081,0,0,1,21-1.6c2.82.272,5.477.116,8.107-1.724,3.85-2.7,8.689-2.861,13.177-3.82a21.288,21.288,0,0,0,5.779-2.153c3.477-1.877,7.428-2.279,11.39-3.664a3.169,3.169,0,0,1-2.671,1.985A43.807,43.807,0,0,0,86.034,82.1c-2.268,1.242-5.029,1.13-7.558,1.686-3.414.75-6.831,1.295-9.864,3.343a11.55,11.55,0,0,1-6.57,1.5c-3.637-.011-7.293-.228-10.912.037a62.261,62.261,0,0,0-13.714,2.246c-2.57.783-4.466,2.839-6.491,4.563q-1.539,1.309-3.082,2.611c-.112-.131-.224-.265-.336-.4",
    transform: "translate(75.112 208.368)",
    fill: "#4f4f4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_999",
    "data-name": "Path 999",
    d: "M68.137,55.392c7.323-2.783,14.684-5.473,21.959-8.383,4.805-1.921,9.506-4.089,14.587-5.268.929-.216,1.679-1.1,2.727-1.212.041.242.082.489.123.735-.414,1.35-1.7,1.44-2.723,1.641-1.884.373-2.7,1.071-1.522,2.932-.194.765.216,1.936-1.242,1.854-.037-.567-.131-1.414-.761-1.227-.72.216-.843,1.1-.638,1.888l-.041.049c-.772-.407-1.5-.063-2.238.119-.612.153-1.612.571-1.794.343-1.142-1.392-2.537-.679-3.846-.694-.142-.373-.339-.791-.806-.608-1.306.515-2.582,1.112-3.88,1.653-.686.284-.373.847-.422,1.317-.694.828-1.66-.5-2.47.4a3.337,3.337,0,0,1-4.268.963c-.858-.429-1.474.026-1.951.731-2.776-.067-4.1,1-4.342,3.432a5.457,5.457,0,0,1-.339,1.1c-.489-.239-.977-.481-1.466-.724-1.324.366-2.63-.686-3.958-.041ZM98.855,44.931c.664.638,1.321.422,2.011.149.388-.149.813-.25.619-.75a.485.485,0,0,0-.9-.127c-.407.783-1.295-.034-1.727.727",
    transform: "translate(186.059 110.671)",
    fill: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1000",
    "data-name": "Path 1000",
    d: "M51.668,69.3a1.983,1.983,0,0,1,1.559.187,14.831,14.831,0,0,0-.806,1.731c-.433,1.339.127,1.951,1.518,1.686a3.664,3.664,0,0,0,1.877-.9c.56-.537.589-1.119-.112-1.582-.41-.276-.866-.492-1.3-.735.254-.09.5-.179.757-.265a6.554,6.554,0,0,1,3.231,1.157c.746.653,1.6.246,2.41.007.451-.134.866-.369.843-.921-.019-.451-.414-.616-.772-.772-.754-.328-1.668-.347-2.179-1.142a.927.927,0,0,1,.963-.813c1.186,1.821,3.455,1.862,5.051,2.112,1.556.243,3.678-.69,5.279-1.813,8.968-1.787,17.747-4.32,26.573-6.663,5.264-1.4,10.282-3.567,15.605-4.76.582.761-.22.72-.533.81-9.748,2.753-19.314,6.115-29.233,8.308-9.9,2.194-19.388,5.857-29.066,8.834-1.981.612-3.969,1.186-5.958,1.776.4-.567-.213-.8-.384-1.183a4.868,4.868,0,0,0,.944.131c.78-.052,1.742-.19,1.847-1.041.108-.9-.959-.8-1.556-1.06-.407-.179-.836-.3-1.257-.448-.007-.3.052-.567.377-.686.492.157.992.287,1.47.481,2.071.828,3.123-.067,2.85-2.436",
    transform: "translate(128.261 152.414)",
    fill: "#4f4f4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1001",
    "data-name": "Path 1001",
    d: "M41.154,86.821c-4.234,1.612-8.681,2.5-12.986,3.88-.242-1.537,1.466-1.142,1.951-1.962,3.3.1,3.831-.515,3.242-3.619a7.96,7.96,0,0,1-.093-2.126c.209-2.388.623-4.764.672-7.152a6.861,6.861,0,0,1,2.708-5.35c.593-.507,1.231-1.108,2.071-.649a2.066,2.066,0,0,1,1.171,2.093c-.556,4.126.011,8.327-.623,12.4-.328,2.1.492,1.869,1.761,1.8.041.228.086.451.127.679m-4.4-12.636a.286.286,0,0,1,.116-.261c.754.545.5,1.817,1.787,2.4-.586-1.309.418-2.6-.783-3.537.108-.455.638-.985,0-1.351-.679-.384-.832.373-1.1.731a8.657,8.657,0,0,0-1.522,4.313c-.06.526-.537,1.5.392,1.578.75.067,1.108-.75,1.086-1.548-.011-.321-.037-.638-.056-.959.608-.422.466-.884.082-1.365m.063,10.338a16.879,16.879,0,0,0-.757-3.921c-.119-.455-.332-.948-.851-.9-.686.06-.414.7-.4,1.078.067,1.8.183,3.6.295,5.4.034.481-.1,1.138.683,1.134.765,0,.914-.541.9-1.2-.011-.384.06-.769.134-1.593",
    transform: "translate(76.851 190.27)",
    fill: "#2d2d2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1002",
    "data-name": "Path 1002",
    d: "M84.733,72.231c-3.593,1.093-6.883,3.026-10.6,3.783a2.719,2.719,0,0,0-1.037.507,39.429,39.429,0,0,1-19.168,7.368,48.2,48.2,0,0,0-14.747,4.074,8.424,8.424,0,0,1-1.283.448c-.325.1-.675.09-.828-.284-.172-.422.164-.485.466-.653A44.9,44.9,0,0,1,53.6,82.584a48.919,48.919,0,0,0,19.276-7.178c3.522-2.171,7.7-3.264,11.793-4.268.019.366.041.727.06,1.093",
    transform: "translate(101.099 194.253)",
    fill: "#4f4f4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1003",
    "data-name": "Path 1003",
    d: "M105.467,37.434q-2.529,1.013-5.059,2.026c-.556.22-1.063.407-1,1.216.019.228.832,1.727-.757.858-.239-.131-.761.466-.582.791.866,1.571-.533,1.761-1.339,2.179-2,1.037-4.1,1.888-6.077,2.977-.608.336-.649-.019-.817-.265a5.49,5.49,0,0,1-.511-2.059c-.127-.563.3-1.642-.925-1.444-.966.153-1.869.384-1.709,1.821.313,2.776.463,5.566.679,8.353-.209,0-.422,0-.63,0a22.8,22.8,0,0,1-.272-2.694c.019-1.418-.589-1.839-1.91-1.5-1.5.384-3.011.724-4.518,1.082,0-.261,0-.522,0-.783,1.41-.466,2.8-1,4.231-1.38,1.28-.347,1.925-.892,1.462-2.335a7.2,7.2,0,0,1-.138-2.112,1,1,0,0,1,.862-1.1c5.73-1.183,10.856-4.085,16.4-5.79.862-.265,1.716-.56,2.574-.836l.034,1M91.835,44.69a2.182,2.182,0,0,0,.787-1.444c.522-2-1.13-.739-1.28-.563-.69.791.205,1.313.492,2.007",
    transform: "translate(218.559 99.5)",
    fill: "#2d2d2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1004",
    "data-name": "Path 1004",
    d: "M102.384,53.832c1.354-.436,2.7-.888,4.063-1.3.582-.175,1.41-.709,1.712.082.358.944-.739.847-1.25,1.052-4.253,1.716-8.722,2.757-13.095,4.1-7.368,2.265-14.6,4.928-21.877,7.446q-10.084,3.2-20.172,6.391c-.675.213-1.377.339-2.067.5v-.672Q61.39,67.5,73.084,63.569a8.124,8.124,0,0,0,3.085-.951c6.066-2,11.975-4.454,18.138-6.193,2.716-.765,5.559-1.19,8.077-2.593",
    transform: "translate(135.714 142.516)",
    fill: "#2d2d2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1005",
    "data-name": "Path 1005",
    d: "M129.459,49.494c-.836,1.742-2.466,1.977-4.081,1.936a13.675,13.675,0,0,0-5.066,1.115c-3.645,1.321-7.32,2.567-10.968,3.876-.492.179-1.3.224-1.19,1.011.093.645.769.776,1.16.929-.91-1.175-2.138-1.239-3.555-.638-2.011.862-4.182.578-6.294.713-.179-.373-1.115-.485-.4-1.164.97.022,1.94.056,2.91.06.451,0,1.033.131,1.328-.093,3.813-2.966,8.7-2.977,12.96-4.757,3.981-1.668,7.928-3.537,12.225-4.391.675-.138,1.242-.429,1.634.381-.224.339-.448.683-.668,1.022m-1.69.175c.037.041.082.127.112.123a2.149,2.149,0,0,0,.295-.108c-.037-.041-.082-.127-.112-.119a1.733,1.733,0,0,0-.295.1",
    transform: "translate(269.792 130.868)",
    fill: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1006",
    "data-name": "Path 1006",
    d: "M38.056,56.949c1-.56,2-1.13,3-1.679.6-.325,1.2-.459,1.72.157.239.474.675.511,1.127.53-.086.1-.168.194-.25.291-.4.481-1.78.354-1.056,1.537.575.936,1.168.183,1.794-.067,1.492-.593,2.652-1.843,4.283-2.145a2.06,2.06,0,0,1-1.045,1.5c-.578.436-.313.713.209.918-.339.392-.612,1.007-1.03,1.138-2.134.657-2.089,2.388-2.473,4.134-.63,2.861.959,6.271-2.022,8.562-1.515.056-2.018-.672-1.921-2.164.22-3.346.377-6.7.436-10.058.052-2.914-.022-2.914-2.641-1.821l-.134-.836",
    transform: "translate(103.918 150.174)",
    fill: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1007",
    "data-name": "Path 1007",
    d: "M69.6,75.969c-4.387.589-7.786,3.443-11.7,5.111-1.6.683-2.977,1.981-4.91,1.783,1.477-1.421,3.626-1.72,5.051-3.175.224-.131.444-.265.664-.4,3.026-1.354,6.279-2.246,8.931-4.369,5.126-.6,10.241-1.351,15.381-1.761,5.234-.414,9.162-4.193,14.322-5.4C96.8,69.1,95.689,69.172,94.92,69.7c-5.652,3.858-12.046,5.242-18.758,5.6-2.194.116-4.38.44-6.566.668",
    transform: "translate(144.681 185.035)",
    fill: "#4f4f4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1008",
    "data-name": "Path 1008",
    d: "M65.494,78.181l3.88-.123c4.861-1.332,9.994-1.544,14.647-3.764a24.418,24.418,0,0,1,8.424-2.145c.022.2.041.4.063.6a43.427,43.427,0,0,0-9.659,3.525,12.17,12.17,0,0,1-4.111,1.153c-4.238.545-8.357,1.709-12.643,2.16-2.832.3-5.5,2.145-8.23,3.32-.832.358-1.634.783-2.444,1.19a2.775,2.775,0,0,1-2.932-.164,120.6,120.6,0,0,0,13.005-5.753",
    transform: "translate(143.329 197.014)",
    fill: "#4f4f4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1009",
    "data-name": "Path 1009",
    d: "M94.673,49.945c.317-.153.634-.3.948-.455q3.794,1.875,7.584,3.753c-.713-2.149-3.082-2.145-4.148-3.746l.4-.444c1.246.078,2.108,1.809,3.6.828.575.511,1.347.858,1.447,1.761-1.048.888-.071,1.406.463,1.735.578.354.75,1.985,1.955.795.168,0,.34,0,.507.007a3.271,3.271,0,0,0,2.447,2.082,1.853,1.853,0,0,0,2.041,1.1c.634-.078.847.168.541.765a1.453,1.453,0,0,0-1.388.157c-.492.366-1.19.545-1.5-.358-.511-1.589-2.126-1.526-3.264-2.179.034,1.007-2.115.47-1.4,1.966a87.275,87.275,0,0,0-8.23-3.85c-.761-.343-2.2-.638-1.675-1.66.425-.836,1.444.231,2.153.552,2.365,1.071,4.7,2.2,7.051,3.309.1-.175.2-.351.3-.526-1-1.209-2.533-1.7-3.861-2.447-1.959-1.1-4.208-1.66-5.969-3.149",
    transform: "translate(258.519 133.947)",
    fill: "#4f4f4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1010",
    "data-name": "Path 1010",
    d: "M104.541,77.663a6.291,6.291,0,0,1-6.182.914A17.024,17.024,0,0,0,95,77.666a7.208,7.208,0,0,1-5.189-3.384c-2.074-2.947-8.819-4.548-11.975-2.8-.548-1.056-.157-1.7.933-1.686,4.764.086,9.528.243,12.681,4.712a3.594,3.594,0,0,0,2.44,1.477c3.529.522,6.8,2.742,10.651,1.675",
    transform: "translate(211.874 190.594)",
    fill: "#4f4f4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1011",
    "data-name": "Path 1011",
    d: "M71.732,87.25c3.141-3.123,6.544-5.894,8.129-10.409,1.522-4.335,6.256-6.458,10.923-5.958a24.921,24.921,0,0,1-3.619,1.451,8.6,8.6,0,0,0-6.45,5.857c-1.078,3.533-3.88,5.327-6.006,7.812a20.47,20.47,0,0,1-2.843,2.343l-.134-1.1",
    transform: "translate(195.875 193.362)",
    fill: "#4f4f4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1012",
    "data-name": "Path 1012",
    d: "M22.67,79.7c.593.034,1.082.019,1.41-.686a1.356,1.356,0,0,1,1.783-.742c.832.362.339,1.078.228,1.683-.153.832-.418,1.768.989,1.716-4.107,3.54-7.89,7.42-11.722,11.252-1.089,1.086-1.761.25-2.279-.746.149-.123.3-.243.448-.366a11.888,11.888,0,0,0,6.141-5.07l.5-.492c1.246-.015,1.544-.836,1.694-1.88.224-1.563.533-3.111.806-4.667",
    transform: "translate(35.712 213.42)",
    fill: "#2d2d2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1013",
    "data-name": "Path 1013",
    d: "M90.6,64.624c.384-.011.9-.123,1.041.3.205.6-.433.8-.795.869a55.868,55.868,0,0,1-7.267,1.224c-3.686.213-6.887,1.724-10.132,3.2-.354.16-.686.366-1.037.533a.828.828,0,0,1-1.164-.384c-.306-.612.28-.713.672-.914a37.591,37.591,0,0,1,13.677-4.1c1.679-.153,3.339-.478,5.007-.724",
    transform: "translate(194.319 176.406)",
    fill: "#4f4f4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1014",
    "data-name": "Path 1014",
    d: "M61.559,72.54c5.943-1.612,11.166-4.76,17.012-6.264,1.272-.328,2.518-.235,2.518,1.955-1.2-1.2-2.354-.821-3.6-.466-3.074.877-5.857,2.421-8.774,3.652-2.209.933-4.391,1.809-7.159,1.123",
    transform: "translate(168.096 180.592)",
    fill: "#2d2d2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1015",
    "data-name": "Path 1015",
    d: "M104.7,60.757c-.254-.011-.5-.019-.757-.03l-.866.306c-.269-1.086-1.369-1.291-2.052-1.936-.451-.429-1.224-.72-1.018-1.5.47-1.757-.537-2.4-1.951-2.794l.026.026c-.358-1.485,1.19-.675,1.645-1.41-.3-.328-.63-.69-.959-1.052.2-.694.616-.854,1.239-.5,0,.571.127.97.813.586l-.026-.049c.657,1.44,2.388,1.354,3.354,2.362.451.466,1.783.623,1.265,1.317-.474.638-.851,2.089-2.339,1.571a8.28,8.28,0,0,0-1.906-.153c.727,1.727,2.384,1.981,3.518,2.869.007.131.011.257.015.388",
    transform: "translate(267.68 141.132)",
    fill: "#4f4f4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1016",
    "data-name": "Path 1016",
    d: "M55.448,49.495c.019-.336.041-.668.06-1a.294.294,0,0,1,.295-.086c1.03.914,1.828-.384,2.776-.287.1.123.2.25.3.373,1.048.91,2,.235,2.921-.235.72-.369,1.365-.933,2.257-.556l-.011-.011c.09.892.75,1.056,1.466,1.142.276,2.279-1.489,2.41-2.977,2.832-1.231-.556-4.839.4-5.454,1.477-.116.194-.034.5-.045.757-1.309.194-1.171-.716-1.168-1.526,1.2-.358.981-1.589,1.313-2.4.179-.44-.8-.22-1.25-.336-.16-.045-.321-.093-.481-.138",
    transform: "translate(151.409 129.913)",
    fill: "#4f4f4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1017",
    "data-name": "Path 1017",
    d: "M89.182,63.7c-2.4,0-4.57.052-6.741-.015a8.63,8.63,0,0,0-5.577,1.9,11.043,11.043,0,0,1-5.984,2.007c-.485.037-.963.093-1.056-.522-.108-.735.433-.851.985-.862a10.084,10.084,0,0,0,5.876-2.209,7.15,7.15,0,0,1,4.913-1.4c1.679.1,3.373-.052,5.055.019A2.563,2.563,0,0,1,89.182,63.7",
    transform: "translate(190.625 170.874)",
    fill: "#4f4f4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1018",
    "data-name": "Path 1018",
    d: "M44.224,77.678a13.668,13.668,0,0,1-9.689,3.764c-3.234-.019-5.424,2.257-7.737,4.1-.63.5-1.489.757-1.891,1.571a.5.5,0,0,1-.813.134c-.3-.321-.052-.627.187-.813,3.589-2.817,6.7-6.488,11.9-6.346a10.222,10.222,0,0,0,5.439-1.891c.436-.265.791-.69,1.362-.675.414.052.824.108,1.239.16",
    transform: "translate(65.416 211.672)",
    fill: "#2d2d2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1019",
    "data-name": "Path 1019",
    d: "M102.228,60.62c-.1-.9-.873-1.246-1.444-1.761a.226.226,0,0,1-.228-.2c.119-1.231.332-2.473-.392-3.611-.522-1.235-2.261-1.078-2.72-2.384.381-.127.586-.332.313-.739-.108-.276-.216-.552-.325-.824.679-.713.813-1.306-.358-1.608a2.743,2.743,0,0,0-.72-1.91c-.149-.142-.3-.284-.444-.425s-.272-.317-.407-.474c.06-.306.123-.612.183-.921a7.934,7.934,0,0,1,3.436,6,.64.64,0,0,0,.239.478c2.2,1.138,2.444,3.22,2.88,5.365.366,1.787,2.376,2.694,3.1,4.391,0,.4.119.813-.194,1.156-.168,0-.336,0-.5-.007-.959-.7-.817-2.447-2.421-2.529",
    transform: "translate(260.791 124.968)",
    fill: "#2d2d2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1020",
    "data-name": "Path 1020",
    d: "M49.856,75.577c-.019-.366-.041-.727-.06-1.093,2.753-1.093,5.357-2.526,8.226-3.376a46.664,46.664,0,0,1,5.312-1.03c.485-.086,1.108-.444,1.317.272.194.679-.5.839-.959.981a38.614,38.614,0,0,1-6.5,1.9c-2.634.343-4.757,2.022-7.338,2.35",
    transform: "translate(135.976 190.907)",
    fill: "#2d2d2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1021",
    "data-name": "Path 1021",
    d: "M98.106,61.669c-.138.425-.276.851-.418,1.276a3.729,3.729,0,0,1-2.309,0c-.045-.388-.138-.78-.619-.754s-.526.433-.541.817c-.679.168-1.351.388-2.037.5a7.244,7.244,0,0,0-4.76,2.451A8.44,8.44,0,0,1,83.3,68.328c-.145-.381-.287-.761-.433-1.145a15.9,15.9,0,0,0,4.029-2.611c3.29-2.757,7.152-3.19,11.214-2.9",
    transform: "translate(226.27 168.188)",
    fill: "#4f4f4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1022",
    "data-name": "Path 1022",
    d: "M69.4,44.513l.686,1c.272,1.224-.377,2.671.959,3.936.317-1-.123-2.388,1.44-2.16.056-.992,1.835-.44,1.556-1.735.492.243.981.485,1.47.727l.011,2.436a20.414,20.414,0,0,1-5.633,1.847c-2.555-1.142-2.555-1.142-1.731-3.622a8.939,8.939,0,0,1,.384-.869,1.688,1.688,0,0,0,.381-1.369c.16-.063.317-.131.478-.194",
    transform: "translate(184.791 121.55)",
    fill: "#4f4f4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1023",
    "data-name": "Path 1023",
    d: "M98.4,35.977a1.047,1.047,0,0,0-.5,1.194.636.636,0,0,0-.672.414c-.168.037-.332.075-.5.116-.948.172-2.57-.422-2.749.235-.481,1.75-1.835,2.813-2.6,4.287a3.8,3.8,0,0,1-2.6.948c-1.365.123-1.119-.541-.66-1.321,1.981,1.082.914-1.511,2.093-1.787.679-.16-.511-1.015-.66-1.634q4.4-1.718,8.808-3.443l.045.992",
    transform: "translate(239.622 95.532)",
    fill: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1024",
    "data-name": "Path 1024",
    d: "M65.25,51.5c-.716-.09-1.377-.25-1.466-1.142l.086-.116-.075.127c-.9-.377-1.537.187-2.257.556-.921.47-1.873,1.145-2.921.235.295-.116.754-.336.586-.589-.272-.407-.649-.142-.884.216-.948-.1-1.746,1.2-2.776.284,3.555-2.029,7.469-3.156,11.311-4.473.015.381.034.761.049,1.142-2.541.381-1.78,2.209-1.653,3.761",
    transform: "translate(151.669 127.243)",
    fill: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1025",
    "data-name": "Path 1025",
    d: "M61,60.186A2.332,2.332,0,0,1,63.892,57.8c1.854.213,1.183,1.824,1.212,2.794.056,1.914-1.947,1.615-2.88,1.739-1.649.209-.974-1.522-1.227-2.145",
    transform: "translate(166.562 157.755)",
    fill: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1026",
    "data-name": "Path 1026",
    d: "M35.7,73.757l.4.806c-3.749.533-7.521.966-10.151,4.26a3.2,3.2,0,0,1-2.279,1.3c-.142-.433-.526-.436-.877-.5,1.589-1.212,3.022-2.664,4.633-3.79,2.41-1.683,5.406-1.794,8.271-2.078",
    transform: "translate(62.251 201.405)",
    fill: "#4f4f4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1027",
    "data-name": "Path 1027",
    d: "M19.111,84.106a9.638,9.638,0,0,1-3.186,2.5c-2.809,1.578-5.663,3.085-8.495,4.619,0-.377,0-.754,0-1.13,2.209-1.921,4.969-2.932,7.446-4.406,1.261-.754,2.41-1.641,3.637-2.429a.837.837,0,0,1,.6.851",
    transform: "translate(20.281 227.341)",
    fill: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1028",
    "data-name": "Path 1028",
    d: "M65.237,57.438c1.526-.463,1.791.2,1.712,1.351-.1,1.474-2.119,3.19-3.518,2.888A1.037,1.037,0,0,1,63,61.385a3.989,3.989,0,0,0,.537-2.865c-.44-1.955,1.3-.7,1.7-1.082",
    transform: "translate(172.018 156.437)",
    fill: "#2d2d2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1029",
    "data-name": "Path 1029",
    d: "M59.2,60.844a2.276,2.276,0,0,1,2.541-2.492c1-.022.944.653.977,1.3.093,1.888-.731,2.832-2.507,2.895-1.533.052-.739-1.179-1.011-1.7",
    transform: "translate(161.648 159.339)",
    fill: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1030",
    "data-name": "Path 1030",
    d: "M50.241,63.932a3.129,3.129,0,0,1,2.7-3.033c.948-.034,1.2.519,1.205,1.351.015,1.78-.989,2.7-2.917,2.8-.963.045-1.1-.4-.985-1.115",
    transform: "translate(137.097 166.29)",
    fill: "#2d2d2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1031",
    "data-name": "Path 1031",
    d: "M50.71,63.868c-.519.776-.086,2.47-1.813,2.168-.877-.153-2.339-.048-1.985-1.7.272-1.261.9-2.432,2.354-2.444,1.074-.007,1.5.869,1.444,1.974",
    transform: "translate(127.952 169.011)",
    fill: "#2d2d2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1032",
    "data-name": "Path 1032",
    d: "M31.065,81.158c-3.234,2.134-6.2,4.779-10.27,5.335,3.563-1.772,6.723-4.163,10.1-6.208.06.291.116.582.175.873",
    transform: "translate(56.784 219.231)",
    fill: "#4f4f4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1033",
    "data-name": "Path 1033",
    d: "M59.582,60.769a2.579,2.579,0,0,1-2.955,2.611c-1.268-.026-1.171-1.041-1.265-1.817-.1-.81,2.141-2.242,3.264-2.153.839.071,1.108.575.955,1.358",
    transform: "translate(151.167 162.22)",
    fill: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1034",
    "data-name": "Path 1034",
    d: "M56.908,50.321c-.034-.616-.56-1.209-.093-1.85l.086.037c.608.5.992,1.548,2.268.679-1.272,1.731-1.675,4.152-4.522,3.447-.41-.1-.645.981-1.4.75a5.54,5.54,0,0,1,.515-3.007c1.026-1.108,2.078-.713,3.137-.052l.157.086-.153-.09",
    transform: "translate(145.279 132.358)",
    fill: "#2d2d2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1035",
    "data-name": "Path 1035",
    d: "M48.694,64.072c.1-1.7,1.183-2.779,2.537-2.671a1.061,1.061,0,0,1,1.06,1.466c-.28,1.157-.075,2.805-2.115,2.537-.866-.112-1.8-.123-1.481-1.332",
    transform: "translate(132.795 167.643)",
    fill: "#2d2d2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1036",
    "data-name": "Path 1036",
    d: "M45.369,65.531A2.053,2.053,0,0,1,46.536,63.1c.679-.3,1.444-1.261,2.063,0,.455.925.9,1.947-.422,2.641-.455.239-.869.563-1.339.757-.966.4-1.891.642-1.47-.97",
    transform: "translate(123.6 170.575)",
    fill: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1037",
    "data-name": "Path 1037",
    d: "M41.543,74.353a2.494,2.494,0,0,1,2.574-1.235A5.6,5.6,0,0,0,47.9,71.88a2.572,2.572,0,0,1,2.608-.556c-2.291,1.313-3.846,3.917-7.04,3.067-.425-.112-1.026.433-1.544.675-.328-.131-.366-.414-.377-.713",
    transform: "translate(113.44 194.284)",
    fill: "#2d2d2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1038",
    "data-name": "Path 1038",
    d: "M59.682,57.35c0,.224,0,.448,0,.672-3.608,1.339-7.211,2.69-10.826,4.007a5.5,5.5,0,0,1-2.432.5c-.127-.175-.257-.351-.384-.526,3.238-.668,6.178-2.164,9.237-3.331a20.019,20.019,0,0,1,4.4-1.324",
    transform: "translate(125.728 156.603)",
    fill: "#4f4f4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1039",
    "data-name": "Path 1039",
    d: "M60.806,60.6a2.172,2.172,0,0,1-2.2,2.429c-1.212.131-1.283-.772-1.347-1.641-.127-1.746,1.384-2.052,2.451-2.492.806-.332,1.164.515,1.1,1.7",
    transform: "translate(156.322 160.613)",
    fill: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1040",
    "data-name": "Path 1040",
    d: "M55.444,62.11c.53,2.264-.828,2.358-2.451,2.369-1.015.011-1.272-.5-1.287-1.283-.022-1.086,2.078-2.861,3.2-2.708,1.235.172.4,1.112.541,1.623",
    transform: "translate(141.191 165.143)",
    fill: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1041",
    "data-name": "Path 1041",
    d: "M54.057,70.343a2.677,2.677,0,0,1-2.492.787c-2.029-.418-3.331.515-4.492,1.981-.31.388-.623,1.276-1.3.664-.612-.552.138-1.045.455-1.462,1.932-2.507,3.455-2.888,7.831-1.97",
    transform: "translate(124.35 190.84)",
    fill: "#4f4f4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1042",
    "data-name": "Path 1042",
    d: "M105.367,54.018a19.8,19.8,0,0,1,6.894-1.548,1.706,1.706,0,0,0,1.761-.918c.53.362.511.877-.037,1.011-2.354.578-4.357,1.947-6.585,2.8a.745.745,0,0,1-.892-.153c.1-.854-.9-.664-1.142-1.194",
    transform: "translate(287.721 140.771)",
    fill: "#4f4f4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1043",
    "data-name": "Path 1043",
    d: "M46.73,72.008c.011.3.049.582.377.713-1.843,2.19-4.387,3.6-6.342,5.674-.246.257-.657.589-.992.19s.052-.724.336-.966q3.3-2.815,6.622-5.611",
    transform: "translate(108.253 196.629)",
    fill: "#4f4f4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1044",
    "data-name": "Path 1044",
    d: "M31.827,78.054c-.481.821-2.19.425-1.951,1.962a1.242,1.242,0,0,1-1.194.474c.022-.851-.586-.78-1.142-.78-.276-1.339,1.921-1.313,1.507-2.731.914-.921-.142-2.485,1.209-3.387.448,1,.977,1.858.44,3.063-.362.813.3,1.119,1.067,1.086a.227.227,0,0,1,.063.313",
    transform: "translate(75.138 200.954)",
    fill: "#4f4f4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1045",
    "data-name": "Path 1045",
    d: "M74.053,63.911c-1.138.463-2.171,1.205-3.574.843-1.093-.28-1.78.589-2.57,1.13-.287.2-.623.623-.985.146-.3-.392-.034-.769.269-1.007a4.306,4.306,0,0,1,1.608-1.06c1.69-.3,3.414-.41,5.122-.593.045.179.086.362.131.541",
    transform: "translate(182.389 173.042)",
    fill: "#4f4f4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1046",
    "data-name": "Path 1046",
    d: "M76.307,63.185c-.037.287-.134.653-.425.492-1.809-.985-3.373.306-5.048.489-.388.041-.985.451-1.108-.261-.082-.481.336-.791.843-.884,1.4-.254,2.783-.575,4.19-.761a1.533,1.533,0,0,1,1.548.925",
    transform: "translate(190.371 169.977)",
    fill: "#4f4f4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1047",
    "data-name": "Path 1047",
    d: "M86.5,63.091c.145.381.291.765.433,1.145-1.287,1.246-3.07,1.5-4.592,2.268a.734.734,0,0,1-.686-.127c-.261-.3-.048-.63.22-.806,1.474-.951,2.634-2.492,4.626-2.481",
    transform: "translate(222.636 172.28)",
    fill: "#dadada"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1048",
    "data-name": "Path 1048",
    d: "M99.98,52.6c-.623-.358-1.037-.194-1.239.5-.541-.231-.877-.731-.612-1.2.53-.925,1.5-.228,2.253-.425.31.9,1.007.724,1.5.358a1.446,1.446,0,0,1,1.384-.157c.183.459.757.892.351,1.4-.366.451-.963.179-1.466.123-.459-.052-.9-.664-1.384-.063l.026.049c.131-.75-.578-.336-.813-.582",
    transform: "translate(267.706 140.393)",
    fill: "#2d2d2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1049",
    "data-name": "Path 1049",
    d: "M16.417,82.938c-1.354,1.481-3.339,2.037-4.835,3.313a.963.963,0,0,1-.933-.575c1.347-1.817,3.511-2.44,5.3-3.6.157.287.31.578.466.866",
    transform: "translate(29.079 224.11)",
    fill: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1050",
    "data-name": "Path 1050",
    d: "M74.772,75.218l.134,1.1c-.813,1.373-2.361,1.906-3.44,2.981a.443.443,0,0,1-.679.015.613.613,0,0,1,.034-.877c1.25-1.153,2.078-2.832,3.951-3.216",
    transform: "translate(192.836 205.394)",
    fill: "#dadada"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1051",
    "data-name": "Path 1051",
    d: "M42.119,55.519l.134.836q-2.546,1.628-5.089,3.257c-.2-.19-.4-.377-.6-.567,1.824-1.216,3.436-2.768,5.551-3.525",
    transform: "translate(99.855 151.603)",
    fill: "#4f4f4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1052",
    "data-name": "Path 1052",
    d: "M101.685,68.191c-.332.88-.832,1.578-1.7,1.7a1.1,1.1,0,0,1-1.272-1.119,1.82,1.82,0,0,1,1.709-1.768c.742-.082,1.018.612,1.268,1.183",
    transform: "translate(269.534 182.96)",
    fill: "#f7f7f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1053",
    "data-name": "Path 1053",
    d: "M56.55,60.13l.022,2.3c-.742.179-1.474.936-2.25.119-.75-.787-.407-1.623-.037-2.447a.44.44,0,0,1,.3-.06c.657.03,1.309.056,1.966.086",
    transform: "translate(147.118 163.948)",
    fill: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1054",
    "data-name": "Path 1054",
    d: "M98.091,51.309c.313-.343.194-.761.194-1.157,1.2-.291,1.791.832,2.723,1.168-.72.683.216.795.4,1.168-.287.3-.575.6-.866.9a3.283,3.283,0,0,1-2.447-2.082",
    transform: "translate(267.853 136.82)",
    fill: "#dadada"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1055",
    "data-name": "Path 1055",
    d: "M55.095,60.058c-.369.821-.713,1.656.037,2.444.776.817,1.5.063,2.25-.116-.47,1.7-1.91.638-2.861.959-.548.187-.955-.306-.94-.94.026-1.082.2-2.085,1.515-2.347",
    transform: "translate(146.308 163.998)",
    fill: "#4f4f4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1056",
    "data-name": "Path 1056",
    d: "M48.843,61.375l.571.6c-1.149.515-2.287,1.048-3.447,1.533-.41.175-1,.705-1.25-.09-.16-.515.265-.948.817-1.108,1.1-.317,2.2-.627,3.309-.94",
    transform: "translate(122.013 167.594)",
    fill: "#4f4f4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1057",
    "data-name": "Path 1057",
    d: "M83.8,40.072c0,.261,0,.522,0,.783l-5.01,1.656c-.041-.246-.082-.489-.127-.735a19.321,19.321,0,0,1,5.133-1.7",
    transform: "translate(214.802 109.423)",
    fill: "#4f4f4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1058",
    "data-name": "Path 1058",
    d: "M50.286,58.9c.127.175.257.351.384.526-.287.851-.989.631-1.608.619-.832-.668-1.664-.384-2.544-.071-.642.228-1.313.88-2.029.119,1.518-.575,2.888-1.567,4.589-1.612.295.455.769.388,1.209.418",
    transform: "translate(121.484 159.705)",
    fill: "#dadada"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1059",
    "data-name": "Path 1059",
    d: "M45.123,59.25c.716.761,1.388.108,2.029-.119.88-.31,1.712-.6,2.544.075-1.91.216-3.518,1.358-5.368,1.753.022-.683-.455-1.6.795-1.709",
    transform: "translate(120.85 160.552)",
    fill: "#2d2d2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1060",
    "data-name": "Path 1060",
    d: "M63.262,73.467c-.022-.2-.041-.4-.063-.6,1.149-1.388,2.6-.966,4.037-.731a6.647,6.647,0,0,1-3.973,1.332",
    transform: "translate(172.575 196.297)",
    fill: "#dadada"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1061",
    "data-name": "Path 1061",
    d: "M89.553,35.909c.149.619,1.339,1.474.66,1.634-1.179.276-.112,2.865-2.093,1.787l.049-.108a.647.647,0,0,0-.34-.668l-.078-.1.063-.108c.183-.847,1.824-.858,1.231-2.153.168-.1.339-.19.507-.287",
    transform: "translate(239.618 98.055)",
    fill: "#2d2d2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1062",
    "data-name": "Path 1062",
    d: "M21.777,77.766c-.586.205-.992-.16-.847-.608.25-.78.716-1.559,1.7-1.6,1.339-.056,2.682-.026,4.025-.034.358.082.754.093.97.474a3.058,3.058,0,0,1-2.376.354,3.557,3.557,0,0,0-3.47,1.414",
    transform: "translate(57.071 206.226)",
    fill: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1063",
    "data-name": "Path 1063",
    d: "M29.976,77.65a4.446,4.446,0,0,1,3.88-.586c-1.112.354-2.223.705-3.335,1.06-.179-.157-.362-.317-.545-.474",
    transform: "translate(81.854 209.868)",
    fill: "#4f4f4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1064",
    "data-name": "Path 1064",
    d: "M90.4,35.986c.593,1.291-1.048,1.306-1.231,2.153l-1.127-.3c-.261-.239-.522-.474-.783-.713A9.189,9.189,0,0,1,90.4,35.986",
    transform: "translate(238.266 98.265)",
    fill: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1065",
    "data-name": "Path 1065",
    d: "M99.13,70.014c-1.022-.754-1.324-1.821-1.593-3.257,1.809.664,1.451,2.1,1.593,3.257",
    transform: "translate(266.34 182.29)",
    fill: "#f7f7f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1066",
    "data-name": "Path 1066",
    d: "M46.363,62.513c.168-.6-.459-1.645.619-1.694.5-.022,1.627.183,1.354,1.351-.578.575-1.35.034-1.974.343",
    transform: "translate(126.515 166.072)",
    fill: "#4f4f4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1067",
    "data-name": "Path 1067",
    d: "M40.449,56.769c-.455-.019-.892-.056-1.127-.53,1.287.1,1.7-1.406,2.865-1.541.313.09.619.179.921.269l-2.66,1.8",
    transform: "translate(107.375 149.361)",
    fill: "#4f4f4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1068",
    "data-name": "Path 1068",
    d: "M30.3,78.781c-.414-.052-.824-.108-1.239-.16a4.307,4.307,0,0,1,2.835-1.507l.067.713a3.375,3.375,0,0,1-1.664.955",
    transform: "translate(79.345 210.569)",
    fill: "#4f4f4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1069",
    "data-name": "Path 1069",
    d: "M107.018,49.094c.224-.339.444-.683.668-1.022.168.086.336.246.5.246.425,0,.854-.075,1.571-.149a4.279,4.279,0,0,1-2.742.925",
    transform: "translate(292.229 131.268)",
    fill: "#4f4f4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1070",
    "data-name": "Path 1070",
    d: "M56.032,60.788c-.657-.03-1.309-.056-1.966-.086,1.507-1.22,1.526-1.216,1.966.086",
    transform: "translate(147.636 163.29)",
    fill: "#4f4f4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1071",
    "data-name": "Path 1071",
    d: "M23.412,76.524c-.216-.381-.608-.392-.97-.474l1.324-.72c.351.06.735.063.877.492-.175.649-.672.731-1.231.7",
    transform: "translate(61.281 205.7)",
    fill: "#2d2d2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1072",
    "data-name": "Path 1072",
    d: "M27.826,75.233c.56,0,1.164-.071,1.142.78-.489.246-.936.679-1.556.351,0-.235,0-.47,0-.709.138-.138.272-.28.41-.422",
    transform: "translate(74.853 205.432)",
    fill: "#2d2d2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1073",
    "data-name": "Path 1073",
    d: "M32.7,73.66c.705.392-.377,1.477.675,1.738a.964.964,0,0,1-1.056.209c-.045-.235-.09-.474-.131-.709.168-.414.339-.824.511-1.239",
    transform: "translate(87.894 201.14)",
    fill: "#2d2d2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1074",
    "data-name": "Path 1074",
    d: "M88.124,36.291c.261.239.522.474.78.713-.519.179-1.033.354-1.548.533.254-.474.213-.795-.418-.8a1.534,1.534,0,0,1,1.186-.444",
    transform: "translate(237.398 99.098)",
    fill: "#2d2d2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1075",
    "data-name": "Path 1075",
    d: "M11.334,83.038a.963.963,0,0,0,.933.575Q11.635,84.155,11,84.7a.836.836,0,0,0-.6-.851l.936-.813",
    transform: "translate(28.393 226.748)",
    fill: "#2d2d2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1076",
    "data-name": "Path 1076",
    d: "M28.519,75.444c0,.235,0,.47,0,.709-.261.011-.522.022-.787.03a.916.916,0,0,1-.72-.873,2.585,2.585,0,0,0,1.511.134",
    transform: "translate(73.75 205.646)",
    fill: "#4f4f4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1077",
    "data-name": "Path 1077",
    d: "M85.907,62.571c.015-.384.052-.795.541-.817s.578.369.623.757c-.388.019-.776.041-1.164.06",
    transform: "translate(234.583 168.626)",
    fill: "#2d2d2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1078",
    "data-name": "Path 1078",
    d: "M20.45,77.246c.5-.664.817-1.772,1.97-.783-.429.832-.888,1.6-1.97.783",
    transform: "translate(55.842 207.72)",
    fill: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1079",
    "data-name": "Path 1079",
    d: "M33.8,73.992l.134.709a4.175,4.175,0,0,1-2.212.347c-.041-.228-.086-.451-.127-.679.735-.127,1.47-.25,2.2-.377",
    transform: "translate(86.281 202.047)",
    fill: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1080",
    "data-name": "Path 1080",
    d: "M23.676,81.691c-.06-.291-.116-.582-.175-.873.481-.269,1.06-1.231,1.474-.392.354.735-.791.884-1.3,1.265",
    transform: "translate(64.173 218.698)",
    fill: "#2d2d2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1081",
    "data-name": "Path 1081",
    d: "M87.189,36.41c.634.007.675.328.422.8-.243.1-.485.2-.731.3l-.034-1a.588.588,0,0,1,.343-.1",
    transform: "translate(237.147 99.423)",
    fill: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1082",
    "data-name": "Path 1082",
    d: "M13.965,79.7c-.179.444-.418.608-.78.157l.78-.157",
    transform: "translate(36.004 217.644)",
    fill: "#2d2d2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1083",
    "data-name": "Path 1083",
    d: "M29.887,77.943c-.022-.239-.045-.474-.071-.713.2-.052.4-.108.6-.16.183.157.366.317.545.474-.354.134-.713.265-1.071.4",
    transform: "translate(81.417 210.452)",
    fill: "#2d2d2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1084",
    "data-name": "Path 1084",
    d: "M65.924,57.368c-.011.22-.019.44-.03.66-.6-.25-.474-.463.03-.66",
    transform: "translate(178.844 156.652)",
    fill: "#4f4f4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1085",
    "data-name": "Path 1085",
    d: "M102.483,54.414c.284-.1.575-.205.866-.306l-.078,1.615c-1.145-.172-1.548.481-1.761,1.474-.213,1.026.436,1.8.645,2.7v2.593a23.554,23.554,0,0,0-1.854,5.555c-.511.306-.489.824-.53,1.317-.507-.034-1.015-.067-1.522-.1a.935.935,0,0,0,0-1.1c2.529-3.164,2.768-6.741,1.914-10.52l.067-1.052a2.785,2.785,0,0,1,2.257-2.171",
    transform: "translate(268.273 147.75)",
    fill: "#2d2d2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1086",
    "data-name": "Path 1086",
    d: "M100.052,57.986c.347.142.694.28,1.041.422a2.949,2.949,0,0,1-1.8,2.417c-.243-1.205.69-1.914.757-2.839",
    transform: "translate(271.029 158.34)",
    fill: "#4f4f4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1087",
    "data-name": "Path 1087",
    d: "M83.01,53.944c-2.518,1.4-5.361,1.828-8.077,2.593-6.163,1.738-12.072,4.2-18.138,6.193.548-1.858,2.3-2.022,3.734-2.57A10.343,10.343,0,0,0,63.906,58.6a23.789,23.789,0,0,0-4.973,1.336c-.612.224-1.276.739-1.794-.168a2.712,2.712,0,0,0,1.2-2.82c-.1-1.164-.313-2.421.783-3.544.6,1.716-.172,3.492.7,5.1.88-.675.332-1.593.72-2.235,2.291,1.231,2.182,1.194,3.04-1.358a5.218,5.218,0,0,1,1.862-2.761c.03.4.183.7.642.739l.022.034c-1.641.742-.828,2.253-.589,3.137.269.989-1.731,1.932-.1,2.473.824.269,1.977-.381,2.958-.69a14.673,14.673,0,0,0,1.742-.8c1.966-.53,4.126-.381,5.872-1.683l7-2.63c0,.407.011.81.015,1.216",
    transform: "translate(155.088 142.404)",
    fill: "#dadada"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1088",
    "data-name": "Path 1088",
    d: "M62.282,58.639c-.392.645.157,1.559-.724,2.238-.873-1.6-.1-3.384-.7-5.1-1.1,1.123-.888,2.384-.783,3.544a2.716,2.716,0,0,1-1.194,2.824c-.608.291-1.06.94-1.854.8-1.082-1.283-.325-2.891-.742-4.29.034-.515.045-1.033.112-1.541.145-1.06-.72-2.369.172-3.13a20.711,20.711,0,0,1,4.272-2.608c.9-.451,1.869.739,1.511,2.1-.463,1.746-.1,3.443-.067,5.163",
    transform: "translate(153.346 140.033)",
    fill: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1089",
    "data-name": "Path 1089",
    d: "M68.943,58.616l-7,2.63c0-.328.011-.653.019-.981,1.179-1.724.63-3.7.81-5.574.127-1.321.205-2.641.358-4.7.765,1.735,1.186,2.156,2.212.907a2.081,2.081,0,0,1,3.6,1.037,9.838,9.838,0,0,1,.455,3.234c-.037.444-.149,1.164.071,1.309,1.9,1.272-.127,1.492-.522,2.134m-.78-3.32h.026c-.056-.709-.086-1.421-.168-2.123-.071-.589-.183-1.209-1.011-1.1-.664.082-.75.578-.783,1.134-.06.966-.242,1.932-.213,2.891.026.772-.7,2.044.75,2.156,1.466.116,1.511-1.078,1.436-2.182-.019-.257-.026-.515-.037-.772",
    transform: "translate(169.14 136.516)",
    fill: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1090",
    "data-name": "Path 1090",
    d: "M64.284,60.238a14.359,14.359,0,0,1-1.742.8c-.981.31-2.138.963-2.962.69-1.63-.541.366-1.485.1-2.473-.239-.884-1.052-2.4.589-3.137.067.444.131.892.2,1.336.075-.015.153-.026.231-.041.116-1.186.235-2.376.351-3.567.817-1.645,1.727-3.16,3.962-2.82,1.567,2.373,1.414,5.018,1.209,7.67-.366,0-.727-.011-1.089-.019-.231-1.485.25-3.033-.325-4.745-1.556,1.765-.754,3.44-.459,5.077-.022.407-.041.817-.063,1.227",
    transform: "translate(160.924 139.206)",
    fill: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1091",
    "data-name": "Path 1091",
    d: "M58.917,62.037c-.138-1.351-.25-2.7-.425-4.044-.056-.444-.272-.985-.806-.933-.287.026-.668.448-.776.769a4.916,4.916,0,0,0-.34,2.97,2.964,2.964,0,0,1-.989,3.507c-.668.463-1.242.481-1.339-.53-.28-2.843-.582-5.678-.791-8.525-.063-.9,3.179-3.249,4.107-3.044.88.194.481.7.187,1.149-.627.933-1.936.944-2.843,1.985,1.47.354,3.007-.657,3.913.791.75,1.194.727,2.6.951,3.932-.037.653-.078,1.309-.116,1.962l-.735.011",
    transform: "translate(145.956 142.523)",
    fill: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1092",
    "data-name": "Path 1092",
    d: "M52.23,56.068c.534-.1,1.462-.373,1.149.541a31.151,31.151,0,0,0-1.145,6.338c-.205,1.6-2.126,1.436-3.294,1.675-1.071.216-1.1-.981-.951-1.854.332-1.932-.231-3.9.373-5.838.4-1.268,2.8-2.876,4.029-2.347.7.3-.164.533-.19.832a3.244,3.244,0,0,0-3.082,2.5c-.519,2.082,0,4.294,1.16,5.219.265-2.5-.877-5.368,1.951-7.07",
    transform: "translate(130.863 148.764)",
    fill: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1093",
    "data-name": "Path 1093",
    d: "M56.052,57.432l.735-.011c1.071-.015,2.149.022,3.212-.063.873-.071,1.63-.388,1.552-1.5.8.134,1.246-.515,1.854-.806.515.907,1.179.388,1.794.168a23.949,23.949,0,0,1,4.973-1.339,10.409,10.409,0,0,1-3.38,1.559c-1.433.548-3.186.713-3.734,2.57a8.1,8.1,0,0,1-3.085.951c.254-1.041-.418-.612-.877-.567-1.559.164-2.854,1.339-4.6,1.287.246-1.048,1.865-.992,1.552-2.25",
    transform: "translate(148.821 147.128)",
    fill: "#4f4f4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1094",
    "data-name": "Path 1094",
    d: "M54.328,62.156,51.544,63.41c-.325-.175-.653-.347-.977-.522l.336-1.444c.231-.007.466-.011.7-.019,1.78-.649.459-2.115.828-3.137.56-.634.325-1.373.28-2.085.03-.339.06-.675.093-1.011.485-.1.832-.269.4-.817l-.06.019c.828.668,1.466-.459,2.261-.235.377.1.817.134.974.526.2.492-.231.705-.582.824a2.265,2.265,0,0,0-1.5,2.966c.246,1.074-.619,1.925-.336,2.944.123.246.25.492.373.739",
    transform: "translate(138.081 147.805)",
    fill: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1095",
    "data-name": "Path 1095",
    d: "M51.4,63.626c-.235.007-.466.015-.7.019-.239-2.391.407-4.786,0-7.182a.693.693,0,0,1,.358-.824c1.824-.727,3.5-1.847,5.8-2.317-1.063,1.753-2.813,2.134-3.921,3.272L53,56.579c-.466.108-1.033.172-.4.817l0,0c-.489-.645-.694-.216-.757.246-.056.422-.239,1.1.66.765.049.713.284,1.455-.28,2.085-.918.877-.8,2.026-.824,3.137",
    transform: "translate(138.287 145.604)",
    fill: "#2d2d2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1096",
    "data-name": "Path 1096",
    d: "M62.4,50.27a2.58,2.58,0,0,1,2.16-2.988c.959-.243,1.209,1.231,1.205,2.242,0,1.209-1.507,3.04-2.444,2.828-1.112-.254-.806-1.309-.921-2.082",
    transform: "translate(170.235 129.037)",
    fill: "#2d2d2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1097",
    "data-name": "Path 1097",
    d: "M59.878,57.552c.078,1.112-.683,1.429-1.552,1.5-1.067.086-2.141.049-3.212.067.037-.657.075-1.313.116-1.966,1.615-.4,3.078-.963,3.108-3,.011-.534.239-.854.8-.892.414,1.4-.339,3.007.742,4.294",
    transform: "translate(150.497 145.429)",
    fill: "#dadada"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1098",
    "data-name": "Path 1098",
    d: "M48.144,53.3a1.013,1.013,0,0,1,1.2,1.309,2.91,2.91,0,0,1-2.432,2.16c-.828.175-1.015-.545-1.007-1.268.015-1.522.735-2.238,2.242-2.2",
    transform: "translate(125.342 145.497)",
    fill: "#2d2d2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1099",
    "data-name": "Path 1099",
    d: "M60.054,57.512c-.455-.037-.608-.336-.642-.739-.22-.716-.049-1.462-.306-2.212A2.508,2.508,0,0,1,60.177,51.9a22.574,22.574,0,0,1,5.051-1.44c.034.6-.571.6-.839.91-3.581.948-3.667,1.03-3.869,3.757-.448.739-.254,1.6-.466,2.388",
    transform: "translate(161.114 137.781)",
    fill: "#2d2d2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1100",
    "data-name": "Path 1100",
    d: "M51.5,55.383c-2.828,1.7-1.686,4.57-1.951,7.07-1.164-.925-1.679-3.137-1.16-5.219a3.244,3.244,0,0,1,3.082-2.5c.011.216.019.437.03.653",
    transform: "translate(131.59 149.449)",
    fill: "#dadada"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1101",
    "data-name": "Path 1101",
    d: "M53.48,52.894c-.145,1.078.194,2.578-1.421,2.514-1.164-.049-1-1.313-1.015-2.194A1.786,1.786,0,0,1,52.8,51.283c1.1-.034.575,1.041.683,1.612",
    transform: "translate(139.381 140.033)",
    fill: "#2d2d2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1102",
    "data-name": "Path 1102",
    d: "M58.972,50.64c-.168,1.265.209,2.723-1.518,2.85-1.317.1-.888-.992-.9-1.683-.022-1.216.325-2.268,1.768-2.309.921-.022.608.776.649,1.142",
    transform: "translate(154.272 135.162)",
    fill: "#2d2d2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1103",
    "data-name": "Path 1103",
    d: "M63.224,58.27c.034-.9-.556-.873-1.183-.8,0-.239,0-.478,0-.716,2.447-.866,4.682-2.339,7.368-2.623-1.649,2.044-4.779,1.794-6.189,4.137",
    transform: "translate(169.413 147.819)",
    fill: "#4f4f4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1104",
    "data-name": "Path 1104",
    d: "M59.233,50.935c.116-1.1.131-2.261,1.716-2.3.989-.03,1.205.519,1.179,1.347-.041,1.183-.239,2.22-1.742,2.3-.985.052-1.239-.489-1.153-1.343",
    transform: "translate(161.704 132.796)",
    fill: "#2d2d2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1105",
    "data-name": "Path 1105",
    d: "M45.412,54.2c.295-1.127,1.242-1.321,2.134-1.843,1.828-1.074,1.462,1.1,2.35,1.235-.436,1.324-1.768,1.2-2.72,1.686a.921.921,0,0,0-.985-.653c-.317-.037-.63-.082-.78-.425",
    transform: "translate(124.005 142.153)",
    fill: "#4f4f4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1106",
    "data-name": "Path 1106",
    d: "M56.992,58.261l-.47-.492c.09-.31-.1-.429-.343-.522l2.593-.638c.69,1.586,2.466,1.828,4.137,2.973-2.5.16-3.954-1.671-5.917-1.321",
    transform: "translate(153.406 154.577)",
    fill: "#4f4f4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1107",
    "data-name": "Path 1107",
    d: "M51.848,58.159c-.123-.246-.25-.492-.373-.739q3.274-.912,6.551-1.828c.052.179.1.354.149.533-1.862,1.365-4.093,1.7-6.327,2.033",
    transform: "translate(140.561 151.803)",
    fill: "#4f4f4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1108",
    "data-name": "Path 1108",
    d: "M46.755,58.6c-.3.007-.6.019-.9.026-.2-2.306,1.828-3.761,4.839-3.417-.287,1.086-1.332.839-2.011,1.194-.925.481-2.235.63-1.929,2.2",
    transform: "translate(125.18 150.625)",
    fill: "#2d2d2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1109",
    "data-name": "Path 1109",
    d: "M55.886,51.025c.011-.257-.071-.563.045-.757.616-1.078,4.223-2.033,5.454-1.477-1.571,1.392-3.552,1.768-5.5,2.235",
    transform: "translate(152.557 132.784)",
    fill: "#2d2d2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1110",
    "data-name": "Path 1110",
    d: "M56.222,51.042c-.034.254-.071.507-.1.761-.116.795.463,2.1-1,2.015-1.283-.075-1.522-1.209-1.421-2.32a2.908,2.908,0,0,1,.373-.854c.716.134,1.436.265,2.153.4",
    transform: "translate(146.569 138.289)",
    fill: "#2d2d2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1111",
    "data-name": "Path 1111",
    d: "M48.56,53.758c-.127-.985.358-1.4,1.328-1.336.6.037,1.309.071,1.037.914-.265.824-.007,2.175-1.373,2.171-1,0-1.078-.907-.992-1.75",
    transform: "translate(132.53 143.131)",
    fill: "#2d2d2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1112",
    "data-name": "Path 1112",
    d: "M59.409,54.459c.2-2.727.287-2.813,3.869-3.757.142.358.287.72.433,1.082-2.235-.336-3.145,1.175-3.962,2.824a.754.754,0,0,0-.339-.149",
    transform: "translate(162.226 138.45)",
    fill: "#dadada"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1113",
    "data-name": "Path 1113",
    d: "M61.214,53.851c.362.007.724.015,1.086.019,1.548.429,2.626-.787,3.958-1.123l-.022.981c-1.742,1.3-3.9,1.153-5.868,1.683.022-.41.041-.821.063-1.227.261-.112.522-.22.783-.332",
    transform: "translate(164.842 144.034)",
    fill: "#4f4f4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1114",
    "data-name": "Path 1114",
    d: "M66.175,48.055c-.257-.011-.515-.015-.769-.041-.492-.052-1.149.254-1.444-.209-.362-.563.257-1.048.485-1.548A1.693,1.693,0,0,1,65.9,45.168c.571.052.552.888.66,1.447a10.588,10.588,0,0,0,.325,1.1c-.142.31-.414.347-.709.339",
    transform: "translate(174.356 123.327)",
    fill: "#4f4f4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1115",
    "data-name": "Path 1115",
    d: "M68,49.538a13.113,13.113,0,0,1-4.924,1.91c-.381.108-.6-.063-.694-.44a.46.46,0,0,1,.358-.586c1.571-.478,3.014-1.612,5.26-.884",
    transform: "translate(170.307 134.622)",
    fill: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1116",
    "data-name": "Path 1116",
    d: "M47.462,55.408c-.2.246-.567.716-.578.705a8.741,8.741,0,0,0-4.029-1.7.748.748,0,0,1,.007-.5,1.071,1.071,0,0,1,1.239-.228c1.082.321,1.977,1.287,3.253.955.037.254.071.507.108.761",
    transform: "translate(116.914 146.361)",
    fill: "#4f4f4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1117",
    "data-name": "Path 1117",
    d: "M62.146,57.776l-.612.481a8.291,8.291,0,0,1-3.026-1.809c.284-.127.571-.25.854-.377a4.8,4.8,0,0,0,2.783,1.7",
    transform: "translate(159.768 153.111)",
    fill: "#4f4f4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1118",
    "data-name": "Path 1118",
    d: "M55.744,48.127c.448.116,1.429-.1,1.25.336-.332.813-.116,2.044-1.313,2.4a5.448,5.448,0,0,1,.063-2.738",
    transform: "translate(151.595 131.418)",
    fill: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1119",
    "data-name": "Path 1119",
    d: "M58.049,59.242c-.119-.616-.2-.765-.157-.851.358-.739.5-1.63,1.321-2.044a.369.369,0,0,1,.5.4,4.7,4.7,0,0,1-1.664,2.492",
    transform: "translate(158.05 153.782)",
    fill: "#dadada"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1120",
    "data-name": "Path 1120",
    d: "M46.166,52.643c.149.343.463.388.78.425,0,.377-.011.754-.015,1.134a.741.741,0,0,1-.78.392c-.007-.69-.466-.791-1.015-.776.007-.4.011-.795.019-1.19.339,0,.675.011,1.011.015",
    transform: "translate(123.251 143.709)",
    fill: "#2d2d2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1121",
    "data-name": "Path 1121",
    d: "M55.934,51.858c-.716-.134-1.436-.265-2.153-.4.41-.672.97-1.3,1.787-1.063.619.183.63.869.366,1.462",
    transform: "translate(146.857 137.473)",
    fill: "#4f4f4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1122",
    "data-name": "Path 1122",
    d: "M61.419,48.6c-.858-.686-.858-.686-.127-1.88.824.563-.078,1.257.149,1.854l-.022.026",
    transform: "translate(165.912 127.568)",
    fill: "#4f4f4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1123",
    "data-name": "Path 1123",
    d: "M45.617,53.882c.007-.381.011-.757.019-1.134a.919.919,0,0,1,.981.653l-1,.481",
    transform: "translate(124.564 144.029)",
    fill: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1124",
    "data-name": "Path 1124",
    d: "M50.807,56.477c.325.175.649.347.977.522a.987.987,0,0,1-1.3.078,3.7,3.7,0,0,1,.325-.6",
    transform: "translate(137.844 154.219)",
    fill: "#2d2d2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1125",
    "data-name": "Path 1125",
    d: "M53.638,58.01c.138.269.28.541.418.81-.183-.246-.742-.3-.418-.81",
    transform: "translate(146.195 158.405)",
    fill: "#2d2d2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1126",
    "data-name": "Path 1126",
    d: "M109.852,55.816c.854,3.779.612,7.357-1.914,10.52-.914.007-1.832.019-2.746.026l-5.8-2.082c-.325-.422-1.056-.116-1.283-.709.321-.466.754-.384,1.212-.28,2.388.548,4.824.925,7.144,1.668,2.283.731.463-2.384,2.123-2.037,0-.175.056-.388-.022-.519a.654.654,0,0,0-.459-.295c-2.623.1-4.734-1.589-7.2-2.022l-.739-.19a.654.654,0,0,0-.813-.239,7.856,7.856,0,0,0-1.541-.735c-.511-.119-1.175-.951-1.6.045-.325.761.276,1.149.866,1.474a18.557,18.557,0,0,0,3.816,1.268c.653.731,2,.153,2.63,1.406-2.179-.235-4.085-1.063-6.115-.757A1.982,1.982,0,0,1,95.3,60.016a9.166,9.166,0,0,0-.317-2.5c-.657-2.746-.306-3.123,2.4-2.466.705.664,1.932.44,2.716,1.567-.966-.153-1.649-.257-2.335-.366-.664.022-1.582-.9-1.929.239-.317,1.037.709,1.365,1.459,1.645a2.568,2.568,0,0,0,1.656.306c.4.209.81.384,1.183.627,2.026,1.332,4.462.608,6.6,1.343.533.187,1.138.709,1.526.022.4-.713-.392-.948-.839-1.272-.306-.22-.754-.4-.571-.873s.649-.269,1.015-.265c.716,0,1.2-.209.8-1.03-.772-1.593.414-1.168,1.186-1.183",
    transform: "translate(258.584 149.572)",
    fill: "#dadada"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1127",
    "data-name": "Path 1127",
    d: "M74.323,58.618l.448,11.326c-2.216-1.153-4.309-2.567-6.913-2.824-.765-.075-1.787-.172-1.724-1.406.034-.63-.284-1.578.332-1.8a3.473,3.473,0,0,1,2.955.444c1.44.929,3.078,1.086,4.678,1.518a10.959,10.959,0,0,0-5.238-2.925c-.429-.082-1.03.011-1.022-.627.007-.78.683-.616,1.168-.638.97-.045,1.944-.022,2.906-.116.336-.037.821-.2.8-.694-.015-.354-.381-.466-.679-.6-1.287-.593-2.567-1.2-3.872-1.821.392-.448,1.063.019,1.4-.582-.09-.112-.179-.339-.306-.362A12.511,12.511,0,0,0,67.9,57.4c-.511-.026-.9-.209-.9-.783a1.49,1.49,0,0,1,.205-.907.863.863,0,0,1,1.235-.011,5.662,5.662,0,0,0,2.794,1.186c.369.093,1.153-.108.925,1.127-.19,1.056,1.351.567,2.168.608",
    transform: "translate(180.447 151.392)",
    fill: "#4f4f4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1128",
    "data-name": "Path 1128",
    d: "M118.207,43.992c-2,1.477-4.462,1.847-6.708,2.7-1.932.735-3.895,1.421-5.816,2.209q-9.356,3.839-18.709,7.7c-1.254.522-2.223,1.615-3.63,1.847l-.485-.519,3.559-2.015,1.142-.638a.67.67,0,0,0,.787-.373c4.081-1.623,8.237-3.082,12.225-4.906,5.428-2.485,11.147-4.148,16.665-6.361.358-.146,1-.7.97.354",
    transform: "translate(226.259 118.404)",
    fill: "#2d2d2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1129",
    "data-name": "Path 1129",
    d: "M93.847,61.555a9.118,9.118,0,0,1,3.339-4.223c.366.6-.134,1.421.631,2.153.19-2.645,1.91-1.712,3.305-1.586.295.9,1.056.444,1.619.552.977.183,1.518.6.933,1.664-2.123.951-4.477.81-6.667,1.436a.557.557,0,0,0-.8.1c-.783-.142-1.589.265-2.362-.1",
    transform: "translate(256.264 156.554)",
    fill: "#dadada"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1130",
    "data-name": "Path 1130",
    d: "M73.915,54.226c-1.078,1.392.183,3.208-.836,4.611-2.138-.418-3.772-2.22-6.122-2.164-.526.011-.854-.746-.623-1.406s.791-1.078,1.336-.593c1.746,1.559,2.828.463,3.913-.824.556-.1,1.149.175,1.679-.172.216.183.436.366.653.548",
    transform: "translate(180.93 146.576)",
    fill: "#4f4f4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1131",
    "data-name": "Path 1131",
    d: "M66.116,51.684c-.78-1.877.086-2.223,1.944-1.746-.97-.854-2.156-1.265-1.955-2.712.168-1.209,1.235-1.291,1.951-1.821.276,1.026.052,2.339,1.544,2.66.16,1.455-.075,2.94.392,4.38.175.545.108,1.44-.72,1.078-1.1-.478-2.414-.713-3.156-1.839",
    transform: "translate(179.757 123.985)",
    fill: "#4f4f4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1132",
    "data-name": "Path 1132",
    d: "M70.942,59.514q-.022,3.128-.049,6.253c-.757.183-1.653-.295-2.294.463-1.089-.713-1.522-1.6-.552-2.7.806-.91-.9-2.1.4-2.9-.907-1.649.381-1.171,1.149-1.175.451,0,.9.034,1.35.052",
    transform: "translate(184.34 162.202)",
    fill: "#4f4f4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1133",
    "data-name": "Path 1133",
    d: "M83.537,56.676c-.09,1.052-.242,2.059-1.511,2.354-.149-.138-.3-.272-.448-.41-1-1.522-2.279-.343-3.432-.369-.5-1.664.959-4.122,3.033-5.1L84.343,54.8c-.022.25-.049.5-.071.746a5.206,5.206,0,0,1-2.746-.593c-.664-.336-1.149.2-1.3.742-.194.713.526.478.88.634a6.187,6.187,0,0,0,2.429.351",
    transform: "translate(213.117 145.137)",
    fill: "#2d2d2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1134",
    "data-name": "Path 1134",
    d: "M71.2,49.1a18.424,18.424,0,0,0-1.112,5.51l-1.75-.9c0-.254-.086-.694.011-.735,2.761-1.268.071-1.593-.425-2.16a5.691,5.691,0,0,0-1.518-.832c-.806-.459-.653-1.257-.459-1.9.265-.884.921-.28,1.444-.205,1.343.187,2.358,1.384,3.809,1.212",
    transform: "translate(179.66 130.032)",
    fill: "#4f4f4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1135",
    "data-name": "Path 1135",
    d: "M74.095,48.451c.459.929-.112,1.242-.854,1.563-3.123,1.354-3.966,3.167-3.1,6.473.205.78.851,1.679.06,2.343-.422.358-1.156.153-1.074-.757.041-.448.078-.9.078-1.347a25.018,25.018,0,0,0-.1-3.891,2.566,2.566,0,0,1,1.944-3.227l3.048-1.157",
    transform: "translate(188.521 132.303)",
    fill: "#dadada"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1136",
    "data-name": "Path 1136",
    d: "M73.447,54.4c.53-.5,1.41-.242,1.918-.9-.127-.683-.847-.877-1.194-1.38-.2-.295-.642-.533-.25-.948a.794.794,0,0,1,1.048-.179,1.369,1.369,0,0,1,.3.242c1.384,1.589,2.947,2.708,5.212,1.992V53.9a13.588,13.588,0,0,1-5.555,1.821c-.739-.164-1.373-.448-1.481-1.324",
    transform: "translate(200.559 138.883)",
    fill: "#2d2d2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1137",
    "data-name": "Path 1137",
    d: "M71.195,53.328c1.507-.269,3.014-.548,4.522-.806.929-.16.731-.907.824-1.507a2.031,2.031,0,0,1-.086,2.526c-1.474.168-3.044-.015-4.231,1.175l.041-.03c-.407.138-.813.28-1.224.418l.034-.049c-.075.093-.153.183-.231.276-1.276-.91-3.052-.545-4.242-1.686-.276-.261-.716-.44-.53-.9.25-.619.72-.295,1.13-.168q1.74.532,3.481,1.056c.4.272.392-.123.511-.31",
    transform: "translate(180.3 139.304)",
    fill: "#4f4f4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1138",
    "data-name": "Path 1138",
    d: "M73.406,56.561c.422.63.231,1.369.366,2.052-1.451-.388-3.074-.295-4-1.944-.47-.839-1.515.146-2.339-.28-.578-.3-1.421-.4-1.239-1.127.216-.862,1.011-.463,1.634-.28,1.854.541,3.716,1.052,5.574,1.578",
    transform: "translate(180.696 149.449)",
    fill: "#4f4f4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1139",
    "data-name": "Path 1139",
    d: "M70.091,59.015a12.29,12.29,0,0,1-.153,7.961,77.592,77.592,0,0,0-.731-7.969c.295,0,.589,0,.884.007",
    transform: "translate(188.981 161.131)",
    fill: "#2d2d2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1140",
    "data-name": "Path 1140",
    d: "M70.426,56.75c-1.25-.093-2.656.183-3.287-1.38a2.166,2.166,0,0,0-.019-2.376c-.623.888-.347,1.653-.444,2.354-.586-.463-.366-1.2-.575-1.794-.168-.485-.44-1.343.284-1.477s2.071.332,2,.783c-.242,1.485.851,1.608,1.6,2.164.2.146.194.575.28.869.056.287.108.571.16.858",
    transform: "translate(179.976 142.142)",
    fill: "#4f4f4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1141",
    "data-name": "Path 1141",
    d: "M72.056,54.119c.157,1.186-.31,1.3-1.2.7-.265-.157-.533-.313-.8-.474a.5.5,0,0,1,0-.347c.347-.112.284-.228.007-.347-1.194-1.037-2.365-2.1-3.585-3.1-1.026-.843-.366-1,.418-1.142a9.457,9.457,0,0,0,2.973,2.4c.91.593,1.9,1.134,2.179,2.32",
    transform: "translate(180.117 134.903)",
    fill: "#4f4f4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1142",
    "data-name": "Path 1142",
    d: "M71.366,54.525c-.284-1.186-1.268-1.727-2.179-2.32a9.457,9.457,0,0,1-2.973-2.4,1.219,1.219,0,0,0,.974-.556q.879.448,1.753.9c.429,1.205,1.619,1.571,2.5,2.291a3.555,3.555,0,0,1,1.369,1.8c-.127.1-.257.194-.388.287H71.366",
    transform: "translate(180.808 134.496)",
    fill: "#2d2d2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1143",
    "data-name": "Path 1143",
    d: "M72.5,54.515c.007-.164.011-.328.019-.492,1.227.522.877-.4.851-.959-.075-1.481-.187-2.966-.284-4.447.369-.284.66-.093.94.16.175,2.343-.388,4.723.716,7.316-1.007-.388-1.343-.761-1.466-1.433-.1-.519-.425-.567-.776-.145",
    transform: "translate(197.962 132.369)",
    fill: "#dadada"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1144",
    "data-name": "Path 1144",
    d: "M82.05,55.674l-3.164-1.645a2.7,2.7,0,0,1,2.6-1.19c.567.261,1.13.526,1.694.787.149.974-.5,1.507-1.134,2.048",
    transform: "translate(215.411 144.263)",
    fill: "#4f4f4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1145",
    "data-name": "Path 1145",
    d: "M86.745,47.931l-3.563,2.015c-.739-.951-.548-1.645.53-2.19a20.248,20.248,0,0,0,1.854-1.186c.291.037.425-.451.772-.22.548.422.41,1.018.407,1.582",
    transform: "translate(225.932 126.392)",
    fill: "#dadada"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1146",
    "data-name": "Path 1146",
    d: "M98.346,60.14c.589-1.06.045-1.477-.933-1.664-.563-.108-1.321.351-1.615-.548l.582-.6,5.8,2.082a13.205,13.205,0,0,1-3.839.735",
    transform: "translate(261.591 156.529)",
    fill: "#4f4f4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1147",
    "data-name": "Path 1147",
    d: "M79.972,53.772c-.142-1.462-1.735-1.668-2.35-2.72-.194-.339-.907-.545-.418-1.052a.9.9,0,0,1,1.246.045c.962.929,1.873,1.91,2.8,2.873-.1.776-.6.94-1.28.854",
    transform: "translate(210.359 135.902)",
    fill: "#2d2d2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1148",
    "data-name": "Path 1148",
    d: "M68.905,53.121a1.5,1.5,0,0,1-.373.063,2.6,2.6,0,0,1-2.432-1.53c-.149-.354-.1-.873.31-1a2.625,2.625,0,0,1,2.738.787,2.18,2.18,0,0,0-.243,1.675",
    transform: "translate(180.288 138.015)",
    fill: "#4f4f4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1149",
    "data-name": "Path 1149",
    d: "M67.777,62.118c-.548-1.026-2.126-1.462-1.459-2.846.291-.608,1.365-.485,1.9.041.974.963.392,1.843-.44,2.805",
    transform: "translate(180.651 160.74)",
    fill: "#4f4f4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1150",
    "data-name": "Path 1150",
    d: "M80.244,53.641c.175-2.41,2.115-.985,3.179-1.462,0,.44.007.877.007,1.317-.97.313-1.7,1.254-2.854,1.1-.112-.317-.22-.634-.332-.951",
    transform: "translate(219.119 142.483)",
    fill: "#4f4f4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1151",
    "data-name": "Path 1151",
    d: "M72.231,55.845a27.851,27.851,0,0,1-3.966-3.44l1.377-.09c1,1.459,2.638,2.082,4,3.074-.47.149-.936.3-1.406.455",
    transform: "translate(186.408 142.857)",
    fill: "#2d2d2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1152",
    "data-name": "Path 1152",
    d: "M79.125,55.426c.72.358,2.026-.142,2.126,1.328.037.533-.2.921-.791.772-1-.246-2.138-.515-2.529-1.5-.243-.623.642-.548,1.194-.6",
    transform: "translate(212.691 151.349)",
    fill: "#dadada"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1153",
    "data-name": "Path 1153",
    d: "M81.1,53.547c0-.436,0-.877-.007-1.313,1.336-.16,2.619-.179,3.455,1.153-.134.306-.265.612-.4.921-.093.157-.187.313-.284.47l-.22-.3c-.011-.366-.224-.485-.556-.463l.052.03q-1.024-.246-2.041-.5",
    transform: "translate(221.445 142.428)",
    fill: "#2d2d2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1154",
    "data-name": "Path 1154",
    d: "M81.964,55.437a6.187,6.187,0,0,1-2.429-.351c-.354-.157-1.074.078-.88-.634.149-.545.634-1.078,1.3-.742A5.206,5.206,0,0,0,82.7,54.3c-.246.377-.489.757-.735,1.134",
    transform: "translate(214.69 146.377)",
    fill: "#4f4f4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1155",
    "data-name": "Path 1155",
    d: "M66.835,52.618a2.18,2.18,0,0,1,.242-1.675c.246-.071.492-.146.742-.216.265.157.534.313.8.474q-.011,1.192-.026,2.384c-.586-.321-1.171-.645-1.757-.966",
    transform: "translate(182.358 138.518)",
    fill: "#dadada"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1156",
    "data-name": "Path 1156",
    d: "M68.706,61.932a3.657,3.657,0,0,0-2.171,2.335,2.79,2.79,0,0,1,.448-3.164c.548-.556,1.306.026,1.724.828",
    transform: "translate(180.913 166.254)",
    fill: "#2d2d2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1157",
    "data-name": "Path 1157",
    d: "M67.97,48.3c-1.492-.317-1.272-1.63-1.544-2.66a2.074,2.074,0,0,1,1.47-.287c.075.373.153.746.231,1.119L67.97,48.3",
    transform: "translate(181.387 123.754)",
    fill: "#dadada"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1158",
    "data-name": "Path 1158",
    d: "M73.623,50.66c-.28-.254-.567-.444-.94-.16-.332-1.947,1.377-2.048,2.458-2.716l.1.1.011.422a6.659,6.659,0,0,1-1.634,2.35",
    transform: "translate(198.357 130.482)",
    fill: "#2d2d2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1159",
    "data-name": "Path 1159",
    d: "M66.375,59.414c-.164-.989-.649-2.078.2-2.746.6-.47,1.332.011,1.921.813-1.052.291-1.455,1.186-2.123,1.932",
    transform: "translate(180.464 154.237)",
    fill: "#4f4f4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1160",
    "data-name": "Path 1160",
    d: "M67.8,61.573c.642-.757,1.537-.28,2.294-.466.306.727-.563,1.239-.354,1.947-1.321.388-1.2-1.1-1.94-1.481",
    transform: "translate(185.139 166.862)",
    fill: "#2d2d2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1161",
    "data-name": "Path 1161",
    d: "M67.689,52.867c1.186-1.19,2.757-1.007,4.231-1.175-1.142,1.358-2.779.929-4.231,1.175",
    transform: "translate(184.835 141.153)",
    fill: "#dadada"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1162",
    "data-name": "Path 1162",
    d: "M72.625,48.9l-3.048,1.157c0-.257,0-.515,0-.772,1.295-.425,2.492-1.738,3.981-.448Z",
    transform: "translate(189.991 131.851)",
    fill: "#2d2d2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1163",
    "data-name": "Path 1163",
    d: "M71.949,49.913c-.168,1.03-.336,2.063-.556,3.421a5.037,5.037,0,0,1-.839-3.428c.466,0,.929,0,1.4.007",
    transform: "translate(192.659 136.276)",
    fill: "#2d2d2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1164",
    "data-name": "Path 1164",
    d: "M80.991,54.821c-.474,1.88-1.007,1.974-2.69.463a5.3,5.3,0,0,1,2.69-.463",
    transform: "translate(213.813 149.697)",
    fill: "#dadada"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1165",
    "data-name": "Path 1165",
    d: "M84.291,47.727c-.343-.231-.481.261-.769.22l-.034-.873c.47-1.056,1.623-.847,2.432-1.257.343-.175.4.332.291.657-.1.09-.2.179-.3.272-.153.116-.306.235-.459.354-.4-.112-.653.015-.709.448l-.455.179",
    transform: "translate(227.98 125.013)",
    fill: "#2d2d2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1166",
    "data-name": "Path 1166",
    d: "M82.907,47.991q-.308-1.136-.612-2.272l.974-.1a4.346,4.346,0,0,1,.362,2.35l-.724.022",
    transform: "translate(224.719 124.567)",
    fill: "#2d2d2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1167",
    "data-name": "Path 1167",
    d: "M78.977,51.721c.317-.4.586-.884,1.224-.791.373.373.31,0,.347-.205.284-.164.567-.325.851-.489,0,.384-.007.769-.007,1.149-.6.575-1.339.306-2.026.351-.131-.007-.257-.011-.388-.015",
    transform: "translate(215.659 137.177)",
    fill: "#2d2d2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1168",
    "data-name": "Path 1168",
    d: "M66.115,54.66c.093-.7-.179-1.466.44-2.354a2.166,2.166,0,0,1,.022,2.376l-.463-.022",
    transform: "translate(180.537 142.83)",
    fill: "#2d2d2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1169",
    "data-name": "Path 1169",
    d: "M68.581,61.951a.745.745,0,0,1-.78.645c-.246.007-.522-.086-.481-.414a.72.72,0,0,1,.769-.645c.246-.011.489.082.492.414",
    transform: "translate(183.817 168.033)",
    fill: "#2d2d2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1170",
    "data-name": "Path 1170",
    d: "M78.823,50.072l-.034.011c.022-.589-.153-1.3.806-1.321-.489.675.381.705.515,1.082Z",
    transform: "translate(215.146 133.155)",
    fill: "#2d2d2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1171",
    "data-name": "Path 1171",
    d: "M70.812,50.262c-.131-.272-.261-.545-.4-.817.164-.231.4-.343.589-.112.284.347.149.675-.194.929",
    transform: "translate(192.285 134.364)",
    fill: "#2d2d2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1172",
    "data-name": "Path 1172",
    d: "M67.051,46.447c-.078-.373-.153-.746-.231-1.119.3.1.6.2.9.3v.795c-.224.007-.448.019-.671.026",
    transform: "translate(182.462 123.775)",
    fill: "#4f4f4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1173",
    "data-name": "Path 1173",
    d: "M66.762,61.956c.146.187.25.317.354.451-.134.075-.284.231-.4.205-.134-.026-.231-.209-.347-.325.116-.1.231-.2.388-.332",
    transform: "translate(181.245 169.181)",
    fill: "#2d2d2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1174",
    "data-name": "Path 1174",
    d: "M94.48,58.657a.552.552,0,0,1,.795-.1c-.205.47-.459.608-.795.1",
    transform: "translate(257.992 159.553)",
    fill: "#2d2d2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1175",
    "data-name": "Path 1175",
    d: "M93.006,58.9c.2-.545.459-.705.828-.123a.646.646,0,0,1-.828.123",
    transform: "translate(253.967 159.483)",
    fill: "#dadada"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1176",
    "data-name": "Path 1176",
    d: "M67.107,57.172c.048-.108.071-.272.149-.3s.205.078.31.123c-.049.1-.071.272-.145.3s-.205-.075-.313-.123",
    transform: "translate(183.246 155.278)",
    fill: "#2d2d2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1177",
    "data-name": "Path 1177",
    d: "M67.373,52.42c.407-.142.817-.28,1.224-.422-.321.4-.813.291-1.224.422",
    transform: "translate(183.973 141.989)",
    fill: "#dadada"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1178",
    "data-name": "Path 1178",
    d: "M67.787,51.813c-.119.187-.116.582-.511.31,0-.187.011-.369.015-.552.168.078.332.16.5.243",
    transform: "translate(183.708 140.82)",
    fill: "#2d2d2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1179",
    "data-name": "Path 1179",
    d: "M67.319,52.371c.078-.09.157-.183.231-.272a3.186,3.186,0,0,1-.231.272",
    transform: "translate(183.825 142.264)",
    fill: "#dadada"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1180",
    "data-name": "Path 1180",
    d: "M67.066,50.541c.276.119.339.235,0,.347a2.152,2.152,0,0,0,0-.347",
    transform: "translate(183.123 138.01)",
    fill: "#2d2d2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1181",
    "data-name": "Path 1181",
    d: "M94.066,47.455c-.7-.571-1.194.119-1.72.328-2.712,1.078-5.395,2.227-8.092,3.331a2.179,2.179,0,0,1-2.186.131,20.005,20.005,0,0,1,3.641-2.115c8.252-2.626,15.881-6.7,23.82-10.047.739-.313,1.686-1.627,2.488.056a2.776,2.776,0,0,0,1.045-.239c1.817-.694,3.626-1.41,5.436-2.119.373-.145.776-.306.955.231.131.381-.168.6-.466.731-.705.321-1.418.634-2.141.918-6.092,2.384-12.192,4.745-18.276,7.148-1.336.526-2.854.261-4.107,1.045-.224.138-.686.168-.436.645Z",
    transform: "translate(224.1 100.052)",
    fill: "#4f4f4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1182",
    "data-name": "Path 1182",
    d: "M90.213,43.194c1.078,1.16,1.268-.272,1.638-.664,1.03-1.086,2.052-1.8,3.555-.921a1.361,1.361,0,0,1,.851,1.2c-.022.7-.6.66-1.108.81-1.888.571-2.764,3.6-1.556,5.253.478.657,1.056.194,1.6.127l.067.836c-1.9.735-3.634,1.947-5.764,2.052-.243-.127-.485-.254-.731-.381a1.846,1.846,0,0,0,1.13-2.339,29.755,29.755,0,0,1-.851-5.962c.392,0,.78,0,1.171-.007",
    transform: "translate(242.379 112.545)",
    fill: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1183",
    "data-name": "Path 1183",
    d: "M85.578,48.3a43.367,43.367,0,0,1-.966-4.936c-.332-1.507,1.4-.888,2.168-1.3.007.25.011.5.019.754-1.858,1.582-.179,3.1-.108,4.652,1.048-2.97,1.485-3.268,4.395-2.914,0,.336,0,.675.007,1.011-2.231,2.078-2.552,3.645-1.414,6.5a.843.843,0,0,0,1.018.608c.131.243.265.481.4.724a18.075,18.075,0,0,1-4.4,1.675c-.347-.056-.694-.108-1.041-.164.6-.545.235-1.291.4-1.925a3.5,3.5,0,0,1,.72.213c.422.228.817.843,1.313.332.429-.448-.284-.739-.388-1.138-.242-.955-.888-2.029-.649-2.843.567-1.936-.69-1.2-1.47-1.246",
    transform: "translate(230.931 114.868)",
    fill: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1184",
    "data-name": "Path 1184",
    d: "M88.494,47.894l-.974.1c-5.115.425-5.372,3.671-4.5,7.316.093.373.425.429.754.459,0,.228,0,.455,0,.686-.638.388-1.276.772-1.918,1.16.015.377.239.761-.037,1.127-.63-.313-1.746-.172-1.365-1.44,1-1.38.69-2.9.478-4.41-.492-3.544,1.3-6.5,5.178-6.488,1.138,0,1.369-.291,1.28-1.242l.653-.381.448,3.111",
    transform: "translate(219.494 122.287)",
    fill: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1185",
    "data-name": "Path 1185",
    d: "M85.178,43.908c0-.254-.011-.5-.015-.757A26.814,26.814,0,0,0,88.237,42c1.5-.776,2.071-.131,2.444,1.254a48.594,48.594,0,0,1,1.425,7.428c.16,1.466.735,1.526,1.891,1.089,1.324-.5,2.7-.873,4.048-1.306.026.239.049.478.075.713l-8.64,3.3c-.134-.239-.269-.481-.4-.72.41-.194.817-.4,1.235-.575a1.221,1.221,0,0,0,.78-1.727c-.7-1.552.548-3.757-1.615-4.8,0-.339-.007-.675-.007-1.015.977-.839.291-1.694-.131-2.384-.436-.72-1.164-.123-1.75,0-.813.179-1.608.429-2.41.645",
    transform: "translate(232.551 113.783)",
    fill: "#2d2d2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1186",
    "data-name": "Path 1186",
    d: "M90.277,46.021c-.392,0-.78,0-1.171.007-.664-3.04-.668-3.055,2.085-4.238,1.242-.533,2.511-1.015,3.775-1.5.44-.164.94-.228,1.119.358.142.47-.254.672-.619.824a13.356,13.356,0,0,1-3.048,1.205c-2.179.287-2.552,1.507-2.141,3.339",
    transform: "translate(242.315 109.719)",
    fill: "#2d2d2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1187",
    "data-name": "Path 1187",
    d: "M86.655,39.587c1.063-.19,1.88.164,1.175,1.257-1,1.544-2.112,2.973-2.071,5-1.582-2.317-1.276-3.891.936-6.3l-.041.045",
    transform: "translate(231.469 107.964)",
    fill: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1188",
    "data-name": "Path 1188",
    d: "M88.824,47.643l-.653.381c-.3-.862-.888-.705-1.548-.489-2.112.7-4.234,1.369-6.35,2.048-.06-.25-.119-.5-.175-.75a19.8,19.8,0,0,1,5.118-1.679c1.891-.455,3.011-1.287,2.526-3.41.235,0,.47,0,.705-.007q.185,1.953.377,3.906",
    transform: "translate(218.72 119.431)",
    fill: "#2d2d2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1189",
    "data-name": "Path 1189",
    d: "M83.7,50.9c-.235,0-.47,0-.7,0a50.187,50.187,0,0,1-1.16-9.782c.209,0,.418,0,.63,0L83.7,50.9",
    transform: "translate(223.459 112.271)",
    fill: "#4f4f4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1190",
    "data-name": "Path 1190",
    d: "M90.552,46.429l-.067-.839a48.093,48.093,0,0,1,7.846-3.126l.1.839a73,73,0,0,1-7.879,3.126",
    transform: "translate(247.083 115.952)",
    fill: "#4f4f4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1191",
    "data-name": "Path 1191",
    d: "M88.724,40.293c.772-1.47,2.126-2.537,2.6-4.283.183-.657,1.8-.067,2.753-.239l.09,1.067c-.41.011-.88-.179-1.164.317-1.332,1.175-2.123,3.093-4.283,3.137",
    transform: "translate(242.275 97.461)",
    fill: "#2d2d2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1192",
    "data-name": "Path 1192",
    d: "M84.84,43.811c.78.045,2.037-.69,1.47,1.246-.239.813.407,1.888.649,2.843.1.4.817.69.388,1.138-.5.511-.892-.1-1.313-.332a3.5,3.5,0,0,0-.72-.213q-.235-2.339-.474-4.682",
    transform: "translate(231.669 119.357)",
    fill: "#2d2d2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1193",
    "data-name": "Path 1193",
    d: "M90.293,35.986a.635.635,0,0,1,.672-.414,2.634,2.634,0,0,1,.373,1.932c-.216.007-.429.019-.642.026l-.4-1.545",
    transform: "translate(246.559 97.135)",
    fill: "#2d2d2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1194",
    "data-name": "Path 1194",
    d: "M89.872,36.336c.284-.5.75-.306,1.164-.317-.011,1.485-.8.116-1.164.317",
    transform: "translate(245.41 98.281)",
    fill: "#4f4f4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1195",
    "data-name": "Path 1195",
    d: "M84.613,46.777c-.037.015-.332-.153-.339-.354-.019-.556.474-.657.892-.795.351-.116.668-.056.664.339-.007.593-.582.545-1.216.81",
    transform: "translate(230.12 124.452)",
    fill: "#2d2d2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1196",
    "data-name": "Path 1196",
    d: "M93.658,43.926c-.317.369-.664.649-1.186.4-.481-.668.071-.832.515-1,.571-.22.78.034.672.6",
    transform: "translate(251.999 118.081)",
    fill: "#2d2d2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1197",
    "data-name": "Path 1197",
    d: "M84.906,46.679a.674.674,0,0,1-.787.373c.071-.53.164-1.011.787-.373",
    transform: "translate(229.7 126.632)",
    fill: "#dadada"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1198",
    "data-name": "Path 1198",
    d: "M88.687,44.887c-.022-.239-.048-.474-.071-.713l.545-.2.731.381c-.28.455-.776.422-1.205.533",
    transform: "translate(241.98 120.075)",
    fill: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1199",
    "data-name": "Path 1199",
    d: "M90.4,36.115c.213-.007.429-.019.642-.026.056.321-.119.489-.4.451-.1-.011-.16-.276-.239-.425",
    transform: "translate(246.851 98.547)",
    fill: "#4f4f4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1200",
    "data-name": "Path 1200",
    d: "M84.86,45.508l1.041.168c-.369.086-.866.959-1.041-.168",
    transform: "translate(231.724 124.267)",
    fill: "#2d2d2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1201",
    "data-name": "Path 1201",
    d: "M83.826,46.609c.056-.433.306-.556.709-.448-.078.4-.373.455-.709.448",
    transform: "translate(228.9 125.949)",
    fill: "#dadada"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1202",
    "data-name": "Path 1202",
    d: "M87.8,36.617a.652.652,0,0,1,.339.672c-.492-.034-.369-.377-.339-.672",
    transform: "translate(239.649 99.988)",
    fill: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1203",
    "data-name": "Path 1203",
    d: "M84.139,46.238c.1-.09.2-.183.3-.272-.1.09-.2.183-.3.272",
    transform: "translate(229.755 125.517)",
    fill: "#dadada"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1204",
    "data-name": "Path 1204",
    d: "M44.339,61.538c1.28-.2,2.22-1.1,3.354-1.612.552-.246.325-.716.291-1.127h2.123c-.041.4-.757.862.157,1.157.586.187,1.145.455,1.716.686a1.029,1.029,0,0,0-.634.948c-1.03.034-1.959-.727-3.029-.4-2.168,1.048-3.984,4.074-3.622,6.04a2.285,2.285,0,0,1-2.522.552c-1.574-.511-3.07-1.265-4.809-2,2.332-1.813,4.969-2.518,6.976-4.238",
    transform: "translate(102.026 160.563)",
    fill: "#2d2d2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1205",
    "data-name": "Path 1205",
    d: "M45.007,69.123c-.377.056-.343.78-.869.567-1.634-.668-2.216-.358-2.608,1.485a46.655,46.655,0,0,0-.765,8.853c-.011.642-.108,1.28-.168,1.918-.963-.34-.489-1.164-.6-1.787s.351-1.459-.668-1.731a16.615,16.615,0,0,1,.806-7.48c1.2-2.828,3.712-4.9,6.357-6.57a1.417,1.417,0,0,1,2.063.3c-3.746,1.078-3.746,1.078-2.667,2.69-.254.6-.88,1.022-.88,1.753",
    transform: "translate(107.167 174.944)",
    fill: "#4f4f4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1206",
    "data-name": "Path 1206",
    d: "M40.883,75.21c-.03-.418-.056-.832-.086-1.25.533-.082,1.03-.216,1.123-.865q1.393-.979,2.791-1.955l.351-.239-.213-.235c-.892-.485-1.634.586-2.533.295.019-.884.824-.955,1.254-1.38s.5-.836-.19-.925c-1.515-.2-.81-.713-.205-1.209a4.462,4.462,0,0,1,.963-.642c.466-.216.985-.948,1.47-.187.373.593,0,1.086-.642,1.354a3.138,3.138,0,0,0-.586.433c1.7,1.134,2.048,3.932.724,5.07-1.6.112-2.6,1.671-4.219,1.735",
    transform: "translate(111.403 180.989)",
    fill: "#dadada"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1207",
    "data-name": "Path 1207",
    d: "M53.189,53.032c-1.362,1.272-3.208,1.254-4.839,1.809-.343.116-.619.119-.757-.295A2.519,2.519,0,0,1,49.38,51.7a11.972,11.972,0,0,1,2.988-.765c1.548.2.343,1.474.821,2.093",
    transform: "translate(129.762 139.096)",
    fill: "#4f4f4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1208",
    "data-name": "Path 1208",
    d: "M50.316,52.528c-.037-.69.011-1.2.5-1.373a30.717,30.717,0,0,1,4.01-1.276,1.174,1.174,0,0,1,1.265.959,1.115,1.115,0,0,1-.862,1.134c-1.205.418-2.417.828-3.581,1.343s-1.384-.019-1.328-.787",
    transform: "translate(137.369 136.165)",
    fill: "#4f4f4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1209",
    "data-name": "Path 1209",
    d: "M41.361,66.275c.272-.276.545-.556.821-.832a1.656,1.656,0,0,1,1.7-.589c.593.22.272.9.31,1.373.235,2.824.224,2.824-2.694,3.831-.075-.235-.153-.47-.228-.705.246-.69.933-.933,1.414-1.388.407-.1.914-.2.731-.75-.1-.295-.515-.168-.795-.045-.392-.011-.787-.026-1.179-.041-.026-.284-.056-.571-.086-.854",
    transform: "translate(112.708 176.897)",
    fill: "#dadada"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1210",
    "data-name": "Path 1210",
    d: "M41.174,69.944c1.615-.063,2.619-1.623,4.219-1.735.265.254.533.5.8.757a10.189,10.189,0,0,0-3.857,2.451c-.459.436-1.153,1.056-.045,1.619a1.072,1.072,0,0,1-1.078,1.078c-.131-1.392-1.082-2.772-.037-4.171",
    transform: "translate(111.111 186.255)",
    fill: "#2d2d2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1211",
    "data-name": "Path 1211",
    d: "M34.487,70.47c-.392.22-.783.44-1.171.66-.276-1.257,1.425-1.776,1.134-3.04h.907c.69.444,1.746.325,1.813,1.641.116,2.3-.015,3.141-1.4,4.115.709-1.287.082-2.3.347-3.4.25-1.048-.571-.336-.948-.306-.287-.011-.571-.019-.683.332",
    transform: "translate(90.889 185.93)",
    fill: "#2d2d2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1212",
    "data-name": "Path 1212",
    d: "M46.337,69.154c-.1,1.709-3.335,4.783-4.708,4.563a.834.834,0,0,1-.552-.455.869.869,0,0,1,.448-1.153,21.283,21.283,0,0,1,2.112-.989,10.4,10.4,0,0,0,2.7-1.966",
    transform: "translate(111.97 188.836)",
    fill: "#dadada"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1213",
    "data-name": "Path 1213",
    d: "M34.965,73.31c-.116-.287-.172-.772-.354-.824-.511-.153-1.373.433-1.362-.69a1.627,1.627,0,0,1,1.19-1.753c.131.4-.075.944.448,1.171.366.16.6-.049.727-.384.183-.489.377-1.059,1.033-.854.571.179.623.772.578,1.291-.052.582.287,1.343-.608,1.6-.548.16-1.1.295-1.653.44",
    transform: "translate(90.792 190.959)",
    fill: "#2d2d2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1214",
    "data-name": "Path 1214",
    d: "M42.8,66.286c.075.235.153.47.228.705a2.981,2.981,0,0,0-1.2,2.958A6.3,6.3,0,0,1,41.6,72.8c-.179.526-.366,1.179.541,1.317-.093.653-.589.787-1.123.869l-.056-.119.093-.093c-.112-.2-.224-.4-.339-.6.746-2.72.142-5.525.507-8.271l1.578.381",
    transform: "translate(111.181 179.964)",
    fill: "#4f4f4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1215",
    "data-name": "Path 1215",
    d: "M46.782,66.866a6.013,6.013,0,0,1-3.54-1.063,1.3,1.3,0,0,1-.5-2c.511-.649,1.164-.164,1.7.22a5.92,5.92,0,0,1,2.332,2.839",
    transform: "translate(115.946 173.366)",
    fill: "#4f4f4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1216",
    "data-name": "Path 1216",
    d: "M41.557,72.482c-1.112-.563-.418-1.183.045-1.619a10.189,10.189,0,0,1,3.857-2.451c.653.851.563,1.4-.5,1.918a35.5,35.5,0,0,0-3.406,2.153",
    transform: "translate(111.844 186.81)",
    fill: "#dadada"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1217",
    "data-name": "Path 1217",
    d: "M43.884,66.119c1.056-.007,1.515.519,1.477,1.567a6.45,6.45,0,0,0,.343,2.9,2.535,2.535,0,0,1-1.906-.407c-.078-.455-.384-.548-.78-.5L43,69.667c.015-.4.026-.791.037-1.19.459-.157,1.045.7,1.309.026.2-.5-.754-.284-.944-.724a2.663,2.663,0,0,0,.485-1.66",
    transform: "translate(117.407 180.548)",
    fill: "#2d2d2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1218",
    "data-name": "Path 1218",
    d: "M45.747,64.237c-.134.317.19,1.3-.552,1-1.056-.429-2.347-.892-2.608-2.287-.127-.683.261-1.194,1.011-.963,1.071.325,2.41.478,2.149,2.246",
    transform: "translate(116.227 169.123)",
    fill: "#4f4f4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1219",
    "data-name": "Path 1219",
    d: "M42.281,59.117A13.425,13.425,0,0,0,45.7,62.228c.47.347.69.851.272,1.321-.489.548-.914.078-1.3-.261-1.115-.992-2.5-1.806-2.4-4.171",
    transform: "translate(115.44 161.428)",
    fill: "#4f4f4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1220",
    "data-name": "Path 1220",
    d: "M43.637,64.433c1.209.03,2.164.459,2.32,1.821a.794.794,0,0,1-.813.9c-.787.06-2.671-1.354-2.66-2.007.015-.8.634-.66,1.153-.716",
    transform: "translate(116.009 175.944)",
    fill: "#4f4f4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1221",
    "data-name": "Path 1221",
    d: "M45.347,67.011a2.663,2.663,0,0,1-.485,1.66c-.5-.149-1-.287-1.485-.451a1.311,1.311,0,0,1-.769-1.914c.381-.97,1.086-.313,1.619-.063a7.849,7.849,0,0,1,1.119.769",
    transform: "translate(115.944 179.656)",
    fill: "#4f4f4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1222",
    "data-name": "Path 1222",
    d: "M34.125,73.356c-.1-.66-1.373-1.179-.246-1.992.776.455,2.011-1.033,2.332.209.336,1.313-1.142,1.448-2.085,1.783",
    transform: "translate(91.247 194.054)",
    fill: "#4f4f4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1223",
    "data-name": "Path 1223",
    d: "M35.925,75.4c-.354-.261-.7-.727-1.06-.746-2.182-.1-.91-1.134-.571-1.925l.9-.28c.164,1,1.578,1.7.735,2.951",
    transform: "translate(91.798 197.825)",
    fill: "#4f4f4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1224",
    "data-name": "Path 1224",
    d: "M44.049,67.481c.533.116,1.451-.187,1.261.694-.123.571-.869,1-1.336,1.5-.463-.545-1.25-1.059-1.3-1.642-.056-.668.873-.455,1.377-.552",
    transform: "translate(116.518 184.267)",
    fill: "#2d2d2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1225",
    "data-name": "Path 1225",
    d: "M45.717,66.7a.641.641,0,0,1-.955.5c-.869-.362-1.992-.53-2.328-1.515-.179-.533.616-.567,1.015-.474A3.408,3.408,0,0,1,45.717,66.7",
    transform: "translate(115.802 177.949)",
    fill: "#4f4f4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1226",
    "data-name": "Path 1226",
    d: "M49.641,53.682c-.478-.619.727-1.9-.821-2.093.34-1.127,1.011-1.179,1.373-.168.239.668.634,1.765-.552,2.261",
    transform: "translate(133.311 138.447)",
    fill: "#dadada"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1227",
    "data-name": "Path 1227",
    d: "M44.669,62.966c-.127,0-.254.007-.381,0-1.071-.037-1.261-.933-1.567-1.671a.49.49,0,0,1,.4-.713c.817-.056,1.209.578,1.627,1.134l-.078,1.246",
    transform: "translate(116.536 165.429)",
    fill: "#4f4f4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1228",
    "data-name": "Path 1228",
    d: "M43.211,62.133l.078-1.246c.3.112.6.213.9.343.481.213.936.474.918,1.1a.711.711,0,0,1-.507.742,1.071,1.071,0,0,1-1.388-.94",
    transform: "translate(117.994 166.261)",
    fill: "#2d2d2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1229",
    "data-name": "Path 1229",
    d: "M42.736,62.962a2.648,2.648,0,0,1,2.436,1.216.523.523,0,0,1-.478.7c-1.078-.112-1.515-1.011-1.959-1.914",
    transform: "translate(116.697 171.928)",
    fill: "#4f4f4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1230",
    "data-name": "Path 1230",
    d: "M45.278,62.992a3.09,3.09,0,0,1-2.641-1.268c-.034-.049.175-.373.284-.381,1.22-.093,1.615,1.041,2.358,1.649",
    transform: "translate(116.416 167.492)",
    fill: "#4f4f4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1231",
    "data-name": "Path 1231",
    d: "M54.219,48.982a5.61,5.61,0,0,0-.515,3.007c-1.074-.761-.813-2.3.515-3.007",
    transform: "translate(144.826 133.753)",
    fill: "#dadada"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1232",
    "data-name": "Path 1232",
    d: "M44.453,67.041c-.011.4-.022.791-.037,1.186-.709.179-1.4.235-1.821-.522a.674.674,0,0,1,.086-.873c.638-.507,1.175.179,1.772.209",
    transform: "translate(115.988 181.987)",
    fill: "#4f4f4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1233",
    "data-name": "Path 1233",
    d: "M34.5,69.139H33.6a2.949,2.949,0,0,1,2.638-1.433c-.351.94-1.3.877-1.731,1.433",
    transform: "translate(91.742 184.882)",
    fill: "#dadada"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1234",
    "data-name": "Path 1234",
    d: "M34.734,73.429c-.3.093-.6.187-.9.276a.407.407,0,0,1-.015-.377c.172-.489.045-1.38.791-1.224.6.123.269.847.119,1.324",
    transform: "translate(92.254 196.842)",
    fill: "#dadada"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1235",
    "data-name": "Path 1235",
    d: "M46.08,52.628c-.007.4-.015.791-.019,1.186-.418-.138-1.119.522-1.246-.187-.142-.795.578-.989,1.265-1",
    transform: "translate(122.326 143.709)",
    fill: "#4f4f4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1236",
    "data-name": "Path 1236",
    d: "M41.93,65.182c.03.284.06.571.086.854-.026.459-.332.851-.672.474-.608-.675-.131-1.108.586-1.328",
    transform: "translate(112.138 177.99)",
    fill: "#2d2d2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1237",
    "data-name": "Path 1237",
    d: "M36.458,71.467a1.158,1.158,0,0,1,.19,1.589c-.716-.451-.705-.989-.19-1.589",
    transform: "translate(98.547 195.152)",
    fill: "#2d2d2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1238",
    "data-name": "Path 1238",
    d: "M42.785,58.629l.19.239c-.112.086-.224.175-.336.265-.045-.1-.134-.205-.119-.291s.149-.127.265-.213",
    transform: "translate(116.104 160.096)",
    fill: "#2d2d2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1239",
    "data-name": "Path 1239",
    d: "M41.637,65.524c.28-.123.7-.254.795.041.183.556-.325.653-.731.754-.022-.265-.041-.53-.063-.795",
    transform: "translate(113.696 178.547)",
    fill: "#2d2d2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1240",
    "data-name": "Path 1240",
    d: "M38.449,72.339c-.03-.228-.056-.455-.082-.683l.519-.09c.123.149.242.3.362.451-.183.31-.492.313-.8.321",
    transform: "translate(104.767 195.425)",
    fill: "#4f4f4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1241",
    "data-name": "Path 1241",
    d: "M43,67.082c.4-.049.705.041.78.5-.317-.071-.7-.041-.78-.5",
    transform: "translate(117.421 183.145)",
    fill: "#4f4f4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1242",
    "data-name": "Path 1242",
    d: "M33.607,68.974c.112-.351.4-.343.683-.332-.03.265-.056.526-.086.791l-.6-.459",
    transform: "translate(91.769 187.427)",
    fill: "#dadada"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1243",
    "data-name": "Path 1243",
    d: "M41.987,67.456c.071.078.142.157.213.231l-.354.243c.048-.157.093-.317.142-.474",
    transform: "translate(114.264 184.199)",
    fill: "#4f4f4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1244",
    "data-name": "Path 1244",
    d: "M40.909,54.652c-.175.1-.351.209-.522.313a.443.443,0,0,1,.522-.313",
    transform: "translate(110.283 149.21)",
    fill: "#4f4f4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1245",
    "data-name": "Path 1245",
    d: "M27.948,79.977c-.478.877-1.8,1.13-1.724,2.436.052.918.175,1.373,1.22.757,2.227-1.313,4.6-2.406,6.723-3.861.985-.675,2.052-.787,2.985-1.38.116.149.231.3.347.451a18.457,18.457,0,0,1-3.346,2.671A53.226,53.226,0,0,0,27.3,85.136c-.53.362-1.063.907-1.753.571-.657-.321-.373-1.041-.388-1.586-.06-2.246-.47-2.686-2.679-2.906a6.326,6.326,0,0,1-1.272-.414c.034-1.63,1.694-1.735,2.485-2.652,3.783-2.25,6.961-5.3,10.431-7.961,2-1.537,3.984-1.153,6.051-.866,1.056.146.731.944.216,1.392a3.871,3.871,0,0,1-1.425.474c-1.668-.97-4.2-.575-5.1.873a3.67,3.67,0,0,1-1.276,1.149,32.194,32.194,0,0,0-5.029,4.473c-.88.007-1.268.824-1.936,1.183a.734.734,0,0,0-.25,1.153c.328.444.713.119.959-.157.612-.679,1.142-.843,1.612.116",
    transform: "translate(57.909 188.574)",
    fill: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1246",
    "data-name": "Path 1246",
    d: "M22.911,76.513A32.194,32.194,0,0,1,27.94,72.04a3.67,3.67,0,0,0,1.276-1.149c.9-1.447,3.428-1.843,5.1-.873a38.713,38.713,0,0,1-7.219,5.939c-1.011.675-1.944,1.474-2.91,2.212-.015-.866-.787-1.153-1.272-1.656",
    transform: "translate(62.562 189.744)",
    fill: "#2d2d2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1247",
    "data-name": "Path 1247",
    d: "M19.494,78.75a5.761,5.761,0,0,1-.213-5.033c.254.362.492.254.769.011.224-.2.295-.918.589-.567.239.28.828.795.7.948-1.153,1.35-.228,3.511-1.843,4.641",
    transform: "translate(51.359 199.519)",
    fill: "#4f4f4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1248",
    "data-name": "Path 1248",
    d: "M25.71,69.831a8.8,8.8,0,0,1,.086-.88c.172-.851.052-2.138,1.28-2.026,1.418.131.608,1.4.683,2.19a2.468,2.468,0,0,1-.1.963c-.239.754.075,2.168-.873,2.082-.985-.09-.921-1.5-1.074-2.328",
    transform: "translate(70.205 182.73)",
    fill: "#2d2d2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1249",
    "data-name": "Path 1249",
    d: "M23.873,75.181c-.791.918-2.451,1.022-2.485,2.652l-.142-.007a27.26,27.26,0,0,1,.407-7.45c1.72-.754,1.421.5,1.44,1.444-1.048-.325-1.22.31-1.164,1.108.06.832-.291,1.813.716,2.317.093.049.425-.384.645-.593.194.175.388.354.582.53",
    transform: "translate(57.727 191.543)",
    fill: "#dadada"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1250",
    "data-name": "Path 1250",
    d: "M26.67,69.286c-.093.735-.187,1.5-.284,2.264-.049.392-.108.854-.593.839-.41-.015-.6-.418-.735-.8a4.235,4.235,0,0,1-.127-2.462c.16-.653.16-1.619,1.134-1.477.851.123.548,1,.6,1.634",
    transform: "translate(67.738 184.697)",
    fill: "#2d2d2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1251",
    "data-name": "Path 1251",
    d: "M23.846,68.461c.522.3,1.571-.455,1.63.675s.339,2.451-.511,3.358c-.612.649-1.071-.06-1.1-.679-.06-1.127.015-2.261.034-3.387Z",
    transform: "translate(65.093 186.851)",
    fill: "#2d2d2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1252",
    "data-name": "Path 1252",
    d: "M22,72.425c.369-.955-.116-2.735,1.276-2.574,1.164.134.16,1.634.224,2.526a.687.687,0,0,1-.026.19c-.153.578,0,1.548-.836,1.474s-.388-1.06-.638-1.615",
    transform: "translate(60.072 190.71)",
    fill: "#4f4f4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1253",
    "data-name": "Path 1253",
    d: "M26.05,74.507c-.317.8.276,2.414-.806,2.365-1.052-.045-.519-1.608-.5-2.481.015-.649-.313-1.888.627-1.865.907.022.537,1.224.675,1.981",
    transform: "translate(67.156 198.043)",
    fill: "#4f4f4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1254",
    "data-name": "Path 1254",
    d: "M23.7,73.732a3.985,3.985,0,0,1-.616-3.992c.071-.25.228-.537.522-.44a.913.913,0,0,1,.485.507,5.22,5.22,0,0,1-.392,3.925",
    transform: "translate(62.311 189.182)",
    fill: "#4f4f4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1255",
    "data-name": "Path 1255",
    d: "M24.642,71.37c.485.5,1.257.791,1.272,1.656a.962.962,0,0,1-.888.638c-.47-.959-1-.795-1.608-.116-.25.276-.634.6-.963.157a.734.734,0,0,1,.25-1.153c.668-.358,1.056-1.175,1.936-1.183",
    transform: "translate(60.831 194.887)",
    fill: "#4f4f4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1256",
    "data-name": "Path 1256",
    d: "M24.3,75.218c-.06.761.347,1.686-.586,1.906-.754.175-.645-.657-.623-1.108.045-.9-.354-2.279.675-2.485.783-.157.123,1.209.533,1.686",
    transform: "translate(62.945 200.757)",
    fill: "#2d2d2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1257",
    "data-name": "Path 1257",
    d: "M22.725,73.489c-.22.209-.552.642-.645.6-1.007-.507-.66-1.489-.716-2.317-.056-.8.116-1.436,1.164-1.112a5.7,5.7,0,0,1,.2,2.832",
    transform: "translate(58.297 192.704)",
    fill: "#4f4f4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1258",
    "data-name": "Path 1258",
    d: "M23.022,70.065c-.146.5.19,1.321-.634,1.41-.776.086-1.033-.649-.858-1.205.205-.645-.343-1.862.828-1.843.776.011.563,1.011.664,1.638",
    transform: "translate(58.646 186.85)",
    fill: "#2d2d2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1259",
    "data-name": "Path 1259",
    d: "M27.88,66c.056.705-.231,1.089-.839,1.13-.843.06-1.123-.463-1.1-1.216.022-.653.116-1.544.787-1.556.933-.015.791,1.115,1.153,1.642",
    transform: "translate(70.83 175.745)",
    fill: "#4f4f4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1260",
    "data-name": "Path 1260",
    d: "M23.792,69.182c-.127.534.056,1.347-.783,1.306-.754-.037-.761-.795-.735-1.358.022-.526-.153-1.343.72-1.309.787.034.589.862.8,1.362",
    transform: "translate(60.801 185.192)",
    fill: "#2d2d2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1261",
    "data-name": "Path 1261",
    d: "M24.273,65.939c.325.164.776.242.944.5a1.839,1.839,0,0,1-.041,2.138.45.45,0,0,1-.653.179c-.645-.474-.313-1.153-.3-1.753,0-.369.056-.735.086-1.1l-.034.034",
    transform: "translate(65.878 179.964)",
    fill: "#2d2d2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1262",
    "data-name": "Path 1262",
    d: "M23.739,70.072c-.839-1.28-.862-2.279-.16-3.234.172-.235.5-.078.616.168.507,1.037.164,1.951-.455,3.067",
    transform: "translate(63.021 182.195)",
    fill: "#4f4f4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1263",
    "data-name": "Path 1263",
    d: "M26.477,66.631c-.145.653.063,1.574-.8,1.537-.713-.026-.575-.873-.548-1.418.026-.575-.242-1.481.713-1.444.787.03.436.907.634,1.324",
    transform: "translate(68.546 178.327)",
    fill: "#4f4f4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1264",
    "data-name": "Path 1264",
    d: "M18.869,78.622a5.16,5.16,0,0,1,.511-3.5c1.142,1.358-.235,2.35-.511,3.5",
    transform: "translate(51.263 205.135)",
    fill: "#4f4f4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1265",
    "data-name": "Path 1265",
    d: "M24.44,69.753c-1.168-.119-.832-.746-.4-1.313.269-.351.739-.739,1.145-.313.578.612-.291.787-.5,1.168-.093.168-.2.328-.295.492l.049-.034",
    transform: "translate(64.552 185.521)",
    fill: "#4f4f4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1266",
    "data-name": "Path 1266",
    d: "M26.929,78.28c.254-2.667.8-5.189,3.335-6.715.481-.291,1.089-.8,1.533-.153.369.541-.194.907-.664,1.179a2.136,2.136,0,0,0-.936,1.418c-1.843,1.239.25,1.6.526,2.365-.071.187-.142.377-.213.567a16.837,16.837,0,0,0-1.955,1.582c-.746.806-1.168.373-1.627-.242",
    transform: "translate(73.534 194.147)",
    fill: "#dadada"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1267",
    "data-name": "Path 1267",
    d: "M28.762,81.086a2.585,2.585,0,0,1-1.511-.134q-.168-2.076-.332-4.156c.082-1.809,1.988-2.115,2.817-3.339.4-.586.63.183.735.593-1.7,1.392-.362,2.615.209,3.884.414,1.414-1.783,1.392-1.507,2.731-.138.138-.272.28-.41.422",
    transform: "translate(73.507 200.004)",
    fill: "#dadada"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1268",
    "data-name": "Path 1268",
    d: "M30.847,75.631c-.1-.414-.339-1.179-.735-.6-.828,1.227-2.735,1.53-2.817,3.343-.347-.112-.619-.41-.474-.705.582-1.179-.119-2.514.511-3.667.459.616.88,1.048,1.627.242a16.2,16.2,0,0,1,1.959-1.582c.123.142.224.336.384.418.533.265,1.466-.78,1.686.463.164.914-.589,1.13-1.25,1.414a4.735,4.735,0,0,0-.892.672",
    transform: "translate(73.13 198.423)",
    fill: "#4f4f4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1269",
    "data-name": "Path 1269",
    d: "M28.881,74.413c-.276-.765-2.369-1.127-.526-2.362a3.325,3.325,0,0,0,.933-.071c.593-.22,1.138-.328,1.406.4a1.18,1.18,0,0,1-.586,1.6,9.768,9.768,0,0,1-1.227.437",
    transform: "translate(75.376 196.104)",
    fill: "#4f4f4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1270",
    "data-name": "Path 1270",
    d: "M97.851,67.227c.686.1,1.369.213,2.335.362-.783-1.127-2.011-.9-2.716-1.563.455-1.429-1.526-1.3-1.548-2.421,3.563,1.309,6.864,3.384,10.759,3.749a7.974,7.974,0,0,0-3.335-2.294c-2.071-.918-4.193-1.724-6.26-2.645-.533-.239-1.429-.582-1.007-1.362.291-.537,1.078-.239,1.608.015,2.388,1.142,4.764,2.309,7.148,3.458.6.291,1.13.944,1.97.463-.284-.955-1.164-1.179-1.888-1.5-2.119-.951-4.238-1.929-6.428-2.69-1.276-.444-2.067-1.765-3.525-1.776a.673.673,0,0,1-.3-.119l.146-1.235c.783.321,1.526.567,1.5-.746-.022-.929.668-.7,1.2-.735l-.03-.034a6.667,6.667,0,0,0,4.2,2c-.619-1.037-1.694-1.018-2.272-1.668.03-.269.063-.537.1-.81a23.194,23.194,0,0,1,4.548,1.683c.418.157,1.082.44,1.332-.235.19-.522-.332-.787-.727-1a28.978,28.978,0,0,0-5.283-2.47,10.483,10.483,0,0,1-3.111-1.586c-.362-.261-.851-.586-.548-1.086.216-.354.724-.194,1.086-.063a4.613,4.613,0,0,1,1.041.5,31.387,31.387,0,0,0,6.607,3.123c.649.239,1.354.433,1.235-.716.489.392,1.317.94.739,1.489-1.731,1.634-.063,1.641.851,2.056l-.026-.026c.183,1.877-1.548.8-2.582,1.6,2.033.757,1.988,3.007,3.63,3.966a.872.872,0,0,1,.381,1.179c-.63,1.433.455,1.459,1.339,1.653l-.067,1.052c-.772.015-1.959-.414-1.186,1.179.4.824-.082,1.033-.8,1.03-.366,0-.836-.2-1.015.269s.265.653.571.873c.448.321,1.239.56.839,1.272-.388.686-.992.16-1.53-.022-2.138-.739-4.574-.015-6.6-1.343-.373-.242-.787-.422-1.183-.627.31-1.112-1.227-1.224-1.186-2.19m5.066-8.48c-.3-.444-.56-.78-1.239-.485.313.425.556.791,1.239.485",
    transform: "translate(258.498 138.601)",
    fill: "#4f4f4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1271",
    "data-name": "Path 1271",
    d: "M106.4,57.866c.116,1.149-.586.955-1.235.716a31.387,31.387,0,0,1-6.607-3.123,4.613,4.613,0,0,0-1.041-.5c-.362-.131-.869-.291-1.086.063-.3.5.187.824.548,1.086a10.484,10.484,0,0,0,3.111,1.586,28.978,28.978,0,0,1,5.283,2.47c.4.216.918.481.724,1-.246.675-.91.392-1.328.235a23.139,23.139,0,0,0-4.551-1.683c-1-.963-2.417-1.145-3.552-1.865A2.8,2.8,0,0,1,95,54.96c0-1.455-.4-2.906-.537-4.369-.06-.619-.325-1.582.959-1.25,1.761,1.489,4.01,2.048,5.969,3.149,1.328.746,2.861,1.239,3.861,2.447-.1.175-.2.351-.295.526-2.35-1.108-4.689-2.235-7.055-3.309-.705-.317-1.727-1.384-2.153-.548-.519,1.018.918,1.317,1.675,1.656a87.771,87.771,0,0,1,8.23,3.85l-.045-.03.437.436L106,57.474l.436.436Z",
    transform: "translate(257.771 134.55)",
    fill: "#dadada"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1272",
    "data-name": "Path 1272",
    d: "M96.75,57.647c.022,1.123,2,.992,1.548,2.417-2.708-.653-3.059-.276-2.4,2.466a9.313,9.313,0,0,1,.317,2.5,1.983,1.983,0,0,0,2.108,2.347c-.019.548-.116,1.142.7,1.209.228.6.955.287,1.283.709l-.582.6c-1.4-.131-3.119-1.06-3.309,1.586-.765-.731-.261-1.548-.631-2.156-.511-5.451-1.268-10.882-1.418-16.366.377,0,.754-.011,1.13-.019a.678.678,0,0,0,.3.123c.16,1.559-.664,3.328.959,4.585",
    transform: "translate(257.67 144.558)",
    fill: "#2d2d2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1273",
    "data-name": "Path 1273",
    d: "M100.6,54.136c1.063,1.6,3.436,1.6,4.149,3.746q-3.794-1.875-7.584-3.753A5.468,5.468,0,0,1,94.2,48.111c.306-1.72,1.548.131,2.112-.571L96.26,47.5c-.131.72.414.485.757.53a4.315,4.315,0,0,0,2.4,1.459l-.037-.026c.742.955,2.429.839,2.94,2.813-1.854-.9-3.317-1.653-4.82-2.317-.735-.325-1.638-1.194-2.25-.619-.5.47.291,1.425.6,2.141,1.466.992,2.869,2.115,4.73,2.294l-.019-.015c-.03.045-.1.1-.086.134a1.1,1.1,0,0,0,.127.246",
    transform: "translate(256.977 129.308)",
    fill: "#dadada"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1274",
    "data-name": "Path 1274",
    d: "M97.542,48.389a2.676,2.676,0,0,1,.608,1.959c-3.414-.7-4.458-1.862-4.592-5.066-.022-.478.041-.933.705-.888.213.239.619.474.739.187.224-.533-.351-.608-.713-.761-.239-.216-.481-.433-.724-.649,1.362-.3,2.2.94,3.391,1.138a1.231,1.231,0,0,0,.052.328c-.436.3-1.093-.242-1.537.369.563.384,1.071.735,1.578,1.082.1.291.2.582.3.873-1.06.134-1.836-1.212-3.164-.616.9,1.239,2.209,1.518,3.358,2.044",
    transform: "translate(255.464 117.752)",
    fill: "#dadada"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1275",
    "data-name": "Path 1275",
    d: "M101.387,50.215c.459,1.306,2.2,1.149,2.72,2.384-1.787.515-2.958-1.235-4.6-1.254l.037.026a3.049,3.049,0,0,0-2.421-1.41c.011-.515-.317-.6-.731-.578l.052.045c-.388-.742-1.272-.78-1.824-1.283-.638-.582-.929-1.127.228-1.44l-.03-.041a.554.554,0,0,0,.828.414l-.045-.03c-.041.362.187.325.418.28,1.444,1.6,3.432,2.2,5.368,2.888",
    transform: "translate(256.846 127.421)",
    fill: "#dadada"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1276",
    "data-name": "Path 1276",
    d: "M101.019,49.131c1.171.3,1.037.892.358,1.6-2.794-.63-4.824-2.7-7.316-3.895l.09-.94c.683.343,1.369.683,2.052,1.022,1.582.791,2.895,2.16,4.816,2.209",
    transform: "translate(256.848 125.337)",
    fill: "#4f4f4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1277",
    "data-name": "Path 1277",
    d: "M93.434,41.272c.187-.985-1.026-2.123-.078-2.85.6-.466,1.459.541,2.212.858,1.392.586,1.007,1.742.884,2.809a1.688,1.688,0,0,1-.138.358l-2.88-1.175",
    transform: "translate(253.923 104.586)",
    fill: "#4f4f4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1278",
    "data-name": "Path 1278",
    d: "M96.282,40.78c.134,1,.269,2,.4,3-1.205.026-2.011-1.093-3.2-1.127-.224-.451-.705-.9-.011-1.362l.175-.015c-.052-.071-.1-.138-.157-.205a1.853,1.853,0,0,1-.228-1.772q1.511.739,3.014,1.485",
    transform: "translate(254.269 107.301)",
    fill: "#4f4f4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1279",
    "data-name": "Path 1279",
    d: "M101.53,50.024c-1.921-.049-3.234-1.418-4.816-2.209-.683-.339-1.369-.679-2.052-1.022.034-.414-1.694-.638-.134-1.22,1.694.955,3.443,1.832,5.062,2.895.75.492.78-.4,1.22-.358a2.763,2.763,0,0,1,.72,1.914",
    transform: "translate(256.337 124.444)",
    fill: "#dadada"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1280",
    "data-name": "Path 1280",
    d: "M94.274,46.151c2.492,1.2,4.522,3.268,7.316,3.9.108.272.22.548.328.824a3.469,3.469,0,0,1-1.985-.526c-1.265-.575-2.332-1.541-3.727-1.843a.226.226,0,0,0-.392-.06l.045.03c-.086-.519-.254-.873-.828-.414l.03.041c.351-.642-.243-.638-.563-.795-.6-.295-.675-.668-.224-1.156",
    transform: "translate(256.632 126.022)",
    fill: "#dadada"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1281",
    "data-name": "Path 1281",
    d: "M94.054,44.739c-.675-.436-.511-.843.052-1.227.746-.026,1.168,1.018,2.261.567-.91-.963-1.761-1.683-3.082-1.574l-.045-1.414c.246.045.492.086.735.127l-.041-.026a5.76,5.76,0,0,0,2.649,1.444,3.812,3.812,0,0,1,.377,3.014c-1-.213-1.839-.921-2.906-.91",
    transform: "translate(254.609 112.203)",
    fill: "#4f4f4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1282",
    "data-name": "Path 1282",
    d: "M100.33,48.615c-.437-.037-.47.847-1.216.358-1.623-1.067-3.369-1.944-5.066-2.895.034-.231.067-.459.1-.69,1.362.2,2.466,1.19,3.872,1.254a.981.981,0,0,1,.795.907q.14.985,1.074.642c.149.142.295.284.444.425",
    transform: "translate(256.813 123.939)",
    fill: "#4f4f4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1283",
    "data-name": "Path 1283",
    d: "M93.454,41.8c-.354-.511-.582-1.018.06-1.489l3.115,1.835c.06.157.116.313.179.47-1.406.907-2.2-.709-3.354-.817",
    transform: "translate(254.246 110.073)",
    fill: "#dadada"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1284",
    "data-name": "Path 1284",
    d: "M97.537,53.367c-.53.034-1.22-.194-1.2.735.03,1.313-.716,1.067-1.5.746.172-1.015-.724-2.145.336-3.059.653.724,1.981.444,2.358,1.578",
    transform: "translate(258.464 141.418)",
    fill: "#dadada"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1285",
    "data-name": "Path 1285",
    d: "M98.449,47.529c-1.4-.067-2.511-1.052-3.869-1.254-.153-.4-.832-.429-.664-1.212,1.742.444,3.574.578,4.533,2.466",
    transform: "translate(256.381 123.052)",
    fill: "#dadada"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1286",
    "data-name": "Path 1286",
    d: "M97.152,53.954c-.377-1.134-1.7-.854-2.358-1.578.265-.265.53-.533.795-.8,1.134.72,2.548.9,3.552,1.865-.03.269-.063.541-.1.81-.649-.056-1.2-.705-1.921-.328Z",
    transform: "translate(258.85 140.831)",
    fill: "#2d2d2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1287",
    "data-name": "Path 1287",
    d: "M97.024,45.341c-1.19-.2-2.033-1.44-3.391-1.138a2.09,2.09,0,0,1,.071-1.459c1.186.179,1.921,1.406,3.2,1.362a1.427,1.427,0,0,1,.123,1.235",
    transform: "translate(255.4 116.719)",
    fill: "#4f4f4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1288",
    "data-name": "Path 1288",
    d: "M97.193,44.861c-1.276.045-2.015-1.183-3.2-1.362a.893.893,0,0,1-.556-1.018c1.373-.142,2.276.933,3.443,1.321.1.354.209.705.31,1.06",
    transform: "translate(255.108 115.964)",
    fill: "#dadada"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1289",
    "data-name": "Path 1289",
    d: "M97.081,46.143c-1.149-.526-2.455-.806-3.358-2.044,1.328-.6,2.1.75,3.164.616.522.414.392.918.194,1.429",
    transform: "translate(255.925 119.998)",
    fill: "#4f4f4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1290",
    "data-name": "Path 1290",
    d: "M93.376,40.709c1.157.108,1.947,1.724,3.354.817a2.947,2.947,0,0,1,.175,1.623c-.921-.235-1.675-.955-2.686-.921l.045.03c-.157-.593-.63-.653-1.127-.679.078-.291.16-.582.239-.869",
    transform: "translate(254.325 111.162)",
    fill: "#2d2d2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1291",
    "data-name": "Path 1291",
    d: "M93.261,41.475c1.317-.1,2.168.612,3.074,1.574-1.089.455-1.507-.593-2.257-.567-.216-.381-.918-.366-.817-1.007",
    transform: "translate(254.637 113.227)",
    fill: "#dadada"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1292",
    "data-name": "Path 1292",
    d: "M96.871,44.668c-1.168-.388-2.074-1.462-3.443-1.321.019-.4.041-.8.06-1.2l3.1,1.444c.425.272.354.672.284,1.074",
    transform: "translate(255.12 115.097)",
    fill: "#4f4f4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1293",
    "data-name": "Path 1293",
    d: "M96.3,41.32q-1.505-.744-3.014-1.485l-.179-.739,2.88,1.175c.078.358.724.545.313,1.048",
    transform: "translate(254.249 106.76)",
    fill: "#dadada"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1294",
    "data-name": "Path 1294",
    d: "M96.331,42.462,93.22,40.627c0-.146,0-.291,0-.433,1.186.034,1.988,1.153,3.2,1.127.384.41.276.783-.082,1.142",
    transform: "translate(254.541 109.756)",
    fill: "#2d2d2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1295",
    "data-name": "Path 1295",
    d: "M96.547,43.82l-3.1-1.444a.561.561,0,0,1,.056-.31c1.067-.007,1.906.7,2.906.91a.809.809,0,0,1,.138.843",
    transform: "translate(255.164 114.87)",
    fill: "#dadada"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1296",
    "data-name": "Path 1296",
    d: "M94.593,37.273c-1.03-.213-1.731-.455-1.988-1.295a.644.644,0,0,1,.2-.455,2.158,2.158,0,0,1,1.787,1.75",
    transform: "translate(252.855 97.001)",
    fill: "#4f4f4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1297",
    "data-name": "Path 1297",
    d: "M93.427,41.117c1.011-.03,1.765.686,2.686.921l-.034.526a5.814,5.814,0,0,1-2.652-1.447",
    transform: "translate(255.117 112.273)",
    fill: "#dadada"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1298",
    "data-name": "Path 1298",
    d: "M95.58,38.685a3.423,3.423,0,0,1-2.6-1.149,2.831,2.831,0,0,1,2.6,1.149",
    transform: "translate(253.896 102.449)",
    fill: "#4f4f4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1299",
    "data-name": "Path 1299",
    d: "M95.646,44.976l-1.578-1.082c.448-.612,1.1-.063,1.537-.366.015.481.026.966.041,1.448",
    transform: "translate(256.867 118.86)",
    fill: "#4f4f4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1300",
    "data-name": "Path 1300",
    d: "M94.725,38.124a2.07,2.07,0,0,1-.373-.078c-.478-.209-1.224.2-1.425-.608a.509.509,0,0,1,.205-.448c.578-.138.88.414,1.332.6a2.427,2.427,0,0,1,.459.332c-.067.063-.134.131-.2.2",
    transform: "translate(253.737 100.947)",
    fill: "#4f4f4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1301",
    "data-name": "Path 1301",
    d: "M96.4,46.609c-.623.231-.981.015-1.074-.642.224.056.444.112.668.172.134.157.272.313.407.47",
    transform: "translate(260.3 125.52)",
    fill: "#dadada"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1302",
    "data-name": "Path 1302",
    d: "M93.136,40.942c.5.026.97.09,1.127.679-.246-.041-.489-.086-.735-.127-.131-.183-.261-.369-.392-.552",
    transform: "translate(254.322 111.799)",
    fill: "#dadada"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1303",
    "data-name": "Path 1303",
    d: "M93.774,43.308c.358.153.933.228.713.761-.123.287-.526.052-.742-.187.011-.19.019-.384.03-.575",
    transform: "translate(255.983 118.259)",
    fill: "#4f4f4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1304",
    "data-name": "Path 1304",
    d: "M93.825,37.444l.142.22c-.078-.045-.157-.086-.231-.127Z",
    transform: "translate(255.958 102.247)",
    fill: "#4f4f4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1305",
    "data-name": "Path 1305",
    d: "M93.231,39.77l.157.205c-.06.007-.119.011-.175.015a.863.863,0,0,0,.019-.22",
    transform: "translate(254.53 108.598)",
    fill: "#2d2d2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1306",
    "data-name": "Path 1306",
    d: "M93.923,37.69c-.086-.067-.172-.131-.257-.2.194-.228.265-.041.347.108l-.09.09",
    transform: "translate(255.77 102.09)",
    fill: "#4f4f4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1307",
    "data-name": "Path 1307",
    d: "M93.6,37.225c.075.09.231.231.216.257-.16.239-.287.067-.41-.06.063-.067.127-.134.194-.2",
    transform: "translate(255.06 101.649)",
    fill: "#4f4f4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1308",
    "data-name": "Path 1308",
    d: "M98.8,61.91a23.554,23.554,0,0,1,1.854-5.555c.6.425,1.884-.06,1.776,1.272-.075.963-.213,1.862-1.537,2.044-1.186.16-.866,1.97-2.093,2.238",
    transform: "translate(269.778 153.886)",
    fill: "#dadada"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1309",
    "data-name": "Path 1309",
    d: "M100.105,55.281c-.119.325-.343.533-.69.459-.071-.015-.075-.325-.108-.5.265.011.533.026.8.037",
    transform: "translate(271.173 150.852)",
    fill: "#2d2d2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1310",
    "data-name": "Path 1310",
    d: "M63.4,47.08c.034.578.007,1.216-.627,1.254-.735.049-.645-.657-.634-1.142s-.093-1.171.616-1.212c.791-.045.507.713.645,1.1",
    transform: "translate(169.654 125.549)",
    fill: "#dadada"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1311",
    "data-name": "Path 1311",
    d: "M60.78,49.079c-.567-.791-1.03-1.373-.418-2.16a.474.474,0,0,1,.806-.03c.552.769.1,1.377-.388,2.19",
    transform: "translate(164.037 127.463)",
    fill: "#4f4f4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1312",
    "data-name": "Path 1312",
    d: "M22.365,79.507c-.272,1.556-.582,3.1-.806,4.667-.149,1.045-.448,1.865-1.694,1.88-.007-.418.123-1.134-.556-.843-.5.216-.2.888.052,1.336a11.888,11.888,0,0,1-6.141,5.07c0-1.675.007-3.35-.022-5.025-.019-.8-.1-1.8.94-1.746.843.049.4,1.045.522,1.63.172.832-.63,2.022.836,2.406.295.056.41-.086.4-.366a12.968,12.968,0,0,0,.086-4.827c-.093-1.153-.022-1.832,1.552-1.985,1.638-.157,1.157.817,1.41,1.563.209.608-.541,1.75.78,1.768,1.183.019,1.436-.843,1.444-1.858.007-1.235.052-2.47.134-3.7.03-.47-.164-1.261.533-1.254s.3.858.53,1.28",
    transform: "translate(36.016 213.611)",
    fill: "#dadada"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1313",
    "data-name": "Path 1313",
    d: "M19.234,77.989c-.6.78-1.041,1.257-1.85,1.246-.078,0-.246-.321-.213-.455.213-.966.981-.776,2.063-.791",
    transform: "translate(46.877 212.946)",
    fill: "#dadada"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1314",
    "data-name": "Path 1314",
    d: "M15.657,79.367c-.116.037-.3.164-.425.119a.435.435,0,0,1-.31-.586.485.485,0,0,1,.44-.168.425.425,0,0,1,.295.634",
    transform: "translate(40.646 214.97)",
    fill: "#2d2d2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1315",
    "data-name": "Path 1315",
    d: "M17,79.2c-.067-.287-.142-.575-.19-.865-.007-.026.213-.142.257-.112.381.265.187.634-.067.977",
    transform: "translate(45.899 213.577)",
    fill: "#2d2d2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1316",
    "data-name": "Path 1316",
    d: "M14.206,80.985c.011.28-.1.422-.4.366.134-.119.265-.243.4-.366",
    transform: "translate(37.702 221.142)",
    fill: "#2d2d2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1317",
    "data-name": "Path 1317",
    d: "M79.738,43.21c.81,2.406-1.623,2.641-2.66,3.671-1.007,1-2.593,1.4-3.88,2.134-1.447.828-1.888-.093-2.093-1.209a14.7,14.7,0,0,1-.056-2.5c.478-.7,1.093-1.157,1.947-.731a3.34,3.34,0,0,0,4.272-.959c.81-.9,1.776.429,2.47-.4",
    transform: "translate(193.939 117.992)",
    fill: "#4f4f4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1318",
    "data-name": "Path 1318",
    d: "M82.758,42.931c-1.429,1.433-3.473,1.324-5.189,2.033-.828.343-1.668,1.384-2.738.429a5.219,5.219,0,0,1,.052-2.69c1.306.011,2.7-.7,3.843.694.187.224,1.183-.194,1.8-.347a2.956,2.956,0,0,1,2.235-.119",
    transform: "translate(203.902 116.141)",
    fill: "#4f4f4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1319",
    "data-name": "Path 1319",
    d: "M72.275,44.98c.28,1.295-1.5.742-1.559,1.735-1.559-.228-1.119,1.16-1.436,2.16-1.339-1.265-.69-2.712-.959-3.936,1.324-.645,2.634.407,3.954.041",
    transform: "translate(186.561 122.127)",
    fill: "#2d2d2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1320",
    "data-name": "Path 1320",
    d: "M76.371,42.432c.433-.761,1.321.056,1.727-.727a.485.485,0,0,1,.9.127c.194.5-.231.6-.619.75-.69.272-1.347.489-2.011-.149",
    transform: "translate(208.543 113.17)",
    fill: "#4f4f4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1321",
    "data-name": "Path 1321",
    d: "M78.315,43.367c-.589-.037-.918.474-1.4.66-.205-.783-.082-1.671.638-1.888.634-.187.724.66.761,1.227",
    transform: "translate(209.788 114.996)",
    fill: "#4f4f4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1322",
    "data-name": "Path 1322",
    d: "M31.987,77.188c-.075.824-.145,1.209-.134,1.593.015.657-.134,1.194-.9,1.2-.787,0-.649-.653-.683-1.134-.112-1.8-.228-3.6-.295-5.4-.011-.381-.284-1.018.4-1.078.519-.049.731.444.851.9a16.879,16.879,0,0,1,.757,3.921",
    transform: "translate(81.683 197.604)",
    fill: "#dadada"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1323",
    "data-name": "Path 1323",
    d: "M31.6,74.341c.019.321.045.642.056.963.022.795-.336,1.615-1.086,1.548-.929-.082-.451-1.056-.392-1.582A8.657,8.657,0,0,1,31.7,70.957c.269-.358.422-1.115,1.1-.727.634.362.1.892,0,1.35a1.281,1.281,0,0,0-1,1.134.278.278,0,0,0-.116.261c-.571.422-.418.888-.082,1.365",
    transform: "translate(81.925 191.479)",
    fill: "#dadada"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1324",
    "data-name": "Path 1324",
    d: "M30.482,71.647a1.289,1.289,0,0,1,1-1.134c1.205.933.2,2.223.783,3.537-1.287-.586-1.03-1.854-1.787-2.4",
    transform: "translate(83.236 192.547)",
    fill: "#4f4f4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1325",
    "data-name": "Path 1325",
    d: "M30.649,72.252c-.336-.478-.489-.944.082-1.365.384.481.526.944-.082,1.365",
    transform: "translate(82.875 193.568)",
    fill: "#4f4f4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1326",
    "data-name": "Path 1326",
    d: "M83.748,40.523c-.287-.694-1.183-1.216-.492-2.007.149-.175,1.8-1.433,1.28.563a2.182,2.182,0,0,1-.787,1.444",
    transform: "translate(226.646 103.667)",
    fill: "#4f4f4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1327",
    "data-name": "Path 1327",
    d: "M106.566,48.47a1.733,1.733,0,0,1,.295-.1c.03-.007.075.078.112.119a2.149,2.149,0,0,1-.295.108c-.03,0-.075-.078-.112-.123",
    transform: "translate(290.995 132.068)",
    fill: "#4f4f4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1328",
    "data-name": "Path 1328",
    d: "M41.906,55.173c.552-.138.836.205.522.575-.5.589-.623,1.448-1.358,1.847-.522-.205-.787-.481-.205-.918a2.065,2.065,0,0,0,1.041-1.5",
    transform: "translate(110.689 150.573)",
    fill: "#2d2d2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1329",
    "data-name": "Path 1329",
    d: "M7.05,95.411c.425.123,1.164-.235,1.078.642a.975.975,0,0,1-1.06.9A1.019,1.019,0,0,1,6,96.045c-.119-.907.649-.5,1.052-.634",
    transform: "translate(16.345 260.535)",
    fill: "#dadada"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1330",
    "data-name": "Path 1330",
    d: "M99.856,57.112c-.91-.414-2.582-.422-.851-2.056.578-.548-.25-1.1-.739-1.489l.034.045-.436-.436.049.045-.437-.436.049.03c-.72-1.5,1.429-.959,1.4-1.966,1.134.653,2.753.589,3.264,2.182-.75.194-1.724-.5-2.253.422-.265.466.071.966.612,1.2.328.362.657.72.959,1.052-.455.735-2-.078-1.645,1.41",
    transform: "translate(265.902 138.848)",
    fill: "#dadada"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1331",
    "data-name": "Path 1331",
    d: "M100.224,50.5a.225.225,0,0,0,.224.2c-1.489.981-2.35-.75-3.6-.828-.145.022-.291.041-.436.063l.019.015c.246-.746-.854-.582-.806-1.194,1.712.1,2.929,1.518,4.6,1.746",
    transform: "translate(261.123 133.13)",
    fill: "#dadada"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1332",
    "data-name": "Path 1332",
    d: "M97.646,49.747c1.6.082,1.462,1.832,2.421,2.529-1.209,1.194-1.377-.44-1.955-.795-.537-.325-1.511-.847-.466-1.735",
    transform: "translate(265.373 135.842)",
    fill: "#dadada"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1333",
    "data-name": "Path 1333",
    d: "M95.9,49.116c.146-.022.291-.041.44-.063l-.4.444a1.268,1.268,0,0,1-.131-.243c-.007-.037.056-.093.09-.138",
    transform: "translate(261.635 133.947)",
    fill: "#2d2d2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1334",
    "data-name": "Path 1334",
    d: "M15.083,81.484c-.254-.451-.56-1.123-.056-1.336.683-.291.552.425.56.843l-.5.492",
    transform: "translate(40.295 218.673)",
    fill: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1335",
    "data-name": "Path 1335",
    d: "M102.693,60.921c-.888-.194-1.97-.22-1.339-1.649a.875.875,0,0,0-.384-1.183c-1.638-.955-1.6-3.208-3.626-3.962,1.033-.8,2.761.269,2.582-1.608,1.414.4,2.421,1.037,1.951,2.794-.209.78.567,1.071,1.018,1.5.683.645,1.783.851,2.052,1.936a2.776,2.776,0,0,0-2.253,2.171",
    transform: "translate(265.81 143.414)",
    fill: "#dadada"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1336",
    "data-name": "Path 1336",
    d: "M56.286,48.029c.235-.358.612-.623.884-.213.172.25-.287.47-.586.586-.1-.123-.2-.25-.3-.373",
    transform: "translate(153.698 130.002)",
    fill: "#2d2d2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1337",
    "data-name": "Path 1337",
    d: "M103.657,53.013c-1.668-.228-2.884-1.645-4.6-1.746l.022.037c-.119-.451-.269-.235-.414-.019-1.268-.093-1.959-2.007-3.537-1.119-.31-.716-1.1-1.671-.6-2.141.612-.575,1.515.295,2.25.619,1.5.664,2.97,1.418,4.82,2.317-.511-1.974-2.2-1.858-2.94-2.813,1.641.015,2.813,1.768,4.6,1.25.724,1.142.511,2.384.392,3.615",
    transform: "translate(257.691 130.617)",
    fill: "#4f4f4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1338",
    "data-name": "Path 1338",
    d: "M94.613,46.782c1.4.3,2.466,1.272,3.727,1.843a3.441,3.441,0,0,0,1.985.526c.272.41.067.612-.317.739-1.936-.69-3.925-1.283-5.368-2.888a.132.132,0,0,1-.026-.22",
    transform: "translate(258.225 127.746)",
    fill: "#4f4f4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1339",
    "data-name": "Path 1339",
    d: "M75.4,45.906q1-.179,1.988-.362c.007.511.011,1.022.019,1.53-.959.709-1.8,1.5-1.612,2.835.179,1.261-.608,1.813-1.5,2.414s-1.261.3-1.481-.589c-.2-.806-.4-1.612-.608-2.417a6.671,6.671,0,0,0,2.858-1.735A7.132,7.132,0,0,0,71.9,48.7c-1.41.112-2.645,1.127-4.178.9.19-1.276,1.7-.888,2.044-1.839A20.522,20.522,0,0,0,75.4,45.906",
    transform: "translate(184.917 124.365)",
    fill: "#2d2d2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1340",
    "data-name": "Path 1340",
    d: "M57.766,47.7l.071-.127-.086.116Z",
    transform: "translate(157.698 129.911)",
    fill: "#4f4f4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1341",
    "data-name": "Path 1341",
    d: "M54.2,48.967l.153.09-.157-.086,0,0",
    transform: "translate(147.988 133.712)",
    fill: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1342",
    "data-name": "Path 1342",
    d: "M59.75,51.709a.754.754,0,0,1,.339.149c-.116,1.186-.235,2.376-.351,3.567-.078.011-.157.026-.231.037-.067-.444-.131-.888-.2-1.332l-.026-.034c.213-.787.019-1.649.466-2.388",
    transform: "translate(161.884 141.199)",
    fill: "#4f4f4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1343",
    "data-name": "Path 1343",
    d: "M65.3,53.786c.011.257.019.515.037.772.075,1.1.03,2.3-1.436,2.182-1.447-.112-.724-1.384-.75-2.156-.03-.959.153-1.925.213-2.891.034-.556.119-1.052.783-1.134.828-.1.94.515,1.011,1.1.082.7.112,1.414.168,2.123Z",
    transform: "translate(172.006 138.026)",
    fill: "#dadada"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1344",
    "data-name": "Path 1344",
    d: "M61.512,56.516c-.261.112-.522.22-.783.332-.295-1.638-1.1-3.313.459-5.077.571,1.712.093,3.261.325,4.745",
    transform: "translate(164.544 141.369)",
    fill: "#dadada"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1345",
    "data-name": "Path 1345",
    d: "M50.845,58.38c.026-1.112-.093-2.261.824-3.137-.366,1.022.955,2.488-.824,3.137",
    transform: "translate(138.84 150.85)",
    fill: "#4f4f4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1346",
    "data-name": "Path 1346",
    d: "M51.665,55.664c-.9.34-.72-.343-.66-.765.063-.463.269-.892.754-.246-.03.336-.063.675-.093,1.011",
    transform: "translate(139.125 148.343)",
    fill: "#f7f7f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1347",
    "data-name": "Path 1347",
    d: "M51.373,55.012c-.634-.645-.071-.709.4-.817.436.548.093.716-.4.817",
    transform: "translate(139.509 147.988)",
    fill: "#f7f7f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1348",
    "data-name": "Path 1348",
    d: "M112.059,45.239c.045,1.052-.519,1.1-.892,1.265-4.107,1.753-8.11,3.91-12.382,5.092a90.606,90.606,0,0,0-9.953,3.19c-1.112.451-1.873,1.4-3,1.757-.437.142-.948.8-1.309.082-.28-.556.433-.713.772-.929a28.58,28.58,0,0,1,9.129-3.738,56.7,56.7,0,0,0,11.046-4.216,44.873,44.873,0,0,1,6.585-2.5",
    transform: "translate(230.639 123.532)",
    fill: "#4f4f4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1349",
    "data-name": "Path 1349",
    d: "M94.807,51.6a2.719,2.719,0,0,1-3.246,2.712c-1.675-.287-1.474-2.238-1.406-3.134.1-1.448,1.847-1.824,3.171-1.873,1.641-.06,1.324,1.4,1.481,2.294",
    transform: "translate(246.06 134.623)",
    fill: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1350",
    "data-name": "Path 1350",
    d: "M96.378,48.422c-1.291,2.078-3.593,2.071-5.5,2.805-.254.1-.492-.075-.586-.362-.414-1.291.492-2.186.97-3.208.444-.955,1.082-.433,1.772-.34a16.55,16.55,0,0,1,3.343,1.1",
    transform: "translate(246.272 128.59)",
    fill: "#4f4f4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1351",
    "data-name": "Path 1351",
    d: "M88.433,50.591c1.929-.063,2.037.94,1.988,2.071a2.784,2.784,0,0,1-3.014,2.57c-1.738-.216-1.205-2.074-1.283-2.888-.127-1.317,1.429-1.716,2.309-1.753",
    transform: "translate(235.123 138.139)",
    fill: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1352",
    "data-name": "Path 1352",
    d: "M94.09,49.754c-2.153.907-4.081,2.231-6.57,2.029.049-.948.929-1.332,1.369-2,1.828-2.805,2.649-2.817,5.2-.03",
    transform: "translate(238.987 130.175)",
    fill: "#4f4f4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1353",
    "data-name": "Path 1353",
    d: "M90.144,50.244c-.078.907-.9,1.063-1.444,1.421-.91.589-2.2,1.477-2.955.761s.261-1.966.7-2.914c.254-.541.5-1.406,1.321-1.086a3.914,3.914,0,0,1,2.376,1.817",
    transform: "translate(233.394 132.047)",
    fill: "#2d2d2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1354",
    "data-name": "Path 1354",
    d: "M69.8,59.038c-.026-2.141.679-2.876,2.82-2.817,1.317.034,1.414,1.291,1.515,2.19.19,1.716-1.063,2.7-3.141,2.727-1.91.03-.81-1.5-1.194-2.1",
    transform: "translate(190.588 153.512)",
    fill: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1355",
    "data-name": "Path 1355",
    d: "M77.582,57.2c-.019,1.686-1.115,2.638-3.268,2.559-1.683-.063-1.175-1.686-1.179-2.541-.007-2.5,2.279-1.5,3.5-1.8,1.567-.392.72,1.175.948,1.783",
    transform: "translate(199.52 151.143)",
    fill: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1356",
    "data-name": "Path 1356",
    d: "M78.8,49.281l1.287-.228c1.093.974,2.417,1.735,3.145,3.055.668,1.212,1.489-.384,2.145.2,0,.321,0,.645-.007.966-1.332.007-2.291.992-3.492,1.339,0-.384.007-.765.007-1.149.668-.716.071-1.086-.392-1.526-.914-.873-1.8-1.772-2.694-2.66",
    transform: "translate(215.17 133.947)",
    fill: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1357",
    "data-name": "Path 1357",
    d: "M85.5,51.506a6.593,6.593,0,0,1-4.022-1.888c-.276-.22-.515-.526-.28-.795a.9.9,0,0,1,.854-.145c1.168.727,2.6,1.145,3.447,2.828",
    transform: "translate(221.465 132.774)",
    fill: "#4f4f4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1358",
    "data-name": "Path 1358",
    d: "M81.3,49.577c0-.228,0-.459,0-.686.918-.444,1.832-.9,2.757-1.321.377-.172.892-.556,1.115.1.194.575-.4.713-.795.873a9.438,9.438,0,0,1-3.074,1.03",
    transform: "translate(221.981 129.166)",
    fill: "#4f4f4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1359",
    "data-name": "Path 1359",
    d: "M81.187,50.419a4.97,4.97,0,0,1,3.835-.653,10.006,10.006,0,0,1-3.835,1.287v-.634",
    transform: "translate(221.694 135.46)",
    fill: "#4f4f4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1360",
    "data-name": "Path 1360",
    d: "M82.9,49.825v.634c-.824.09-1.429.907-2.339.709,0-.325,0-.645.007-.966.776-.123,1.556-.25,2.332-.377",
    transform: "translate(219.982 136.055)",
    fill: "#2d2d2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1361",
    "data-name": "Path 1361",
    d: "M80.768,49.35c.276-.366.052-.75.041-1.127.284.321.97.354.918.847s-.638.145-.959.28",
    transform: "translate(220.55 131.68)",
    fill: "#4f4f4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1362",
    "data-name": "Path 1362",
    d: "M70.327,54.215c0-.511-.011-1.018-.015-1.53,5.727-2.071,11.446-4.145,17.355-5.678a31.325,31.325,0,0,0,4.906-2.194A15.916,15.916,0,0,0,96.408,43.5c.616-.3,1.552-1.19,2.186.131-.657,1.1-2.015.869-2.9,1.537a8.7,8.7,0,0,0-3.149,1.578,2.482,2.482,0,0,0-1.515.16c-2.447,1.4-5.189,1.918-7.857,2.667-1.295.362-2.369.921-1.951,2.682.257,1.086-.739,1.865-1.134,2.8-.179.429-.668.291-1.041.194-.515-.134-.619-.507-.675-1.022-.254-2.44-.276-2.44-2.671-1.586a32.406,32.406,0,0,1-5.376,1.574",
    transform: "translate(191.998 117.224)",
    fill: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1363",
    "data-name": "Path 1363",
    d: "M83.506,53.781c-.187-.153-.284-.22-.369-.306-.489-.478.53-1.936-.8-1.66-1.149.239-2.962.205-2.794,2.265.1,1.224.254,2.444.358,3.667.03.31.03.679-.381.783s-.593-.205-.705-.5a11.8,11.8,0,0,1-.627-6.1c.25-1.492,1.824-1.679,3.044-2.056.735-.228,1.716-.239,1.265-1.4-.459-1.179-1.175-.187-1.757-.075-2.97.575-4.148,2.287-3.708,5.35.22,1.518.045,3.1.366,4.641.1.459.06,1.048-.481,1.115-.586.075-.589-.53-.672-.974-.533-2.843-.142-5.7-.168-8.551-.007-.694.492-.981,1.082-1.2,1.4-.522,2.753-1.175,4.178-1.582a1.9,1.9,0,0,0,1.4-1.586c1.6,2.708,2.141,5.312.772,8.166",
    transform: "translate(207.433 124.559)",
    fill: "#2d2d2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1364",
    "data-name": "Path 1364",
    d: "M78.124,48.242c-.765-1.026,1.5-1.38.545-2.447,1.854-.6.78-2.313,1.287-3.421.209,0,.418,0,.627,0,.332,1.712,1.134,1.944,2.783,1.317,1.858-.705,3.38-2.089,5.372-2.451.034.257.067.519.108.776l-2.41,1.925c-1.056.019-2.246-.272-2.682,1.175-.351-.041-.724-.209-1.022.127-.019.019.03.134.075.16.414.228.686-.007.936-.3a13.537,13.537,0,0,0,1.4-.5c.907-.429.929.149.948.769-.231.052-.459.1-.69.153-.742-.1-1.362.026-1.634.836-1.787.918-3.522,1.97-5.641,1.888m2.011-1.7c1-.287,1.75.019,1.936-1.082a1.915,1.915,0,0,0-1.936,1.082",
    transform: "translate(212.89 112.601)",
    fill: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1365",
    "data-name": "Path 1365",
    d: "M73.294,48.374c.4-.205.78-.44,1.194-.616,3.294-1.377,4.633-.489,4.469,3.13a27.044,27.044,0,0,0-.127,4.432c.052.433.056,1-.571,1.026s-.642-.556-.694-.977c-.235-1.988-.425-3.984-.653-5.973-.056-.492.052-1.142-.522-1.358a1.155,1.155,0,0,0-1.321.6,3.065,3.065,0,0,1-1.6,1l-.1-.1c.063-.392.612-.813-.067-1.164",
    transform: "translate(200.141 128.732)",
    fill: "#2d2d2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1366",
    "data-name": "Path 1366",
    d: "M80.365,45.106a2.636,2.636,0,0,1,2.567-2.8c.877.082,1.179.552,1.112,1.447-.172,2.287-.694,2.839-2.9,2.843-.727,0-.817-.172-.776-1.489",
    transform: "translate(219.427 115.495)",
    fill: "#2d2d2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1367",
    "data-name": "Path 1367",
    d: "M75.891,47.473c.679.351.131.772.067,1.164-1.086.664-2.794.765-2.458,2.712.1,1.485.205,2.966.28,4.451.026.552.377,1.477-.847.955-.146-1.537-.362-3.07-.422-4.611-.134-3.641-1.052-3.2,3.38-4.671",
    transform: "translate(197.543 129.632)",
    fill: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1368",
    "data-name": "Path 1368",
    d: "M76.272,45.107a8.725,8.725,0,0,1,3.149-1.578l.011.754c-.907-.078-1.268.358-1.235,1.239s.026,1.776.037,2.667c-1.179.53-1.854.2-1.91-1.138-.03-.649-.037-1.295-.052-1.944",
    transform: "translate(208.273 118.863)",
    fill: "#4f4f4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1369",
    "data-name": "Path 1369",
    d: "M76.83,47.641c-.015-.888,0-1.78-.041-2.667s.332-1.317,1.235-1.235c.5,1.045.086,2.093,0,3.137-.052.709-.522.94-1.2.765",
    transform: "translate(209.677 119.41)",
    fill: "#2d2d2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1370",
    "data-name": "Path 1370",
    d: "M81.86,43.4c-.019-.619-.045-1.2-.948-.769a14.173,14.173,0,0,1-1.4.5l.011.011c.433-1.444,1.627-1.153,2.682-1.175.425.183.873.466.746.951-.119.459-.6.608-1.093.481",
    transform: "translate(217.123 114.568)",
    fill: "#2d2d2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1371",
    "data-name": "Path 1371",
    d: "M68.85,47.208a7.135,7.135,0,0,1,3.167-1.119,6.681,6.681,0,0,1-2.858,1.738.488.488,0,0,1-.31-.619",
    transform: "translate(187.965 125.853)",
    fill: "#dadada"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1372",
    "data-name": "Path 1372",
    d: "M79.517,43.24c.276-.806.9-.936,1.638-.832a2.538,2.538,0,0,1-1.638.832",
    transform: "translate(217.134 115.716)",
    fill: "#2d2d2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1373",
    "data-name": "Path 1373",
    d: "M80.842,45.1c.06.25.116.5.175.75-.31.377-.377,1.254-1.194.586A1.33,1.33,0,0,1,80.842,45.1",
    transform: "translate(217.972 123.161)",
    fill: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1374",
    "data-name": "Path 1374",
    d: "M80.955,42.212c-.034-.257-.071-.519-.1-.776.328-.231.806-.478.955,0,.179.567-.459.619-.851.772",
    transform: "translate(220.776 112.402)",
    fill: "#2d2d2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1375",
    "data-name": "Path 1375",
    d: "M79.148,41.887c-.209,0-.418,0-.623,0-.1-.284.015-.47.291-.478s.384.2.332.474",
    transform: "translate(214.324 113.085)",
    fill: "#2d2d2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1376",
    "data-name": "Path 1376",
    d: "M68.266,50.59l.015.474c-.134-.06-.269-.123-.4-.187.127-.1.257-.19.388-.287",
    transform: "translate(185.352 138.144)",
    fill: "#2d2d2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1377",
    "data-name": "Path 1377",
    d: "M81.32,62.274c-.9-1.567-1.365-3.731-.612-5,.854-1.444,3.063-1.9,5.126-1.832-.209,1.257-1.119,1.537-1.966,1.7-2.048.4-2.656,1.556-2.123,3.5a8.368,8.368,0,0,1,.134,1.511c-.187.037-.373.078-.56.119",
    transform: "translate(219.356 151.381)",
    fill: "#2d2d2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1378",
    "data-name": "Path 1378",
    d: "M81.84,53.205c.093-.157.187-.313.284-.47.175.317.131.5-.284.47",
    transform: "translate(223.477 144.001)",
    fill: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1379",
    "data-name": "Path 1379",
    d: "M81.632,52.66c.332-.022.545.1.556.463-.358.052-.541-.1-.556-.463",
    transform: "translate(222.909 143.789)",
    fill: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1380",
    "data-name": "Path 1380",
    d: "M96.128,59.683c-.813-.071-.716-.664-.694-1.212,2.029-.306,3.94.522,6.115.757-.627-1.254-1.977-.675-2.63-1.406,0-.541,0-1.082.007-1.623,2.466.433,4.578,2.126,7.2,2.022a.647.647,0,0,1,.459.295c.078.131.022.343.022.519-1.66-.347.16,2.768-2.123,2.037-2.32-.742-4.757-1.119-7.141-1.668-.463-.1-.9-.187-1.216.28",
    transform: "translate(260.556 153.46)",
    fill: "#4f4f4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1381",
    "data-name": "Path 1381",
    d: "M99.858,57.37c0,.541,0,1.082-.007,1.623a18.622,18.622,0,0,1-3.816-1.265c-.589-.328-1.19-.713-.866-1.477.425-.992,1.089-.164,1.6-.041a7.827,7.827,0,0,1,1.537.735c.1.213.142.534.306.612.25.123.436-.108.507-.377l.739.19",
    transform: "translate(259.624 152.286)",
    fill: "#2d2d2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1382",
    "data-name": "Path 1382",
    d: "M96.974,55.414c-.041.966,1.5,1.078,1.186,2.19A2.568,2.568,0,0,1,96.5,57.3c-.75-.28-1.776-.608-1.459-1.645.347-1.138,1.265-.216,1.929-.239",
    transform: "translate(259.375 150.413)",
    fill: "#2d2d2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1383",
    "data-name": "Path 1383",
    d: "M96.756,56.355c-.071.265-.257.5-.511.377-.16-.082-.205-.4-.3-.616a.654.654,0,0,1,.813.239",
    transform: "translate(261.987 153.114)",
    fill: "#4f4f4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1384",
    "data-name": "Path 1384",
    d: "M79.652,50.367c-.037.2.03.578-.347.205.116-.067.231-.138.347-.205",
    transform: "translate(216.555 137.535)",
    fill: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1385",
    "data-name": "Path 1385",
    d: "M74.267,53.29c-.795.194-2.861-.75-2.828-1.365.052-.839.727-.474,1.2-.451.425.709,1.6.75,1.627,1.817",
    transform: "translate(195.075 140.286)",
    fill: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1386",
    "data-name": "Path 1386",
    d: "M42.031,80.353c-.257,0-.511,0-.769,0-.336-.4-.157-.806-.049-1.216q.593-.548,1.19-1.093c.205-.1.578-.183.593-.306.056-.451-.328-.418-.638-.429a2.107,2.107,0,0,0-1.985.216c-.351.19-.769.657-1.127.082-.284-.451.034-.836.369-1.153,1.19-.034,1.862-1.037,2.809-1.526.369-.19.948-.44.507-.974-.313-.377-.862-.235-1.242.03-.888.623-1.742,1.295-2.608,1.947-.552-1.735,1.257-1.97,1.88-2.962.284-.448,1.283-.634.851-1.283-.388-.578-1.078-.037-1.552.246-.869.522-1.694,1.119-2.686,1.783.284-2.339.907-4.219,3.328-4.924.478-.142,1.045-.347.921-1.041-.146-.8-.795-.686-1.377-.7a5.267,5.267,0,0,0-2.914.9l-1.045-.056a6.351,6.351,0,0,1,7.693-1.175,1.867,1.867,0,0,1,.672,1.891c-.175,3.932-.4,7.864-.6,11.793l-1.4.011c-.09-.269-.071-.672-.481-.608-.142.022-.231.358-.343.548",
    transform: "translate(99.644 179.965)",
    fill: "#2d2d2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1387",
    "data-name": "Path 1387",
    d: "M39.173,66.257c-.2-2.19,2.347-4.458,4.667-4.193.179.019.492.134.492.209,0,.228-.052.586-.205.664-1.761.918-1.492,2.552-1.507,4.1a3.686,3.686,0,0,1-.09,1.153,2.46,2.46,0,0,1-2.279,1.574c-1.1.075-.888-1.082-1.052-1.761a7.531,7.531,0,0,1-.026-1.742",
    transform: "translate(106.856 169.416)",
    fill: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1388",
    "data-name": "Path 1388",
    d: "M40.99,69.8l1.4-.007q-.118,3.313-.242,6.622l-.519.09c-1.447-1.791-2.5-.448-3.611.459l-.683-.09c.019-.541.034-1.082.052-1.623l.481-.022a5.716,5.716,0,0,0,2.776-2.317,2.862,2.862,0,0,0-2.459,1.149l-1.007.011c.2-1.309,1.227-1.884,2.22-2.477.683-.407,1.365-.8,1.06-1.783l.537-.011",
    transform: "translate(101.509 190.578)",
    fill: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1389",
    "data-name": "Path 1389",
    d: "M33.783,61.924c.1.142.205.287.31.429-.53.254-1.224.6-1.033,1.194.272.869.9.183,1.406.082.72-.142,1,.422,1.272.951a6.451,6.451,0,0,1,.336,3.234c-.015.619-.224,1-.9.959a.906.906,0,0,1-.925-1.015c-.007-.649.011-1.295-.03-1.94-.026-.407.164-1.045-.44-1.1-.653-.052-.724.683-.8,1.1a13.416,13.416,0,0,0-.022,2.123,1.367,1.367,0,0,1-.6,1.373c-.892-.556-.257-1.559-.63-2.261l-.078-1.6a5.666,5.666,0,0,1,.746-2.63c.272-.257.548-.511.824-.769.187-.045.373-.093.56-.142",
    transform: "translate(86.433 169.093)",
    fill: "#2d2d2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1390",
    "data-name": "Path 1390",
    d: "M36.406,69.492a2.125,2.125,0,0,0,1.074-2.47,13.035,13.035,0,0,1,.127-5.171c.5-2,2.6-2.145,4.678-3.014-1.914,2.772-3.719,5.04-3.813,8.1-.03.951.839,2.223-.75,2.779-.44-.075-.877-.153-1.317-.228",
    transform: "translate(99.412 160.664)",
    fill: "#2d2d2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1391",
    "data-name": "Path 1391",
    d: "M35.692,67.045c-.011-1.641,2.108-3.585,3.708-3.4.272.03.515.112.589.4.1.369-.134.6-.41.776a3.112,3.112,0,0,0-1.3,3.018c.019.839.213,1.988-1.156,2.018s-1.41-1.037-1.433-2.041c0-.257,0-.515,0-.772",
    transform: "translate(97.459 173.762)",
    fill: "#2d2d2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1392",
    "data-name": "Path 1392",
    d: "M32.07,68.739c-.563.339-.892,1.343-1.735.865-.638-.358-.321-1.183-.44-1.8-.567-2.884,1.727-3.858,3.44-5.227-.075.351-.153.7-.228,1.048a1.654,1.654,0,0,0-.507,1.645c-.011.388-.019.78-.03,1.168-.063.384-.123.765-.187,1.149-.1.381-.209.765-.313,1.149",
    transform: "translate(81.394 170.884)",
    fill: "#2d2d2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1393",
    "data-name": "Path 1393",
    d: "M37.682,60.243c-.019.854-2.276.754-.933,2.19.145,1.612-1.052,3.033-.653,4.682-.287.586.358,1.474-.81,1.932-.645-2.723-.09-5.391.116-8.036.06-.739.869-1.231,1.69-1.388.2.205.392.414.589.619",
    transform: "translate(95.529 162.813)",
    fill: "#2d2d2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1394",
    "data-name": "Path 1394",
    d: "M29.56,66.135c.489-.545.8-.373.821.276.049,1.164.011,2.332.022,3.5.015,1.533-1.489.142-1.992.989-.119.194-.407-.761-.366-1.209.093-1.03.287-2.048.44-3.07.4-.071.921.134,1.074-.481",
    transform: "translate(76.57 179.704)",
    fill: "#2d2d2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1395",
    "data-name": "Path 1395",
    d: "M39.36,65.477c-.358-1.966,1.455-4.988,3.626-6.036-.776,2.272-1.328,4.678-3.626,6.036",
    transform: "translate(107.355 162.313)",
    fill: "#4f4f4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1396",
    "data-name": "Path 1396",
    d: "M37.617,66.438c.347.019.694.041,1.045.06-.974,2.231-.944,4.667-1.425,7-.09.44.138,1.231-.645,1.145-.754-.086-.478-.839-.392-1.265.466-2.313.205-4.779,1.418-6.939",
    transform: "translate(98.519 181.419)",
    fill: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1397",
    "data-name": "Path 1397",
    d: "M35.742,60.746c.362-.369.9-.91,1.115-.067a7.249,7.249,0,0,1-.332,4.507c-.175.451-.664.209-1.03.194l.246-4.633",
    transform: "translate(96.927 164.473)",
    fill: "#2d2d2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1398",
    "data-name": "Path 1398",
    d: "M32.074,68.523a2.4,2.4,0,0,1-.638-.425c-.287-.392.119-.586.347-.713,1-.567,2.026-1.1,3.052-1.619a.667.667,0,0,1,.869.183.546.546,0,0,1-.157.832c-1.127.6-2.283,1.153-3.473,1.742",
    transform: "translate(85.572 179.349)",
    fill: "#2d2d2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1399",
    "data-name": "Path 1399",
    d: "M28.059,69.357a9.679,9.679,0,0,1,5.227-2.2c-1.515,1.253-3.074,2.4-5.227,2.2",
    transform: "translate(76.619 183.38)",
    fill: "#4f4f4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1400",
    "data-name": "Path 1400",
    d: "M38.723,64.243a1.176,1.176,0,0,1-.821.616c-.086-.257-.063-.713-.511-.466-.351.194-.153.515.019.772l-.134-.034c-1.134-.623-2.179.25-3.279.194a34.342,34.342,0,0,1,5.865-3.2c-.175.813-1.533,1-1.138,2.115",
    transform: "translate(92.831 169.65)",
    fill: "#4f4f4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1401",
    "data-name": "Path 1401",
    d: "M35.316,65.437c-.4-1.119.963-1.3,1.138-2.115q1.561-.817,3.126-1.63l.134,1.138-4.4,2.608",
    transform: "translate(96.239 168.457)",
    fill: "#2d2d2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1402",
    "data-name": "Path 1402",
    d: "M37.185,70.208c.869-.653,1.724-1.324,2.611-1.947.377-.269.929-.407,1.239-.03.44.534-.138.783-.507.974-.948.489-1.615,1.492-2.809,1.526-.179-.172-.354-.347-.533-.522",
    transform: "translate(101.539 185.685)",
    fill: "#4f4f4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1403",
    "data-name": "Path 1403",
    d: "M34.211,63.293c1.1.056,2.145-.817,3.279-.2-.4.78-1.242,1.026-1.873,1.522-.351.28-.813.541-1.179.112-.332-.388-.858-.851-.228-1.436",
    transform: "translate(92.613 171.682)",
    fill: "#2d2d2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1404",
    "data-name": "Path 1404",
    d: "M29.257,67.877c-.153.616-.675.41-1.074.481a2.577,2.577,0,0,1,2.276-3.186c.116,1.231-1.985,1.287-1.2,2.7",
    transform: "translate(76.873 177.962)",
    fill: "#4f4f4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1405",
    "data-name": "Path 1405",
    d: "M36.387,60.37,36.14,65c-.265.026-.533.048-.8.075-.4-1.645.8-3.07.649-4.682.131-.007.265-.019.4-.026",
    transform: "translate(96.283 164.85)",
    fill: "#dadada"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1406",
    "data-name": "Path 1406",
    d: "M38.044,56.705c.645.1.824.548.75,1.119-.06.492-.09,1.186-.735,1.134-.686-.056-.783-.765-.8-1.35a.785.785,0,0,1,.783-.9",
    transform: "translate(101.744 154.842)",
    fill: "#4f4f4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1407",
    "data-name": "Path 1407",
    d: "M36.791,58.865c-.078.492.369,1.257-.4,1.3-.888.045-.851-.8-.821-1.433.03-.6-.067-1.571.772-1.466s.269,1.078.444,1.6",
    transform: "translate(97.11 156.349)",
    fill: "#4f4f4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1408",
    "data-name": "Path 1408",
    d: "M39.74,69.451c-.1.41-.284.824.048,1.216a10.822,10.822,0,0,1-1.336.989c-.4.213-.7,1.048-1.22.515s.071-1.179.459-1.41c.7-.418,1.115-1.287,2.048-1.309",
    transform: "translate(101.115 189.647)",
    fill: "#4f4f4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1409",
    "data-name": "Path 1409",
    d: "M36.138,61.187c-.2-.205-.392-.414-.589-.619a3.533,3.533,0,0,1,2.835-1.283c-.75.634-1.5,1.268-2.246,1.9",
    transform: "translate(97.072 161.869)",
    fill: "#4f4f4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1410",
    "data-name": "Path 1410",
    d: "M29.631,64.606c-.037.459.269,1.171-.586,1.108-.7-.052-.627-.724-.612-1.212s-.037-1.227.623-1.224c.88.007.5.821.575,1.328",
    transform: "translate(77.615 172.79)",
    fill: "#4f4f4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1411",
    "data-name": "Path 1411",
    d: "M31.533,61.012c.362.086.761.321.586.619-.332.563-.153,1.578-1.089,1.619-.5.022-.384-.582-.358-.94.045-.582.131-1.179.862-1.3",
    transform: "translate(83.67 166.603)",
    fill: "#4f4f4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1412",
    "data-name": "Path 1412",
    d: "M33.886,61.742c-.336.108-.675.22-1.011.332-.381-.5-.884-1-.28-1.638a.813.813,0,0,1,.649-.269c.787.257.664.948.642,1.574",
    transform: "translate(88.241 164.264)",
    fill: "#4f4f4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1413",
    "data-name": "Path 1413",
    d: "M37.315,70.947l1.007-.011c-.108.388-.213.78-.317,1.168l-.481.022c-.541-.31-.455-.731-.209-1.179",
    transform: "translate(101.368 193.702)",
    fill: "#4f4f4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1414",
    "data-name": "Path 1414",
    d: "M36.539,62.829,36.4,61.691l0,.007c.44.075.877.153,1.317.228a2.127,2.127,0,0,1-1.186.9",
    transform: "translate(99.41 168.457)",
    fill: "#4f4f4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1415",
    "data-name": "Path 1415",
    d: "M38.8,70.242l-.537.011-.16.034-.127-.1c.112-.19.2-.522.343-.545.41-.067.392.336.481.6",
    transform: "translate(103.699 190.136)",
    fill: "#4f4f4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1416",
    "data-name": "Path 1416",
    d: "M35.068,63.559c-.172-.257-.369-.578-.022-.772.451-.246.425.209.515.466-.164.1-.328.205-.492.306",
    transform: "translate(95.173 171.256)",
    fill: "#2d2d2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1417",
    "data-name": "Path 1417",
    d: "M38.064,68.962c.306.011.694-.026.638.425-.015.123-.388.205-.6.306-.011-.242-.026-.489-.041-.731",
    transform: "translate(103.94 188.311)",
    fill: "#4f4f4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1418",
    "data-name": "Path 1418",
    d: "M37.216,71.69l.683.09c-.269.306-.522.455-.683-.09",
    transform: "translate(101.624 195.761)",
    fill: "#4f4f4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1419",
    "data-name": "Path 1419",
    d: "M42.532,61.947H40.409c-.168-1.515-.936-3.175,1.2-4.04.985-.4,1.668-.489,1.537.88-.1,1.071.037,2.194-.612,3.16",
    transform: "translate(109.6 157.419)",
    fill: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1420",
    "data-name": "Path 1420",
    d: "M40.723,68.122c.112.2.228.4.339.593-.455,0-.332-.336-.339-.593",
    transform: "translate(111.174 186.018)",
    fill: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1421",
    "data-name": "Path 1421",
    d: "M95.755,57.557c-1.623-1.257-.8-3.026-.959-4.585,1.459.011,2.246,1.332,3.525,1.776,2.19.761,4.309,1.738,6.428,2.686.724.325,1.6.552,1.888,1.507-.839.481-1.365-.172-1.97-.463-2.384-1.149-4.76-2.317-7.148-3.458-.53-.257-1.317-.552-1.608-.015-.422.78.474,1.123,1,1.362,2.07.921,4.193,1.727,6.264,2.645a8,8,0,0,1,3.335,2.294c-3.895-.366-7.2-2.444-10.759-3.749",
    transform: "translate(258.665 144.648)",
    fill: "#dadada"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1422",
    "data-name": "Path 1422",
    d: "M95.418,52.29c.724-.377,1.272.272,1.921.328.578.645,1.656.63,2.276,1.664a6.645,6.645,0,0,1-4.2-1.992",
    transform: "translate(260.554 142.466)",
    fill: "#dadada"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1423",
    "data-name": "Path 1423",
    d: "M97.784,53.335c-.683.306-.925-.06-1.239-.485.679-.295.936.041,1.239.485",
    transform: "translate(263.631 144.013)",
    fill: "#dadada"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1424",
    "data-name": "Path 1424",
    d: "M97.4,51.367l.437.436-.437-.436",
    transform: "translate(265.977 140.266)",
    fill: "#4f4f4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1425",
    "data-name": "Path 1425",
    d: "M97.508,51.472l.436.436-.436-.436",
    transform: "translate(266.261 140.552)",
    fill: "#4f4f4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1426",
    "data-name": "Path 1426",
    d: "M94.574,48.629c1.578-.884,2.268,1.03,3.537,1.119.138.007.276.015.418.019L98.5,49.73c-.049.612,1.052.448.806,1.194-1.862-.179-3.268-1.3-4.734-2.294",
    transform: "translate(258.249 132.155)",
    fill: "#2d2d2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1427",
    "data-name": "Path 1427",
    d: "M94.881,47.583a3.048,3.048,0,0,1,2.421,1.41,4.315,4.315,0,0,1-2.4-1.459l-.026.049",
    transform: "translate(259.087 129.799)",
    fill: "#4f4f4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1428",
    "data-name": "Path 1428",
    d: "M95.428,47.973l.026-.049c-.343-.045-.884.19-.754-.53.41-.022.739.063.727.578",
    transform: "translate(258.54 129.409)",
    fill: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1429",
    "data-name": "Path 1429",
    d: "M94.263,46.818c.575-.459.742-.1.828.41a.55.55,0,0,1-.828-.41",
    transform: "translate(257.4 127.265)",
    fill: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1430",
    "data-name": "Path 1430",
    d: "M94.866,46.89a.132.132,0,0,0,.026.22c-.231.045-.459.082-.414-.28a.223.223,0,0,1,.388.06",
    transform: "translate(257.972 127.637)",
    fill: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1431",
    "data-name": "Path 1431",
    d: "M95.939,48.958c-.138-.007-.28-.011-.418-.019.149-.216.3-.433.418.019",
    transform: "translate(260.835 132.964)",
    fill: "#dadada"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1432",
    "data-name": "Path 1432",
    d: "M78.545,43.453a1.915,1.915,0,0,1,1.936-1.082c-.187,1.1-.933.795-1.936,1.082",
    transform: "translate(214.479 115.685)",
    fill: "#4f4f4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1433",
    "data-name": "Path 1433",
    d: "M80.257,42.319c-.25.291-.522.53-.936.3-.045-.022-.093-.138-.078-.157.3-.336.672-.168,1.026-.131l-.011-.011",
    transform: "translate(216.375 115.384)",
    fill: "#4f4f4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1434",
    "data-name": "Path 1434",
    d: "M34.129,63.967a2.142,2.142,0,0,1-1.772-1.888,1.166,1.166,0,0,1,1.235-1.2c1,.168,1.291,1.153,1.369,2.078a.829.829,0,0,1-.832,1.011",
    transform: "translate(88.337 166.214)",
    fill: "#f7f7f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1435",
    "data-name": "Path 1435",
    d: "M37.358,72.951c.1-.388.213-.78.317-1.168a2.862,2.862,0,0,1,2.459-1.149,5.72,5.72,0,0,1-2.776,2.317",
    transform: "translate(102.012 192.854)",
    fill: "#dadada"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1436",
    "data-name": "Path 1436",
    d: "M33.128,64.844a1.393,1.393,0,0,1-1.212-.4c-.44-.463-.936-.985-.772-1.638.2-.791.977-.642,1.593-.649.381-.007.757.034,1.138.056a5.666,5.666,0,0,0-.746,2.63",
    transform: "translate(84.955 169.714)",
    fill: "#f7f7f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1437",
    "data-name": "Path 1437",
    d: "M30.682,63.616c.4.052.78.172.7.668s-.5.474-.88.478c.06-.381.119-.765.183-1.145",
    transform: "translate(83.282 173.713)",
    fill: "#f7f7f7"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYearContainer);
export default __webpack_public_path__ + "static/media/year-container.aeb03c51af45df293c1d191f1dd071bb.svg";
export { ForwardRef as ReactComponent };